<template>
    <div>
        <a-spin :spinning="spinning">

            <h2 v-if="promoTypeLabel">
                {{ headingPrefix }} {{ promoTypeLabel }} - {{ promo.name }}
            </h2>

            <base-alert v-if="errors.length" type="danger" :id="errorId">
                <b>You have the following error(s):</b>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </base-alert>

            <a-modal title="Mass Assign" :visible="modalVisible" :confirm-loading="confirmLoading" @ok="handleOk"
                @cancel="handleCancel" ok-text="Apply All">
                <fieldset :disabled="viewOnly">
                    <base-input label="Required" v-if="showMassRequired">
                        <a-input v-model="massRequired" placeholder="Enter Required" />
                    </base-input>
                    <base-input label="Discount" v-if="showMassDiscount">
                        <a-input v-model="massDiscount" placeholder="Enter Discount" @keydown="allowWholeNumberKey"
                            @paste="preventNonWholeNumberPaste" @input="sanitizeMassDiscount" />
                    </base-input>
                    <base-input label="Limit" v-if="showMassLimit">
                        <a-input v-model="massLimit" placeholder="Enter Limit" @keydown="allowPositiveIntegerKey"
                            @paste="preventNonPositiveIntegerPaste" @input="sanitizeMassLimit" />
                    </base-input>
                    <base-input label="Round" v-if="showMassRound">
                        <a-input v-model="massRound" placeholder="Enter Round" @keydown="allowNonNegativeIntegerKey"
                            @paste="preventNonNonNegativeIntegerPaste" @input="sanitizeMassRound" />
                    </base-input>
                </fieldset>
            </a-modal>

            <!-- Available Fields Modal -->
            <a-modal title="Available Fields" :visible="modalAvailableFields" @cancel="handleCancel">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template>
                <VueTabulator v-model="couponAvailableFieldsData" :options="couponAvailableFieldsOption" />
            </a-modal>

            <hr>
            <div class="card mb-3 border-0 promotion-wizard-shell">
                <div class="card-body pb-0">
                    <a-steps :current="current" class="promotion-form-steps">
                        <a-step title="Promotion Info" />
                        <a-step title="Apply Promotion" />
                        <a-step title="Eligibility" />
                    </a-steps>
                </div>
                <!-- {{coupon}} -->
                <!-- <form id="form-proper"> -->
                <div v-if="current == 0" class="card-body">
                    <h2 class="card-title">Promo Information</h2>
                    <div class="row ml-3">
                        <div class="col-md-12">
                            <a-input label="Promo Name" v-model="promo.name" input-classes="form-control"
                                style="margin-bottom: 0px;" placeholder="Enter a description for your promo" required
                                :disabled="viewOnly" />
                            <small>Example: 10% Off All Shirts</small>
                            <br><br>
                            <a-input label="Promo Shortcode" v-model="promo.code" input-classes="form-control"
                                style="margin-bottom: 0px;" placeholder="Enter a short code to identify your promo"
                                required :disabled="viewOnly" />
                            <small>Example: PROMO10% (no spaces)</small>
                            <br><br>
                            <base-input label="Status"><br>
                                <a-select v-model="promo.status" style="width: 100%" @change="replaceStatus"
                                    :key="keyComp" :disabled="viewOnly">
                                    <a-select-option key="A" value="A">Active</a-select-option>
                                    <a-select-option key="I" value="I">In-Active</a-select-option>
                                    <a-select-option key="U" value="U" disabled>On-Going-Upload</a-select-option>
                                    <a-select-option key="E" value="E">Error</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <h2 class="card-title">Promo Duration</h2>
                    <div class="row ml-3">
                        <div class="col-md-12">
                            <div class="row">

                                <!-- Start Date -->
                                <div class="col-md-6">
                                    <base-input label="Start Date">
                                        <br />
                                        <a-date-picker v-model="promo.start_at" show-time :format="dateTimeFormat"
                                            style="width: 100%" :disabled="viewOnly" />
                                        <small v-if="!promo.start_at" class="text-danger">
                                            Enter a valid start date
                                        </small>
                                    </base-input>
                                </div>

                                <!-- End Date -->
                                <div class="col-md-6">
                                    <base-input label="End Date">
                                        <br />
                                        <a-date-picker v-model="promo.end_at" show-time :format="dateTimeFormat"
                                            style="width: 100%" :disabled="viewOnly"
                                            :disabled-date="disableInvalidEndDate" />
                                        <small v-if="endDateError" class="text-danger">
                                            {{ endDateError }}
                                        </small>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center mt-4">
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv'>
                            Advanced Information {{ showAdvancedInfo ? '↟' : '↡' }}
                        </button>
                    </div>
                    <div v-if="showAdvancedInfo == true">
                        <h2 class="card-title" style="margin-bottom: 0px;">Specify Valid Date &amp; Time</h2>
                        <p>Set specific days and hours when this promotion is available (when not enabled, promotion is
                            valid on all
                            days and hours by default)</p>
                        <div class="row ml-3">
                            <div class="col-md-12">
                                <base-checkbox class="mb-3 mt-3" v-model="is_specify_date" :disabled="viewOnly">
                                    <b>Specify Valid Days</b>
                                </base-checkbox>
                                <div class="ml-3">
                                    <span>Promos will only be enable on the days selected</span><br><br>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.mon"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Monday
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.thu"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Thursday
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.sun"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Sunday
                                            </base-checkbox>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.tue"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Tuesday
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.fri"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Friday
                                            </base-checkbox>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.wed"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Wednesday
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox v-model="valid_days.sat"
                                                :disabled="is_specify_date == false || viewOnly">
                                                Saturday
                                            </base-checkbox>
                                        </div>
                                    </div>
                                </div>

                                <base-checkbox class="mb-3 mt-3" v-model="is_specify_time" :disabled="viewOnly">
                                    <b>Specify Valid Time</b>
                                </base-checkbox>
                                <div class="ml-3">
                                    <span>Promos will only be enable on the hours specified</span><br><br>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <base-input label="Start Time"><br>
                                                <a-time-picker use12Hours v-model="picker_date.valid_start_time"
                                                    format="hh:mm A" style="width: 100%"
                                                    :disabled="is_specify_time == false || viewOnly" />
                                                <small>Enter a valid start time</small>
                                            </base-input>
                                        </div>
                                        <div class="col-md-6">
                                            <base-input label="End Time"><br>
                                                <a-time-picker use12Hours v-model="picker_date.valid_end_time"
                                                    format="hh:mm A" style="width: 100%"
                                                    :disabled="is_specify_time == false || viewOnly" />
                                                <small>Enter a valid end time</small>
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="current == 1" class="card-body">
                    <!-- <div v-if="promo.promo_type == '2'">
                                    <h2 class="card-title">PWP Config</h2>
                                    <base-input label="Items in Promo are:"><br>
                                        <base-radio value="exclusive" name="exclusive" v-model="promo.apply_level">
                                            Exclusive
                                        </base-radio>
                                        <base-radio value="inclusive" name="inclusive" v-model="promo.apply_level">
                                            Inclusive
                                        </base-radio>
                                    </base-input>
                                </div> -->

                    <h2 class="card-title">Apply Promotion </h2>

                    <fieldset :disabled="viewOnly" v-if="promo.promo_type == '2'">
                        <base-input label="Items in Promo are:"><br>
                            <base-radio value="exclusive" name="exclusive" v-model="promo.apply_level">
                                Exclusive
                            </base-radio>
                            <base-radio value="inclusive" name="inclusive" v-model="promo.apply_level">
                                Inclusive
                            </base-radio>
                        </base-input>

                        <base-input label="Computation Mode"><br>
                            <base-radio value="every" name="every" v-model="promo.compute_mode">
                                For Every
                            </base-radio>
                            <base-radio value="minimum" name="minimum" v-model="promo.compute_mode">
                                For minimum Amount
                            </base-radio>
                        </base-input>

                        <div v-if="promo.compute_mode == 'every'">
                            <base-input label="For every amount of">
                                <a-input type="number" min="0" v-model="promo.reward_trigger_amount"
                                    :disabled="viewOnly" />
                            </base-input>
                            <base-input label="Max Application (0 for unlimited)">
                                <a-input type="number" min="0" v-model="promo.reward_trigger_frequency"
                                    :disabled="viewOnly" />
                            </base-input>
                        </div>

                        <div v-else>
                            <base-input label="Minimum amount">
                                <a-input type="number" min="0" v-model="promo.reward_trigger_amount"
                                    :disabled="viewOnly" />
                            </base-input>
                        </div>

                    </fieldset>

                    <div class="row ml-3">
                        <div class="col-md-12">
                            <base-input label="Promotion Type"><br>
                                <!-- {{promo.promo_type}} -->
                                <a-select v-if="promo.promo_type == '1'" v-model="promo.reward_type" style="width: 100%"
                                    @change="replaceDiscount" :disabled="viewOnly">
                                    <a-select-option v-for="option in itemPoolOptions" :key="option.key"
                                        :value="option.key">{{ option.value }}</a-select-option>
                                </a-select>
                                <a-select v-if="['2', '7'].includes(promo.promo_type)" v-model="promo.reward_type"
                                    style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                    <a-select-option v-for="option in pwpOptions" :key="option.key"
                                        :value="option.key">{{ option.value }}</a-select-option>
                                </a-select>
                                <a-select v-if="['8'].includes(promo.promo_type)" v-model="promo.reward_type"
                                    style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                    <a-select-option v-for="option in conditionalOptions" :key="option.key"
                                        :value="option.key">{{ option.value }}</a-select-option>
                                </a-select>
                                <a-select v-if="['9'].includes(promo.promo_type)" v-model="promo.reward_type"
                                    style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                    <a-select-option v-for="option in groupDiscountOptions" :key="option.key"
                                        :value="option.key">{{ option.value }}</a-select-option>
                                </a-select>
                                <small>{{ reward_type_description }}</small>
                            </base-input>
                        </div>
                    </div>

                    <div class="row ml-3" v-if="promo.promo_type == '1' && promo.reward_type == '4'">
                        <div class="col-md-12">
                            <base-input label="Discount Type"><br>
                                <!-- {{promo.promo_type}} -->
                                <a-select v-model="promo.remark" style="width: 100%" @change="replaceDiscountType"
                                    :disabled="viewOnly">
                                    <a-select-option v-for="option in discountTypeOptions" :key="option.key"
                                        :value="option.key">{{ option.value }}</a-select-option>
                                </a-select>

                            </base-input>
                        </div>
                    </div>

                    <!-- Promo Coupon -->
                    <div v-if="promo.promo_type == '5'">
                        <div class="row ml-3">
                            <div class="col-md-6">
                                <base-input label="COUPON TRIGGER IN PROMOTION"><br>
                                    <base-radio value="for_minimum_purchase" name="for_minimum_purchase"
                                        v-model="promo.computed_trigger_label"
                                        @change="isUpdatePromoRewardAndCondition = true">
                                        For minimum purchase of
                                    </base-radio>
                                    <base-radio value="for_every" name="for_every"
                                        v-model="promo.computed_trigger_label"
                                        @change="isUpdatePromoRewardAndCondition = true">
                                        For every
                                    </base-radio>
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input :label="`Amount (${promo.computed_trigger_label === 'for_minimum_purchase'
                                    ? 'Minimum'
                                    : 'Every'})`">
                                    <a-input type="number" min="0" v-model="promo.computed_trigger_amount"
                                        :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true" />
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Reward Amount">
                                    <a-input type="number" min="0" placeholder="Enter reward trigger amount"
                                        v-model="promo.reward_trigger_amount" :disabled="viewOnly"
                                        @change="isUpdatePromoRewardAndCondition = true" />
                                </base-input>
                            </div>
                        </div>

                        <div class="row ml-3">
                            <div class="col-md-6">
                                <base-input label="BASE ON:"><br>
                                    <base-radio value="selected_items_amount" name="selected_items_amount"
                                        v-model="promo.computed_coupon_base_on"
                                        @change="isUpdatePromoRewardAndCondition = true">
                                        Selected items amount
                                    </base-radio>
                                    <base-radio value="receipt_amount" name="receipt_amount"
                                        v-model="promo.computed_coupon_base_on"
                                        @change="isUpdatePromoRewardAndCondition = true">
                                        Receipt Amount
                                    </base-radio>
                                </base-input>
                            </div>
                            <div class="col-md-3" v-if="promo.computed_trigger_label == 'for_every'">
                                <base-input label="Limit Coupon (0 for no Limit)">
                                    <a-input type="number" min="0" name="computed_coupon_limit"
                                        v-model="promo.computed_coupon_limit" placeholder="Enter coupon limit"
                                        :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true" />
                                </base-input>
                            </div>
                            <div class="col-md-3" v-if="promo.computed_trigger_label == 'for_every'">
                                <base-checkbox class="mt-4 pt-1" name="computed_coupon_print_as_one"
                                    v-model="promo.computed_coupon_print_as_one" :disabled="viewOnly"
                                    @change="isUpdatePromoRewardAndCondition = true">
                                    Print as one coupon
                                </base-checkbox>
                            </div>
                        </div>

                        <div class="row ml-3">
                            <div class="col-md-12">
                                <base-input alternative="" label="Coupon Text">
                                    <textarea rows="4" class="form-control" name="reward_coupon_text"
                                        v-model="promo.reward_coupon_text" :disabled="viewOnly" />
                                </base-input>
                            </div>
                        </div>

                        <div class="row ml-3 mb-2">
                            <div class="col-md-12">
                                <button class="btn btn-sm btn-primary"
                                    @click="isCouponTextCollapsed = !isCouponTextCollapsed">
                                    {{ !isCouponTextCollapsed
                                        ? 'Click here to see a list of available fields.'
                                        : 'Click here to hide the list of available fields.' }}
                                    <i :class="isCouponTextCollapsed
                                        ? 'fa fa-arrow-down'
                                        : 'fa fa-arrow-right'"></i>
                                </button>
                                <div :class="{ 'collapse': true, 'show': isCouponTextCollapsed }" class="mt-2">
                                    <div class="card card-body">
                                        <pre>
                                {{ this.promo.coupon_text_attributes }}
                            </pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  End Promo Coupon Criteria -->

                    <div class="row ml-3">
                        <div class="col-md-6">
                            <base-input label="Priority">
                                <a-input type="number" min="0" v-model="promo.priority_level"
                                    placeholder="Enter Priority Number" @change="isUpdatePromoRewardAndCondition = true"
                                    :disabled="viewOnly" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row ml-3" v-if="replaceDiscountKey == '3' && promo.promo_type == '6'">
                        <div class="col-md-6">
                            <base-input :label="'Target ' + (PoolOptionKey == 'TQ' ? 'Quantity' : 'Amount')">
                                <a-input-group compact>
                                    <a-select v-model="PoolOptionKey">
                                        <a-select-option value="TQ">Quantity</a-select-option>
                                        <a-select-option value="TA">Amount</a-select-option>
                                    </a-select>
                                    <a-input type="number" min="1" v-model="PoolOptionValue"
                                        :placeholder="'Enter ' + (PoolOptionKey == 'TQ' ? 'Quantity' : 'Amount')"
                                        :disabled="viewOnly" style="width: 87.5%" />
                                </a-input-group>
                            </base-input>
                        </div>
                    </div>

                    <div class="promotion-summary-strip">
                        <div class="promotion-summary-chip">
                            <span class="promotion-summary-label">Bonus Item Count</span>
                            <strong>{{ selectedProductData.length }}</strong>
                        </div>
                        <div v-if="promo.promo_type == '7'" class="promotion-summary-chip">
                            <span class="promotion-summary-label">Pre-Req Item Count</span>
                            <strong>{{ selectedProductDataB.length }}</strong>
                        </div>
                        <div v-if="promo.promo_type == '9'" class="promotion-summary-chip">
                            <span class="promotion-summary-label">Level Count</span>
                            <strong>{{ groupDiscountConfiguredLevelCount }}</strong>
                        </div>
                        <!-- <div class="promotion-summary-chip">
                                        <span class="promotion-summary-label">Status</span>
                                        <strong>{{ applyPromotionSummaryStatus }}</strong>
                                    </div> -->
                    </div>

                    <div v-if="promo.promo_type == '7' && groupBonusValidationMessages.length"
                        class="promotion-summary-errors">
                        <div v-for="message in groupBonusValidationMessages" :key="message"
                            class="promotion-summary-error">
                            {{ message }}
                        </div>
                    </div>
                    <div v-if="promo.promo_type == '9' && groupDiscountValidationMessages.length"
                        class="promotion-summary-errors">
                        <div v-for="message in groupDiscountValidationMessages" :key="message"
                            class="promotion-summary-error">
                            {{ message }}
                        </div>
                    </div>

                    <div class="promotion-select-items-header">
                        <h2 class="card-title">Select Items</h2>
                        <button v-if="canExportProduct" type="button" class="btn btn-sm btn-primary"
                            @click.prevent="exportProduct">
                            <i class="fa fa-download"></i>
                            <span>Export</span>
                        </button>
                    </div>
                    <div class="row ml-3">
                        <div class="col-md-12">

                            <!-- START - ITEM POOL & PWP DISCOUNT -->
                            <div v-if="['1', '2', '5'].includes(promo.promo_type)" class="col p-0">
                                <template v-if="!productUploadFileMode">

                                <!--  START - INCLUDE ITEM OPTIONS -->
                                <div class="col-md-6">
                                    <base-input label="Include Items" v-if="['1'].includes(promo.reward_type)"><br>
                                        <a-select v-model="include_item" style="width: 100%"
                                            :disabled="viewOnly || couponItemSelectionLocked"
                                            @change="isUpdatePromoRewardAndCondition = true">
                                            <a-select-option v-for="option in includeItemOptions" :key="option.key"
                                                :value="option.key">{{ option.value }}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                                <!--  END - INCLUDE ITEM OPTIONS -->

                                <!--  START - SUPPLIER -->
                                <div v-if="include_item == '2'" class="col-md-6">
                                    <base-input label="Select Supplier" :disabled="viewOnly"><br>
                                        <a-select v-model="allItem.supplier_id" showSearch placeholder="Select Supplier"
                                            optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                                            :notFoundContent="fetching ? undefined : null" @search="searchSupplier"
                                            @change="isUpdatePromoRewardAndCondition = true">
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                            <a-select-option v-for="option in supplierOptions" :key="option.id"
                                                :value="option.id">{{ option.name }}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                                <!--  END - SUPPLIER -->

                                <!--  START - BRAND -->
                                <div v-if="include_item == '3'" class="col-md-6">
                                    <base-input label="Select Brand" :disabled="viewOnly"><br>
                                        <a-select v-model="allItem.brand_id" showSearch placeholder="Select Brand"
                                            optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                                            :notFoundContent="fetching ? undefined : null" @search="searchBrand"
                                            @change="isUpdatePromoRewardAndCondition = true" mode="multiple">
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                            <a-select-option v-for="option in brandOptions" :key="option.id"
                                                :value="option.id">{{ option.name }}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                                <!--  END - BRAND-->

                                <!--  START - CATEGORIES -->
                                <div v-if="include_item == '4'" class="col-md-6">
                                    <base-input label="Select Category" :disabled="viewOnly"><br>
                                        <a-cascader v-model="inputCategory" :options="categoriesOptions"
                                            :showSearch="{ filter }" placeholder="All Categories" style="width: 100%"
                                            changeOnSelect @change="isUpdatePromoRewardAndCondition = true"
                                            :key="inputCategoryKey" />
                                    </base-input>
                                </div>
                                <!--  END - CATEGORIES -->

                                <!--  START - NOT SPECFIC ITEMS - All, by supplier, by brand, by category -->
                                <div v-if="showMainDiscountField" class="col-md-12">
                                    <base-input v-if="promo.reward_type == '1'" label="Percent Discount">
                                        <a-input type="number" min="0" max="100" v-model="discount" addonAfter="%"
                                            placeholder="Enter Percent Discount" :disabled="viewOnly"
                                            @keydown="allowWholeNumberKey" @paste="preventNonWholeNumberPaste"
                                            @input="sanitizeDiscount"
                                            @change="isUpdatePromoRewardAndCondition = true" />
                                    </base-input>
                                    <base-input v-else-if="promo.reward_type == '2'" label="Amount Discount"
                                        v-model="discount" input-classes="form-control"
                                        placeholder="Enter Amount Discount" :disabled="viewOnly"
                                        @keydown.native="allowWholeNumberKey"
                                        @paste.native="preventNonWholeNumberPaste" @input="sanitizeDiscountInput($event)"
                                        @change="isUpdatePromoRewardAndCondition = true" />

                                    <base-input v-if="['1', '2'].includes(promo.reward_type)" label="Limit"
                                        v-model="max_application_all" input-classes="form-control"
                                        placeholder="Enter Max Application" :disabled="viewOnly"
                                        @keydown.native="allowPositiveIntegerKey"
                                        @paste.native="preventNonPositiveIntegerPaste"
                                        @input="sanitizeMaxApplicationAll($event)"
                                        @change="isUpdatePromoRewardAndCondition = true" />

                                </div>
                                <!--  END - NOT SPECFIC ITEMS - All, by supplier, by brand, by category -->

                                <!-- START - ALL ITEMS EXCEPT -->
                                <div v-if="include_item == 5" class="col-md-12">
                                    <base-button v-if="!viewOnly" type="default" class="btn btn-sm float-right mr-10"
                                        style="background-color: #394A5D; color: white;"
                                        @click="openPromoExceptionsDrawer = !openPromoExceptionsDrawer">
                                        Add Exception
                                    </base-button>

                                    <br>

                                    <!-- Add Table Here -->
                                    <a-table :columns="promoExceptionsOptions" :dataSource="promoExceptions">
                                        <template slot="render-select" slot-scope="exception_type_display, record">
                                            <div v-if="exception_type_display == 'Supplier'">
                                                <a-select v-model="record['exception_value']"
                                                    placeholder="Select Supplier" optionFilterProp="children"
                                                    style="width: 100%" disabled>
                                                    <a-select-option v-for="option in supplierOptions" :key="option.id"
                                                        :value="option.id">{{ option.name }}</a-select-option>
                                                </a-select>
                                            </div>
                                            <div v-else-if="exception_type_display == 'Brand'">
                                                <a-select v-model="record['exception_value']" placeholder="Select Brand"
                                                    optionFilterProp="children" style="width: 100%" disabled>
                                                    <a-select-option v-for="option in brandOptions" :key="option.id"
                                                        :value="option.id">{{ option.name }}</a-select-option>
                                                </a-select>
                                            </div>
                                            <div v-else>
                                                <a-cascader disabled :key="drawerKey"
                                                    v-model="record['exception_value_display']"
                                                    :options="categoriesOptions" placeholder="All Categories"
                                                    style="width: 100%" />
                                            </div>
                                        </template>
                                        <template slot="render-action" slot-scope="exception_value, record">
                                            <button class="btn btn-sm mr-10"
                                                style="background-color: #f70909; color: white;"
                                                @click.prevent="deleteException(record)">
                                                Delete
                                            </button>
                                        </template>
                                    </a-table>

                                    <!-- <VueTabulator ref="tabulator" v-model="promoExceptions" :options="promoExceptionsOptions"/> -->
                                </div>
                                <!-- END - ALL ITEMS EXCEPT -->

                                <!--  START - SPECFIC ITEMS  -->
                                <div class="col-md-12"
                                    v-if="(parseInt(promo.reward_type) < 3 && ['6'].includes(include_item)) || (parseInt(promo.reward_type) > 2)">
                                    <div class="promotion-item-selector-shell">
                                        <div class="promotion-item-selector-toolbar">
                                            <div>
                                                <h3 class="mb-0">Selected Items</h3>
                                                <small>Browse products in the drawer, then edit promo values inline
                                                    here.</small>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                                @click.prevent="openItemSelectionDrawer">
                                                Browse Items ({{ selectedProductData.length }})
                                            </button>
                                        </div>

                                        <!-- START - TABLE SELECTED PRODUCTS -->
                                        <div class="row no-gutters" v-if="parseInt(promo.reward_type) < 4">
                                            <div class="col-md-12 mb-3">
                                                <b-input-group>
                                                    <template v-slot:prepend>
                                                        <b-dropdown :text="filterCaption1" variant="outline-default">
                                                            <b-dropdown-item
                                                                @click.prevent="changeFilter1('name')">Name</b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click.prevent="changeFilter1('product_id')">Product
                                                                Code</b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click.prevent="changeFilter1('barcode')">Barcode</b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click.prevent="changeFilter1('reference_code')">Reference
                                                                Code</b-dropdown-item>
                                                            <b-dropdown-item
                                                                @click.prevent="changeFilter1('stock_no')">Stock
                                                                No</b-dropdown-item>
                                                        </b-dropdown>
                                                    </template>
                                                    <b-form-input style="padding:5px; height: 44px;"
                                                        @keypress.enter="searchItemListProduct"
                                                        v-model="searchText1">{{ searchText1 }}</b-form-input>

                                                    <div class="filter-cont">
                                                        <base-button @click.prevent="DeleteAll"
                                                            v-if="selectedRowCount > 0"
                                                            class="btn btn-sm float-right mr-10" size="sm">Delete
                                                            All</base-button>
                                                        &nbsp;&nbsp;
                                                        <base-button
                                                            v-if="(promo.promo_type == '5' && promo.reward_type == '2') == false"
                                                            type="default" class="btn float-right mr-0" size="sm"
                                                            :disabled="viewOnly" @click.prevent="massAssign">Mass
                                                            Assign</base-button>
                                                    </div>
                                                </b-input-group>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) < 4">
                                            <div v-if="showAddedProductTabulator">
                                                <fieldset :disabled="viewOnly">
                                                    <!-- && promo.reward_type != '1' && reward.apply_level == 'IL'" -->
                                                    <VueTabulator v-if="promo.promo_type == '2'"
                                                        ref="addedProductTabulator" v-model="selectedProductData"
                                                        :options="selectedInlineProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />

                                                    <VueTabulator
                                                        v-else-if="promo.promo_type == '3' && promo.reward_type == '2'"
                                                        ref="addedProductTabulator" v-model="selectedProductData"
                                                        :options="selectedBuyXGetYProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />

                                                    <VueTabulator v-else-if="promo.promo_type == '6'"
                                                        ref="addedProductTabulator" v-model="selectedProductData"
                                                        :options="selectedBuyXGetYProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />

                                                    <VueTabulator v-else-if="promo.promo_type == '8'"
                                                        ref="addedProductTabulator" v-model="selectedProductData"
                                                        :options="selectedGetYProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />

                                                    <VueTabulator v-else ref="addedProductTabulator"
                                                        v-model="selectedProductData" :options="selectedProductOptions"
                                                        :key="refKey" :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />

                                                </fieldset>
                                            </div>
                                        </div>
                                        <div v-if="selectedProductData.length === 0" class="promotion-empty-state">
                                            No items selected yet. Use Browse Items to add products to this promotion.
                                        </div>

                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) == 6">
                                            <div v-if="showAddedProductTabulator">
                                                <fieldset :disabled="viewOnly">
                                                    <VueTabulator ref="addedProductTabulator"
                                                        v-model="selectedProductData"
                                                        :options="selectedBuyXGetXProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div v-if="selectedProductData.length === 0 && parseInt(promo.reward_type) == 6"
                                            class="promotion-empty-state">
                                            No items selected yet. Use Browse Items to add products to this promotion.
                                        </div>
                                        <!-- END - TABLE SELECTED PRODUCTS -->

                                        <!-- START - TABLE SELECTED PRODUCTS (RELATIVE & BUNDLE) -->
                                        <div v-if="promo.promo_type == '1' && ['4', '5'].includes(promo.reward_type)"
                                            class="row">
                                            <div class="col-7">
                                                <h3>PRODUCT LIST</h3>
                                                <small>Please select a product to edit</small>
                                                <fieldset :disabled="viewOnly">
                                                    <VueTabulator ref="addedProductTabulator"
                                                        v-model="selectedProductData" :options="schemeOptions"
                                                        @row-click="setActiveProductId" :key="refKey" />
                                                </fieldset>
                                            </div>
                                            <div class="col-5">
                                                <button type="button" class="btn btn-sm btn-primary float-right"
                                                    style="margin-bottom: 0px" @click.prevent="levelHandleAdd">ADD
                                                    LEVEL</button>
                                                <h3>LEVELS</h3>
                                                <small>{{ activeProductName }}</small>
                                                <a-table
                                                    v-if="(promo.reward_type == '4' && (promo.remark == '3' || promo.remark == '')) || promo.reward_type == '5'"
                                                    :columns="levelColumns" :dataSource="levelDataFilter"
                                                    :pagination="false" :scroll="{ y: 400 }">
                                                    <template v-for="col in ['qty', 'price']" :slot="col"
                                                        slot-scope="text, record">
                                                        <div :key="col">
                                                            <div>
                                                                <a-input v-if="record.editable" type="number" min="0"
                                                                    style="margin: -5px 0" :value="text"
                                                                    @change="e => levelHandleChangeTable(e.target.value, record.key, col)" />
                                                                <template v-else>{{ text }}</template>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template slot="operation" slot-scope="text, record">
                                                        <div class="editable-row-operations">
                                                            <a-dropdown>
                                                                <a class="ant-dropdown-link">
                                                                    <span class="fa fa-ellipsis-v"></span>
                                                                </a>
                                                                <a-menu slot="overlay">
                                                                    <a-menu-item key=1 v-if="levelDataFilter.length">
                                                                        <a-popconfirm title="Sure to delete?"
                                                                            @confirm="() => levelOnDelete(record.key)">
                                                                            <a href="javascript:;">Delete</a>
                                                                        </a-popconfirm>
                                                                    </a-menu-item>
                                                                </a-menu>
                                                            </a-dropdown>
                                                        </div>
                                                    </template>
                                                </a-table>
                                                <a-table v-else :columns="levelRelativeColumns"
                                                    :dataSource="levelDataFilter" :pagination="false"
                                                    :scroll="{ y: 400 }">
                                                    <template v-for="col in ['qty', 'discount', 'price']" :slot="col"
                                                        slot-scope="text, record">
                                                        <div :key="col">
                                                            <div>
                                                                <a-input v-if="record.editable && col != 'price'"
                                                                    type="number" min="0" style="margin: -5px 0"
                                                                    :value="text"
                                                                    @change="e => levelHandleChangeTableRelative(e.target.value, record.key, col)" />
                                                                <template v-else>{{ text }}</template>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template slot="operation" slot-scope="text, record">
                                                        <div class="editable-row-operations">
                                                            <a-dropdown>
                                                                <a class="ant-dropdown-link">
                                                                    <span class="fa fa-ellipsis-v"></span>
                                                                </a>
                                                                <a-menu slot="overlay">
                                                                    <a-menu-item key=1 v-if="levelDataFilter.length">
                                                                        <a-popconfirm title="Sure to delete?"
                                                                            @confirm="() => levelOnDelete(record.key)">
                                                                            <a href="javascript:;">Delete</a>
                                                                        </a-popconfirm>
                                                                    </a-menu-item>
                                                                </a-menu>
                                                            </a-dropdown>
                                                        </div>
                                                    </template>
                                                </a-table>
                                            </div>
                                        </div>
                                        <!-- START - END SELECTED PRODUCTS (RELATIVE & BUNDLE) -->
                                    </div>

                                </div>
                                <!--  END - SPECFIC ITEMS  -->
                                </template>
                                <div v-else>
                                    <small>Details to be rendered after upload process. </small>
                                    <button v-if="canUploadProduct" type="button" class="btn btn-sm btn-primary ml-2"
                                        :disabled="viewOnly" @click.prevent="toggleUploadProductsDrawer(true)">
                                        Manage Upload
                                    </button>
                                </div>


                            </div>
                            <!-- END - ITEM POOL & PWP DISCOUNT -->

                            <!-- START - GROUP BONUS  -->
                            <div v-if="['7'].includes(promo.promo_type)" class="col p-0">
                                <base-dropdown class="ellisis-cont nav-link pr-0 float-right" position="right">
                                    <div class="media align-items-center" slot="title">
                                        <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                    </div>
                                    <template>
                                        <div class="dropdown-header noti-title">
                                            <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                        </div>
                                        <div class="dropdown-item" @click.prevent="toggleUploadProductsDrawer(true)">
                                            <i class="fa fa-upload"></i>
                                            <span>Import</span>
                                        </div>
                                    </template>
                                </base-dropdown>
                                <br><br>
                                <div v-if="!productUploadFileMode" class="col-md-12">
                                    <div class="promotion-item-selector-shell">
                                        <fieldset :disabled="viewOnly">
                                            <h3 class="mb-3">Criteria</h3>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <base-input label="For any item in the group,"><br>
                                                        <base-radio value="every_amt" name="every_amt"
                                                            v-model="promo.compute_mode">
                                                            every amount of
                                                        </base-radio>
                                                        <base-radio value="every_qty" name="every_qty"
                                                            v-model="promo.compute_mode">
                                                            any pre-requisite of quantity of
                                                        </base-radio>
                                                        <base-radio value="all_with_qty" name="all_with_qty"
                                                            v-model="promo.compute_mode">
                                                            require all pre-requisite with a specific quantity
                                                        </base-radio>
                                                    </base-input>
                                                </div>

                                                <div class="col-md-6" v-if="promo.compute_mode != 'all_with_qty'">
                                                    <div v-if="promo.compute_mode == 'every_amt'">
                                                        <base-input label="Amount">
                                                            <a-input type="number" min="1"
                                                                v-model="promo.reward_trigger_amount"
                                                                :disabled="viewOnly" />
                                                        </base-input>
                                                    </div>
                                                    <div v-else>
                                                        <base-input label="Quantity">
                                                            <a-input type="number" min="1"
                                                                v-model="promo.reward_trigger_amount"
                                                                :disabled="viewOnly" />
                                                        </base-input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-3">
                                                <div class="col-md-4">
                                                    <base-input label="Limit (Max Application)">
                                                        <a-input type="number" min="0" v-model="promo.promo_text"
                                                            :disabled="viewOnly" />
                                                    </base-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-input :label="discountLabel">
                                                        <a-input type="number" min="0" v-model="promo.promo_discount"
                                                            @keydown="allowWholeNumberKey"
                                                            @paste="preventNonWholeNumberPaste"
                                                            @input="sanitizePromoDiscount"
                                                            :disabled="viewOnly" />
                                                    </base-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-input label="Group Discount - Round">
                                                        <a-input type="number" min="0" v-model="reward.round_to_nearest"
                                                            :disabled="viewOnly" />
                                                    </base-input>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <hr>

                                        <div class="promotion-item-selector-toolbar">
                                            <div>
                                                <h3 class="mb-0">Pre-requisite Items</h3>
                                                <small>Select the items that trigger the group bonus.</small>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                                @click.prevent="openGroupBonusItemDrawer('prerequisite')">
                                                Browse Pre-requisite Items ({{ selectedProductDataB.length }})
                                            </button>
                                        </div>

                                        <fieldset :disabled="viewOnly">
                                            <VueTabulator v-if="promo.compute_mode == 'all_with_qty'"
                                                :key="selectedProductBRefKey" ref="addedProductTabulator"
                                                v-model="selectedProductDataB" :options="preReqOptions2" />
                                            <VueTabulator v-else :key="selectedProductBRefKey"
                                                ref="addedProductTabulator" v-model="selectedProductDataB"
                                                :options="preReqOptions" />
                                        </fieldset>
                                        <div v-if="groupBonusValidationState.computeMode"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.computeMode }}
                                        </div>
                                        <div v-if="groupBonusValidationState.trigger"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.trigger }}
                                        </div>
                                        <div v-if="groupBonusValidationState.prerequisiteItems"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.prerequisiteItems }}
                                        </div>
                                        <div v-if="groupBonusValidationState.prerequisiteQty"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.prerequisiteQty }}
                                        </div>
                                        <div v-if="selectedProductDataB.length === 0" class="promotion-empty-state">
                                            No pre-requisite items selected. Use the drawer to add the items that should
                                            trigger this bonus.
                                        </div>

                                        <hr>

                                        <div class="promotion-item-selector-toolbar">
                                            <div>
                                                <h3 class="mb-0">Bonus Items</h3>
                                                <small>Select the bonus items, then edit discount values inline
                                                    below.</small>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                                @click.prevent="openGroupBonusItemDrawer('bonus')">
                                                Browse Bonus Items ({{ selectedProductData.length }})
                                            </button>
                                        </div>

                                        <div class="promotion-item-selector-toolbar"
                                            v-if="parseInt(promo.reward_type) < 4">
                                            <div>
                                                <small>Search and selection for bonus items is handled in the
                                                    drawer.</small>
                                            </div>
                                            <div class="promotion-item-inline-actions">
                                                <base-button @click.prevent="DeleteAll" v-if="selectedRowCount > 0"
                                                    class="btn btn-sm mr-10" size="sm">Delete All</base-button>
                                                <base-button v-if="selectedRowCount > 0" type="default" class="btn"
                                                    size="sm" :disabled="viewOnly" @click.prevent="massAssign">Mass
                                                    Assign</base-button>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) < 4">
                                            <div v-if="showAddedProductTabulator">
                                                <fieldset :disabled="viewOnly">
                                                    <VueTabulator ref="addedProductTabulator" :key="refKey"
                                                        v-model="selectedProductData" :options="selectedProductOptions"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div v-if="groupBonusValidationState.bonusItems"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.bonusItems }}
                                        </div>
                                        <div v-if="groupBonusValidationState.discount"
                                            class="promotion-inline-hint promotion-inline-error">
                                            {{ groupBonusValidationState.discount }}
                                        </div>
                                        <div v-if="selectedProductData.length === 0" class="promotion-empty-state">
                                            No bonus items selected. Use the drawer to add the items customers will
                                            receive.
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <small>Details to be rendered after upload process. </small>
                                    <button v-if="canUploadProduct" type="button" class="btn btn-sm btn-primary ml-2"
                                        :disabled="viewOnly" @click.prevent="toggleUploadProductsDrawer(true)">
                                        Manage Upload
                                    </button>
                                </div>


                            </div>
                            <!-- END - GROUP BONUS  -->

                            <!-- START - CONDITIONAL DISCOUNT -->
                            <div v-if="['8'].includes(promo.promo_type)" class="col p-0">
                                <template v-if="!productUploadFileMode">
                                <!--  START - PAIR OPTIONS -->
                                <div class="col-md-6">
                                    <base-input label="Pair Options"><br>
                                        <a-select v-model="coupleType" style="width: 100%" :disabled="viewOnly"
                                            @change="isUpdatePromoRewardAndCondition = true">
                                            <a-select-option v-for="option in coupleTypeOptions" :key="option.key"
                                                :value="option.key">{{ option.value }}</a-select-option>
                                        </a-select>
                                    </base-input>
                                    <base-checkbox v-if="coupleType == '1'" class="mb-3 mt-3"
                                        v-model="priotizedDiscountedCriteria" :disabled="viewOnly">
                                        <b>Prioritized Discounted Criteria</b>
                                    </base-checkbox>
                                </div>
                                <!--  END - PAIR OPTIONS -->

                                <!--  START - SPECFIC ITEMS  -->
                                <div class="col-md-12">
                                    <div class="promotion-item-selector-shell">
                                        <div class="promotion-item-selector-toolbar">
                                            <div>
                                                <h3 class="mb-0">Selected Items</h3>
                                                <small>Browse products in the drawer, then configure the discount
                                                    details below.</small>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                                @click.prevent="openItemSelectionDrawer">
                                                Browse Items ({{ selectedProductData.length }})
                                            </button>
                                        </div>

                                        <!-- START - TABLE SELECTED PRODUCTS -->
                                        <div class="table-responsive">
                                            <div v-if="showAddedProductTabulator">
                                                <fieldset :disabled="viewOnly">
                                                    <VueTabulator ref="addedProductTabulator"
                                                        v-model="selectedProductData"
                                                        :options="selectedGetYProductOptions" :key="refKey"
                                                        :integration="{ updateStrategy: 'UPDATE' }"
                                                        @cell-edited="syncSelectedProductEdit"
                                                        @cell-click="isUpdatePromoRewardAndCondition = true" />
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div v-if="selectedProductData.length === 0" class="promotion-empty-state">
                                            No items selected yet. Use Browse Items to add products before configuring
                                            the discount.
                                        </div>
                                        <!-- END - TABLE SELECTED PRODUCTS -->


                                        <h2 v-if="coupleType == '1'" class="card-title">Higher Price Item Discount</h2>
                                        <h2 v-else-if="coupleType == '2'" class="card-title">First Item Discount</h2>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <base-radio name="LSP" v-model="get_x_type"
                                                    @change="isUpdatePromoRewardAndCondition = true">
                                                    Percent Discount
                                                </base-radio><br>
                                                <base-input>
                                                    <a-input :disabled="get_x_type != 'LSP'" type="number" min="0"
                                                        v-model="reward.get_x_lp" addonAfter="%"
                                                        @keydown="allowWholeNumberKey"
                                                        @paste="preventNonWholeNumberPaste"
                                                        @input="sanitizeRewardDiscount('get_x_lp')"
                                                        @change="isUpdatePromoRewardAndCondition = true"
                                                        placeholder="Enter Percent Discount" size="large" />
                                                </base-input>
                                                <base-input label="Round to nearest">
                                                    <a-input-number placeholder="Round to Nearest" size="large"
                                                        style="width: 100%" v-model="reward.get_x_lp_round"
                                                        @change="isUpdatePromoRewardAndCondition = true" :min="0"
                                                        :precision="0" />
                                                </base-input>
                                            </div>
                                            <div class="col-md-3">
                                                <base-radio name="LSA" v-model="get_x_type"
                                                    @change="isUpdatePromoRewardAndCondition = true">
                                                    Amount Discount
                                                </base-radio><br>
                                                <base-input :disabled="get_x_type != 'LSA'" v-model="reward.get_x_la"
                                                    input-classes="form-control" placeholder="Enter Amount Discount"
                                                    @keydown.native="allowWholeNumberKey"
                                                    @paste.native="preventNonWholeNumberPaste"
                                                    @input="sanitizeRewardDiscountInput('get_x_la', $event)"
                                                    @change="isUpdatePromoRewardAndCondition = true" />
                                            </div>
                                            <div class="col-md-3">
                                                <base-radio name="NWP" v-model="get_x_type"
                                                    @change="isUpdatePromoRewardAndCondition = true">
                                                    New Price
                                                </base-radio><br>
                                                <base-input :disabled="get_x_type != 'NWP'" v-model="reward.get_x_po"
                                                    input-classes="form-control" placeholder="Enter Amount Discount"
                                                    @keydown.native="allowPositiveDecimalKey"
                                                    @paste.native="preventNonPositiveDecimalPaste"
                                                    @input="sanitizeRewardDecimalInput('get_x_po', $event)"
                                                    @change="isUpdatePromoRewardAndCondition = true" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <hr>
                                                <h2 v-if="coupleType == '1'" class="card-title">Lower Price Item
                                                    Discount</h2>
                                                <h2 v-else class="card-title">Second Item Discount</h2>

                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <base-radio name="LP" v-model="get_y_type"
                                                            @change="isUpdatePromoRewardAndCondition = true">
                                                            Percent Discount
                                                        </base-radio><br>
                                                        <base-input>
                                                            <a-input :disabled="get_y_type != 'LP'" type="number"
                                                                min="0" v-model="reward.get_y_lp" addonAfter="%"
                                                                placeholder="Enter Percent Discount" size="large"
                                                                @keydown="allowWholeNumberKey"
                                                                @paste="preventNonWholeNumberPaste"
                                                                @input="sanitizeRewardDiscount('get_y_lp')"
                                                                @change="isUpdatePromoRewardAndCondition = true" />
                                                        </base-input>
                                                        <base-input label="Round to nearest">
                                                            <a-input-number placeholder="Round to Nearest" size="large"
                                                                style="width: 100%"
                                                                @change="isUpdatePromoRewardAndCondition = true"
                                                                v-model="reward.get_y_lp_round" :min="0"
                                                                :precision="0" />
                                                        </base-input>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <base-radio name="LA" v-model="get_y_type"
                                                            @change="isUpdatePromoRewardAndCondition = true">
                                                            Amount Discount
                                                        </base-radio><br>
                                                        <base-input :disabled="get_y_type != 'LA'"
                                                            v-model="reward.get_y_la" input-classes="form-control"
                                                            placeholder="Enter Amount Discount"
                                                            @keydown.native="allowWholeNumberKey"
                                                            @paste.native="preventNonWholeNumberPaste"
                                                            @input="sanitizeRewardDiscountInput('get_y_la', $event)"
                                                            @change="isUpdatePromoRewardAndCondition = true" />
                                                    </div>
                                                    <div class="col-md-3">
                                                        <base-radio name="PO" v-model="get_y_type"
                                                            @change="isUpdatePromoRewardAndCondition = true">
                                                            New Price
                                                        </base-radio><br>
                                                        <base-input :disabled="get_y_type != 'PO'"
                                                            v-model="reward.get_y_po" input-classes="form-control"
                                                            placeholder="Enter Amount Discount"
                                                            @keydown.native="allowPositiveDecimalKey"
                                                            @paste.native="preventNonPositiveDecimalPaste"
                                                            @input="sanitizeRewardDecimalInput('get_y_po', $event)"
                                                            @change="isUpdatePromoRewardAndCondition = true" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <!--  END - SPECFIC ITEMS  -->
                                </template>
                                <div v-else>
                                    <small>Details to be rendered after upload process. </small>
                                    <button v-if="canUploadProduct" type="button" class="btn btn-sm btn-primary ml-2"
                                        :disabled="viewOnly" @click.prevent="toggleUploadProductsDrawer(true)">
                                        Manage Upload
                                    </button>
                                </div>

                            </div>
                            <!-- END - CONDITIONAL DISCOUNT -->

                            <!-- START - GROUP DISCOUNT  -->
                            <div v-if="['9'].includes(promo.promo_type)" class="col p-0">
                                <template v-if="!productUploadFileMode">
                                <div class="promotion-item-selector-shell">
                                    <div class="promotion-item-selector-toolbar">
                                        <div>
                                            <h3 class="mb-0">Group Discount Setup</h3>
                                            <small>Configure item coverage, selected items, and discount levels.</small>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <base-input label="Include Items" v-if="['1'].includes(promo.reward_type)"><br>
                                                <a-select v-model="include_item" style="width: 100%" :disabled="viewOnly"
                                                    @change="isUpdatePromoRewardAndCondition = true">
                                                    <a-select-option v-for="option in includeItemGroupDiscountOptions"
                                                        :key="option.key" :value="option.key">{{ option.value }}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>

                                        <div v-if="include_item == '4'" class="col-md-6">
                                            <base-input label="Select Supplier" :disabled="viewOnly"><br>
                                                <a-select v-model="allItem.supplier_id" showSearch placeholder="Select Supplier"
                                                    optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                                                    :notFoundContent="fetching ? undefined : null" @search="searchSupplier"
                                                    @change="isUpdatePromoRewardAndCondition = true">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in supplierOptions" :key="option.id"
                                                        :value="option.id">{{ option.name }}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>

                                        <div v-if="include_item == '5'" class="col-md-6">
                                            <base-input label="Select Brand" :disabled="viewOnly"><br>
                                                <a-select v-model="allItem.brand_id" showSearch placeholder="Select Brand"
                                                    optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                                                    :notFoundContent="fetching ? undefined : null" @search="searchBrand"
                                                    @change="isUpdatePromoRewardAndCondition = true" mode="multiple">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in brandOptions" :key="option.id"
                                                        :value="option.id">{{ option.name }}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>

                                        <div v-if="include_item == '6'" class="col-md-6">
                                            <base-input label="Select Category" :disabled="viewOnly"><br>
                                                <a-cascader v-model="inputCategory" :options="categoriesOptions"
                                                    :showSearch="{ filter }" placeholder="All Categories" style="width: 100%"
                                                    changeOnSelect @change="isUpdatePromoRewardAndCondition = true"
                                                    :key="inputCategoryKey" />
                                            </base-input>
                                        </div>
                                    </div>

                                    <div v-if="include_item == '2'" class="col-md-12 p-0">
                                        <base-button v-if="!viewOnly" type="default" class="btn btn-sm float-right mr-10"
                                            style="background-color: #394A5D; color: white;"
                                            @click="openPromoExceptionsDrawer = !openPromoExceptionsDrawer">
                                            Add Exception
                                        </base-button>
                                        <br>
                                        <a-table :columns="promoExceptionsOptions" :dataSource="promoExceptions">
                                            <template slot="render-select" slot-scope="exception_type_display, record">
                                                <div v-if="exception_type_display == 'Supplier'">
                                                    <a-select v-model="record['exception_value']" placeholder="Select Supplier"
                                                        optionFilterProp="children" style="width: 100%" disabled>
                                                        <a-select-option v-for="option in supplierOptions" :key="option.id"
                                                            :value="option.id">{{ option.name }}</a-select-option>
                                                    </a-select>
                                                </div>
                                                <div v-else-if="exception_type_display == 'Brand'">
                                                    <a-select v-model="record['exception_value']" placeholder="Select Brand"
                                                        optionFilterProp="children" style="width: 100%" disabled>
                                                        <a-select-option v-for="option in brandOptions" :key="option.id"
                                                            :value="option.id">{{ option.name }}</a-select-option>
                                                    </a-select>
                                                </div>
                                                <div v-else>
                                                    <a-cascader disabled :key="drawerKey"
                                                        v-model="record['exception_value_display']"
                                                        :options="categoriesOptions" placeholder="All Categories"
                                                        style="width: 100%" />
                                                </div>
                                            </template>
                                            <template slot="render-action" slot-scope="exception_value, record">
                                                <button class="btn btn-sm mr-10" style="background-color: #f70909; color: white;"
                                                    @click.prevent="deleteException(record)">
                                                    Delete
                                                </button>
                                            </template>
                                        </a-table>
                                    </div>
                                </div>

                                <div v-if="include_item == '7'" class="promotion-item-selector-shell">
                                    <div class="promotion-item-selector-toolbar">
                                        <div>
                                            <h3 class="mb-0">Selected Items</h3>
                                            <small>Browse products in the drawer, then manage the selected item list below.</small>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                            @click.prevent="openItemSelectionDrawer">
                                            Browse Items ({{ selectedProductData.length }})
                                        </button>
                                    </div>

                                    <div class="table-responsive">
                                        <div v-if="showAddedProductTabulator">
                                            <fieldset :disabled="viewOnly">
                                                <VueTabulator ref="addedProductTabulator" v-model="selectedProductData"
                                                    :options="selectedProductOptionsGD" :key="refKey"
                                                    :integration="{ updateStrategy: 'UPDATE' }"
                                                    @cell-edited="syncSelectedProductEdit"
                                                    @cell-click="isUpdatePromoRewardAndCondition = true" />
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div v-if="selectedProductData.length === 0" class="promotion-empty-state">
                                        No selected items yet. Use Browse Items to add products.
                                    </div>
                                </div>

                                <div class="promotion-item-selector-shell">
                                    <div class="promotion-item-selector-toolbar">
                                        <div>
                                            <h3 class="mb-0">Discount Rules</h3>
                                            <small>Choose how the discount is triggered, then define the levels below.</small>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-primary" :disabled="viewOnly"
                                            @click.prevent="groupLevelHandleAdd">
                                            Add Level
                                        </button>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <base-input label="Discount Type"><br>
                                                <a-select v-model="promo.group_discount_type" style="width: 100%"
                                                    :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true">
                                                    <a-select-option key="1" value="1">Percent Discount for minimum quantity sold</a-select-option>
                                                    <a-select-option key="2" value="2">Percent Discount for minimum amount sold</a-select-option>
                                                    <a-select-option key="3" value="3">Amount Discount for minimum amount sold</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                        <div class="col-md-6">
                                            <base-input label="Round">
                                                <a-input type="number" min="0" v-model="promo.round"
                                                    @change="isUpdatePromoRewardAndCondition = true" :disabled="viewOnly" />
                                            </base-input>
                                        </div>
                                    </div>

                                    <div v-if="groupDiscountValidationMessages.length" class="promotion-summary-errors">
                                        <div v-for="message in groupDiscountValidationMessages" :key="message"
                                            class="promotion-summary-error">
                                            {{ message }}
                                        </div>
                                    </div>

                                    <a-table v-if="promo.group_discount_type == '1'" :columns="groupLevelColumns"
                                        :dataSource="groupLevelDataFilter" :pagination="false" :scroll="{ y: 600 }"
                                        :key="groupLevelKey">
                                        <template v-for="col in ['qty', 'discount']" :slot="col" slot-scope="text, record">
                                            <div :key="col">
                                                <div>
                                                    <a-input v-if="record.editable" type="number" min="0"
                                                        style="margin: -5px 0" :value="text"
                                                        @change="e => groupLevelHandleChangeTable(e.target.value, record.key, col)" />
                                                    <template v-else>{{ text }}</template>
                                                </div>
                                            </div>
                                        </template>

                                        <template slot="operation" slot-scope="text, record">
                                            <div class="editable-row-operations">
                                                <a-dropdown>
                                                    <a class="ant-dropdown-link"><span class="fa fa-ellipsis-v"></span></a>
                                                    <a-menu slot="overlay">
                                                        <a-menu-item key=1 v-if="groupLevelDataFilter.length">
                                                            <a-popconfirm title="Sure to delete?" @confirm="() => groupLevelOnDelete(record.key)">
                                                                <a href="javascript:;">Delete</a>
                                                            </a-popconfirm>
                                                        </a-menu-item>
                                                    </a-menu>
                                                </a-dropdown>
                                            </div>
                                        </template>
                                    </a-table>

                                    <a-table v-if="promo.group_discount_type == '2'" :columns="groupLevelColumns2"
                                        :dataSource="groupLevelDataFilter" :pagination="false" :scroll="{ y: 600 }"
                                        :key="groupLevelKey">
                                        <template v-for="col in ['amount', 'discount']" :slot="col" slot-scope="text, record">
                                            <div :key="col">
                                                <div>
                                                    <a-input v-if="record.editable" type="number" min="0"
                                                        style="margin: -5px 0" :value="text"
                                                        @change="e => groupLevelHandleChangeTable(e.target.value, record.key, col)" />
                                                    <template v-else>{{ text }}</template>
                                                </div>
                                            </div>
                                        </template>

                                        <template slot="operation" slot-scope="text, record">
                                            <div class="editable-row-operations">
                                                <a-dropdown>
                                                    <a class="ant-dropdown-link"><span class="fa fa-ellipsis-v"></span></a>
                                                    <a-menu slot="overlay">
                                                        <a-menu-item key=1 v-if="groupLevelDataFilter.length">
                                                            <a-popconfirm title="Sure to delete?" @confirm="() => groupLevelOnDelete(record.key)">
                                                                <a href="javascript:;">Delete</a>
                                                            </a-popconfirm>
                                                        </a-menu-item>
                                                    </a-menu>
                                                </a-dropdown>
                                            </div>
                                        </template>
                                    </a-table>

                                    <a-table v-if="promo.group_discount_type == '3'" :columns="groupLevelColumns3"
                                        :dataSource="groupLevelDataFilter" :pagination="false" :scroll="{ y: 600 }"
                                        :key="groupLevelKey">
                                        <template v-for="col in ['amount', 'discount']" :slot="col" slot-scope="text, record">
                                            <div :key="col">
                                                <div>
                                                    <a-input v-if="record.editable" type="number" min="0"
                                                        style="margin: -5px 0" :value="text"
                                                        @change="e => groupLevelHandleChangeTable(e.target.value, record.key, col)" />
                                                    <template v-else>{{ text }}</template>
                                                </div>
                                            </div>
                                        </template>

                                        <template slot="operation" slot-scope="text, record">
                                            <div class="editable-row-operations">
                                                <a-dropdown>
                                                    <a class="ant-dropdown-link"><span class="fa fa-ellipsis-v"></span></a>
                                                    <a-menu slot="overlay">
                                                        <a-menu-item key=1 v-if="groupLevelDataFilter.length">
                                                            <a-popconfirm title="Sure to delete?" @confirm="() => groupLevelOnDelete(record.key)">
                                                                <a href="javascript:;">Delete</a>
                                                            </a-popconfirm>
                                                        </a-menu-item>
                                                    </a-menu>
                                                </a-dropdown>
                                            </div>
                                        </template>
                                    </a-table>
                                </div>
                                </template>
                                <div v-else>
                                    <small>Details to be rendered after upload process. </small>
                                    <button v-if="canUploadProduct" type="button" class="btn btn-sm btn-primary ml-2"
                                        :disabled="viewOnly" @click.prevent="toggleUploadProductsDrawer(true)">
                                        Manage Upload
                                    </button>
                                </div>
                            </div>
                            <!-- END - GROUP DISCOUNT  -->

                        </div>
                    </div>
                </div>

                <div v-if="current == 2" class="card-body">
                    <fieldset :disabled="viewOnly">
                        <h2 class="card-title">Eligibility</h2>
                        <p class="text-muted mb-4">Configure who can use this promotion and where it can be applied.</p>

                        <div class="row">
                            <div class="col-md-6">
                                <h4 class="card-title" style="margin-bottom: 0px;">Customers</h4>
                                <div class="row ml-3 mt-3">
                                    <div class="col-md-12">
                                        <base-radio name="$ALL$" v-model="customer_type">
                                            All Customers (Members and Non-Members)
                                            <br><small>Default Section</small>
                                        </base-radio>
                                        <br>
                                        <base-radio name="$MEMBERSONLY$" v-model="customer_type">
                                            Members Only
                                        </base-radio>
                                        <br>
                                        <base-radio name="$NONMEMBERSONLY$" v-model="customer_type">
                                            Non-Members Only
                                        </base-radio>
                                        <br>
                                        <base-radio name="S" v-model="customer_type">
                                            Members of Specific Card Types Only
                                        </base-radio>
                                        <a-select v-if="customer_type == 'S'" mode="multiple"
                                            v-model="customer_card_type_ids" showSearch
                                            placeholder="All Customer Card Types" optionFilterProp="children"
                                            class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in customerCardTypeOptions"
                                                :key="option.id.toString()" :value="option.id.toString()">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h4 class="card-title" style="margin-bottom: 0px;">Payment Types</h4>
                                <div v-if="promo.promo_type == '2'" class="row ml-3 mt-3">
                                    <div class="col-md-12">
                                        <base-input alternative="" label="Select Payment Type">
                                            <a-select :disabled="viewOnly" v-model="promo.payment_type_code" showSearch
                                                placeholder="Select Payment Type" optionFilterProp="children"
                                                style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in paymentTypeOptions" :key="option.code"
                                                    :value="option.code">{{ option.name }}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                                <div v-else class="row ml-3 mt-3">
                                    <div class="col-md-12">
                                        <base-input alternative="" label="Select Payment Type">
                                            <a-select disabled v-model="payment_type_code" showSearch
                                                placeholder="All Payment Types" optionFilterProp="children"
                                                style="width: 100%" :filterOption="filterOption">
                                                <a-select-option key="ALL" value="ALL">All Payment
                                                    Types</a-select-option>
                                                <a-select-option v-for="option in paymentTypeOptions" :key="option.code"
                                                    :value="option.code">{{ option.name }}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <h4 class="card-title">Sites</h4>
                        <div class="row ml-3">
                            <div class="col-md-12">
                                <base-radio name="A" v-model="site_selection">
                                    All Sites (default)
                                </base-radio>
                                <br>
                                <base-radio name="S" v-model="site_selection">
                                    Specific Site
                                </base-radio>
                                <div v-if="site_selection == 'S'">
                                    <br />
                                    <div class="col-md-8">
                                        <div class="col">
                                            <a-input-search placeholder="Search Sites" v-model="searchQuery"
                                                @input="filterSites" :allowClear="true"
                                                style="width: 100%; margin-bottom: 10px;" />
                                        </div>
                                        <div class="col mb-3">
                                            <h6 class="heading-small text-muted">Enter Site Codes</h6>
                                            <a-input v-model="siteCodesInput"
                                                placeholder="Enter site codes separated by commas"
                                                style="width: 100%;" />
                                            <p class="text-muted" style="font-size: 14px; margin-top: 5px;">Note: Enter
                                                site codes
                                                separated by commas. Example: (site_code1,site_code2,site_code3) or
                                                (site_code1,
                                                site_code2, site_code3)</p>
                                            <a-button @click="processSiteCodesInput" type="default">Tag Sites</a-button>
                                            <a-button @click="clearSiteCodes" type="danger"
                                                style="margin-left: 10px;">Clear</a-button>
                                            <a-button @click="showSelectedSites" type="primary"
                                                style="margin-left: 10px;">View Selected
                                                Sites</a-button>
                                        </div>
                                        <a-tree ref="tree" checkable :checkedKeys="selectedRowKeys"
                                            :treeData="productLocationData" :disabled="viewOnly"
                                            @check="onCheckSiteId" />
                                        <div v-if="searchQuery && !hasSiteSearchResults" class="col text-muted"
                                            style="font-size: 14px; padding-top: 30px;">
                                            No results found for the given search query.
                                        </div>
                                        <a-modal :visible="isModalVisible" title="Selected Sites" @ok="handleOk_"
                                            @cancel="handleCancel">
                                            <ul>
                                                <li v-for="site in selectedSites" :key="site.key">{{ site.title }}</li>
                                            </ul>
                                        </a-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <!-- </form> -->
            </div>
        </a-spin>

        <a-drawer title="Select Items" :width="720" placement="right" :visible="itemSelectionDrawerVisible"
            @close="closeItemSelectionDrawer">
            <div class="promotion-item-drawer-copy">
                Search products, apply filters, and add them directly into the current promotion list.
            </div>

            <div class="row no-gutters">
                <div class="col-md-12 mb-3">
                    <b-input-group>
                        <template v-slot:prepend>
                            <b-dropdown :text="filterCaption" variant="outline-default">
                                <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference
                                    Code</b-dropdown-item>
                                <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf
                                    Code</b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataDrawer"
                            v-model="searchText">{{ searchText }}</b-form-input>

                        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12"
                            style="border-top: 1px solid #e0e0e0; width: 100%">
                            <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams"
                                :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter"
                                :key="filterKey"> </product-advance-filter>
                        </div>

                        <div class="filter-cont">
                            <button class="btn btn-sm float-right mr-10"
                                style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{ toggleLabel }}
                            </button>&nbsp;&nbsp;

                            <base-button v-if="!viewOnly" type="default" class="btn btn-sm float-right mr-10"
                                style="background-color: #394A5D; color: white;" @click.prevent="addAll">
                                Add All
                            </base-button>

                            <base-dropdown class="ellisis-cont nav-link pr-0 float-right" position="right">

                                <div class="media align-items-center" slot="title">
                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                </div>

                                <template>
                                    <div class="dropdown-header noti-title">
                                        <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                    </div>
                                    <div v-if="canUploadProduct" class="dropdown-item"
                                        @click.prevent="toggleUploadProductsDrawer(true)">
                                        <i class="fa fa-upload"></i>
                                        <span>Import</span>
                                    </div>
                                    <div v-if="canExportProduct" class="dropdown-item" @click.prevent="exportProduct">
                                        <i class="fa fa-download"></i>
                                        <span>Export</span>
                                    </div>
                                </template>
                            </base-dropdown>
                        </div>
                    </b-input-group>
                </div>
            </div>

            <div class="table-responsive">
                <div id="product-table-drawer"></div>
            </div>
        </a-drawer>

        <a-drawer
            :title="groupBonusItemDrawerMode === 'prerequisite' ? 'Select Pre-requisite Items' : 'Select Bonus Items'"
            :width="720" placement="right" :visible="groupBonusItemDrawerVisible" @close="closeGroupBonusItemDrawer">
            <div class="promotion-item-drawer-copy">
                {{ groupBonusItemDrawerMode === 'prerequisite'
                    ? 'Search products and add them to the prerequisite item list.'
                    : 'Search products and add them to the bonus item list.' }}
            </div>

            <div class="row no-gutters">
                <div class="col-md-12 mb-3">
                    <b-input-group>
                        <template v-slot:prepend>
                            <b-dropdown
                                :text="groupBonusItemDrawerMode === 'prerequisite' ? filterCaption : filterCaptionB"
                                variant="outline-default">
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'prerequisite'"
                                    @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>

                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('name')">Name</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('id')">Product Code</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('barcode')">Barcode</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('stock_no')">Stock No</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('reference_code')">Reference Code</b-dropdown-item>
                                <b-dropdown-item v-if="groupBonusItemDrawerMode === 'bonus'"
                                    @click.prevent="changeFilterB('shelf_code')">Shelf Code</b-dropdown-item>
                            </b-dropdown>
                        </template>

                        <b-form-input v-if="groupBonusItemDrawerMode === 'prerequisite'"
                            style="padding:5px; height: 44px;" @keypress.enter="allProductsDataGBDrawer"
                            v-model="searchText">{{ searchText }}</b-form-input>
                        <b-form-input v-else style="padding:5px; height: 44px;" @keypress.enter="allProductsDataBDrawer"
                            v-model="searchTextB">{{ searchTextB }}</b-form-input>

                        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12"
                            style="border-top: 1px solid #e0e0e0; width: 100%">
                            <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams"
                                :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter"
                                :key="filterKey"> </product-advance-filter>
                        </div>

                        <div class="filter-cont">
                            <button class="btn btn-sm float-right mr-10"
                                style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{ toggleLabel }}
                            </button>&nbsp;&nbsp;

                            <base-button v-if="!viewOnly && groupBonusItemDrawerMode === 'prerequisite'" type="default"
                                class="btn btn-sm float-right mr-10" style="background-color: #394A5D; color: white;"
                                @click.prevent="addAllGroupBonus">
                                Add All
                            </base-button>

                            <base-button v-if="!viewOnly && groupBonusItemDrawerMode === 'bonus'" type="default"
                                class="btn btn-sm float-right mr-10" style="background-color: #394A5D; color: white;"
                                @click.prevent="addAll">
                                Add All
                            </base-button>

                            <base-dropdown class="ellisis-cont nav-link pr-0 float-right" position="right">

                                <div class="media align-items-center" slot="title">
                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                </div>

                                <template>
                                    <div class="dropdown-header noti-title">
                                        <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                    </div>
                                    <div v-if="canUploadProduct" class="dropdown-item"
                                        @click.prevent="toggleUploadProductsDrawer(true)">
                                        <i class="fa fa-upload"></i>
                                        <span>Import</span>
                                    </div>
                                    <div v-if="canExportProduct" class="dropdown-item" @click.prevent="exportProduct">
                                        <i class="fa fa-download"></i>
                                        <span>Export</span>
                                    </div>
                                </template>
                            </base-dropdown>
                        </div>
                    </b-input-group>
                </div>
            </div>

            <div class="table-responsive">
                <div id="group-bonus-item-drawer-table"></div>
            </div>
        </a-drawer>

        <a-drawer title="ADD EXCEPTION" :width="480" placement="right" :closable="false" :visible="typeVisible"
            @close="onClose">
            <base-input label="Select Exception">
                <select class="form-control" size="large" v-model="exceptionText">
                    <option v-for="option in exceptionOptions" v-bind:value="option.key" v-bind:key="option.key">
                        {{ option.value }}
                    </option>
                </select>
            </base-input>

            <div v-if="exceptionText == 'SP'">
                <base-input label="Select Supplier"><br>
                    <a-select v-model="exceptSupplier" showSearch placeholder="Select Supplier"
                        optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                        :notFoundContent="fetching ? undefined : null" @search="searchSupplier">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in supplierOptions" :key="option.id"
                            :value="option.id">{{ option.name }}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else-if="exceptionText == 'BR'">
                <base-input label="Select Brand"><br>
                    <a-select v-model="exceptBrand" showSearch placeholder="Select Brand" optionFilterProp="children"
                        style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null"
                        @search="searchBrand" mode="multiple">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in brandOptions" :key="option.id"
                            :value="option.id">{{ option.name }}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else>
                <base-input label="Select Category"><br>
                    <a-cascader v-model="exceptCategory" :options="categoriesOptions" :showSearch="{ filter }"
                        placeholder="All Categories" style="width: 100%" changeOnSelect />
                </base-input>
            </div>
            <div
                :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1 }">
                <a-button type="primary" @click="addException">
                    APPLY
                </a-button>
            </div>
        </a-drawer>

        <PromoExceptions :key="promoExceptionKey" :promotionId="profileId" :visible="openPromoExceptionsDrawer"
            :promoType="promo.promo_type" :rewardType="promo.reward_type" :includeItem="include_item"
            :filterOption="filterOption" :supplierOptions="supplierOptions" :brandOptions="brandOptions"
            :categoriesOptions="categoriesOptions" :promoExceptions="promoExceptions"
            :onClose="togglePromoExceptionsDrawer" @updateExceptions="updateExceptions" />

        <UploadProducts ref="uploadProductKey" :promotionId="profileId" :selectedProducts="selectedProductData"
            :visible="openUploadProductsDrawer" :onClose="toggleUploadProductsDrawer" :addProducts="addMassProducts"
            :promoType="promo.promo_type" :rewardType="promo.reward_type" :includeItem="include_item"
            :coupleType="coupleType" @file-change="handleProductUploadFileChange" />

        <div
            :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1 }">
            <a-button v-if="current == 0" type="default" @click="cancel">CANCEL</a-button>
            <a-button v-if="current > 0" type="default" @click="backPage(current)">BACK</a-button>
            <a-button v-if="current < 2" class="ml-3" type="primary" @click="nextPage(current)">NEXT</a-button>
            <a-button v-if="current == 2 && !viewOnly" class="ml-3" type="primary" :loading="doneLoading"
                @click.prevent="done">DONE</a-button>
            <a-button v-if="current == 2 && viewOnly" class="ml-3" type="primary"
                @click.prevent="close">CLOSE</a-button>
        </div>

        <vue-json-to-csv :labels="csvHeaders" :json-data="exportData" @success="clearExportJsonData"
            :csv-title="exportFileName">
            <span ref="exportCsvBtn"></span>
        </vue-json-to-csv>
    </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import secureStorage from '../../controllers/secureStorage';
import Autocomplete from 'vuejs-auto-complete'
import ProductAdvanceFilter from '../Products/ProductAdvanceFilter.vue'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';
import Tabulator from 'tabulator-tables';
import UploadProducts from './Drawers/UploadProductsV2.vue';
import PromoExceptions from './Drawers/PromoExceptions.vue';
import VueJsonToCsv from 'vue-json-to-csv';
import { exportProductCSV, PRODUCT_LIST_EXPORT_PROMO_TYPES } from './Utilities/promotionExport.js';
import { uploadToS3, uploadToS3BackgroundProcess } from '../../utilities.js';
// import { uploadToS3, objectToFormData } from '../../utilities';

import { parseCouponPromoText, formatCurrency, lineRoundToNearest, extractDetailPromoText, shouldShowMainDiscountField, requiresProductDiscountValue, couponItemSelectionLocked, couponBasedOnReceiptAmount, COUPON_ALL_ITEM_KEY } from './Utilities/promo.js'

var component_x;
export default {
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType',
            'categoriesOptions', 'awsEndPoint']),
        promoTypeLabel() {
            const types = {
                '1': 'Item and Pool Discounts',
                '2': 'Purchase with Purchase',
                '3': 'Seasonal',
                '4': 'Coupon Barcode',
                '5': 'Coupon Stub',
                '6': 'Reward Point',
                '7': 'Group Bonus',
                '8': 'Conditional Promo',
                '9': 'Group Discount'
            };
            return types[this.promo.promo_type] || '';
        },
        showMassRequired() {
            return (this.promo.promo_type == '2' && this.promo.reward_type != '1')
                || this.promo.promo_type == '3'
                || this.promo.promo_type == '5'
                || this.promo.promo_type == '6';
        },
        showMassDiscount() {
            return ((this.promo.promo_type != '6' && this.promo.promo_type != '3')
                && this.promo.promo_type != '4'
                && this.promo.promo_type != '5')
                || (this.promo.promo_type == '3' && this.promo.reward_type == '1');
        },
        showMassLimit() {
            return (this.promo.promo_type != '6'
                && this.promo.promo_type != '3'
                && this.promo.promo_type != '5')
                || (this.promo.promo_type == '3' && this.promo.reward_type == '1');
        },
        showMassRound() {
            return (this.promo.promo_type != '6'
                && this.promo.promo_type != '3'
                && this.promo.promo_type != '5')
                || (this.promo.promo_type == '3' && this.promo.reward_type == '1');
        },
        isCouponStubProductMassAssign() {
            return this.promo.promo_type == '5' && this.include_item == '6';
        },
        // Coupon Promo (promo_type '5') BASED ON "Receipt Amount" forces the item
        // selection to "All Item" and the field must be disabled: the coupon
        // applies to the whole receipt, not to selected items. True only for a
        // coupon whose BASE ON is receipt_amount.
        couponItemSelectionLocked() {
            return couponItemSelectionLocked(this.promo.promo_type, this.promo.computed_coupon_base_on);
        },
        // Coupon Promo (promo_type '5') never shows the shared Discount field.
        // Delegates to the pure helper so the UI and the unit tests stay in agreement.
        showMainDiscountField() {
            return shouldShowMainDiscountField(this.promo.promo_type, this.include_item);
        },
        productUploadFileMode() {
            return this.productUploadReplacesManualInputs()
                && (this.uploadedProductFileMode || this.hasUploadedProductFile() || this.promo.status == 'U');
        },
        canExportProduct() {
            return this.showExportProductButton();
        },
        headingPrefix() {
            if (this.profileId === 0) return 'Create';
            return this.viewOnly ? 'View' : 'Edit';
        },
        groupBonusValidationState() {
            if (this.promo.promo_type !== '7') {
                return {};
            }

            if (this.productUploadFileMode) {
                return {};
            }

            const errors = {};
            const triggerAmount = Number(this.promo.reward_trigger_amount);
            const discountAmount = Number(this.promo.promo_discount);

            if (!this.promo.compute_mode) {
                errors.computeMode = 'Select a computation mode.';
            }

            if (this.promo.compute_mode !== 'all_with_qty' && (!Number.isFinite(triggerAmount) || triggerAmount <= 0)) {
                errors.trigger = 'Enter a valid amount or quantity greater than 0.';
            }

            if (this.selectedProductDataB.length === 0) {
                errors.prerequisiteItems = 'Add at least 1 pre-requisite item.';
            }

            if (this.promo.compute_mode === 'all_with_qty' && this.selectedProductDataB.some(item => Number(item.quantity) <= 0 || Number.isNaN(Number(item.quantity)))) {
                errors.prerequisiteQty = 'All pre-requisite quantities must be greater than 0.';
            }

            if (this.selectedProductData.length === 0) {
                errors.bonusItems = 'Add at least 1 bonus item.';
            }

            if (!Number.isFinite(discountAmount) || discountAmount <= 0) {
                errors.discount = 'Enter a valid discount value greater than 0.';
            }

            return errors;
        },
        groupBonusValidationMessages() {
            return Object.values(this.groupBonusValidationState);
        },
        groupDiscountConfiguredLevelCount() {
            if (this.promo.promo_type !== '9') {
                return 0;
            }

            return this.groupLevelData.filter(level => {
                if (this.promo.group_discount_type === '1') {
                    return level.qty !== '' || level.discount !== '';
                }

                return level.amount !== '' || level.discount !== '';
            }).length;
        },
        groupDiscountValidationState() {
            if (this.promo.promo_type !== '9') {
                return {};
            }

            if (this.productUploadFileMode) {
                return {};
            }

            const errors = {};
            const hasSpecificItems = this.include_item === '7';
            const filledLevels = this.groupLevelData.filter(level => {
                if (this.promo.group_discount_type === '1') {
                    return level.qty !== '' || level.discount !== '';
                }

                return level.amount !== '' || level.discount !== '';
            });

            if (hasSpecificItems && this.selectedProductData.length === 0) {
                errors.items = 'Add at least 1 selected item.';
            }

            if (filledLevels.length === 0) {
                errors.levels = 'Add at least 1 discount level.';
            } else {
                const hasIncompleteLevel = filledLevels.some(level => {
                    if (this.promo.group_discount_type === '1') {
                        return level.qty === '' || level.discount === '';
                    }

                    return level.amount === '' || level.discount === '';
                });

                if (hasIncompleteLevel) {
                    errors.levelValues = 'Complete all discount level values before continuing.';
                }
            }

            return errors;
        },
        groupDiscountValidationMessages() {
            return Object.values(this.groupDiscountValidationState);
        },
        applyPromotionSummaryStatus() {
            if (!this.promo.reward_type) {
                return 'Incomplete';
            }

            if (this.promo.promo_type === '7') {
                return this.groupBonusValidationMessages.length === 0 ? 'Ready' : 'Needs Attention';
            }

            if (this.promo.promo_type === '9') {
                return this.groupDiscountValidationMessages.length === 0 ? 'Ready' : 'Needs Attention';
            }

            if (this.selectedProductData.length === 0 && ['6'].includes(this.include_item)) {
                return 'Needs Items';
            }

            return this.selectedProductData.length > 0 ? 'In Progress' : 'Setup Pending';
        },
        endDateError() {
            if (!this.promo.start_at || !this.promo.end_at) return null;

            if (this.promo.end_at.isBefore(this.promo.start_at, 'day')) {
                return 'End date cannot be before start date';
            }
            return null;
        },
        canExportProduct() {
            return this.showExportProductButton();
        }
    },
    components: {
        ProductAdvanceFilter,
        UploadProducts,
        VueJsonToCsv,
        PromoExceptions
    },
    mounted: async function () {
        // initialize filteredLocationData with productLocationData
        this.filteredLocationData = this.productLocationData;

        if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
            this.viewOnly = true
        }

        this.canUploadProduct = this.showUploadCSVButton();

        if (this.$attrs.promoType == '1') {
            this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
            this.reward_type_description = "Apply an discount to an item by percentage (e.g 10%)"
        } else if (this.$attrs.promoType == '2') {
            this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
            this.reward_type_description = "Apply multi-level discount without conditions"
        } else if (this.$attrs.promoType == '3') {
            this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
        } else if (this.$attrs.promoType == '4') {
            this.reward_type_description = "For quantity exceeding X, discount X"
        } else if (this.$attrs.promoType == '5') {
            this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
            // Coupon Promo lists the participating items only; it does not define a
            // per-product discount. Hide the editable "PERCENT DISCOUNT" column (and
            // the related ROUND column) so the discount cannot be entered/edited.
            this.selectedProductOptions.columns[4].visible = false
            this.selectedProductOptions.columns[6].visible = false
        } else if (this.$attrs.promoType == '6') {
            this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
        } else if (this.$attrs.promoType == '7') {
            this.reward_type_description = "Group Discount - Less Percent"
            this.selectedProductOptions.columns[1].width = "40%"
            this.selectedProductOptions.columns[2].width = "30%"
            this.selectedProductOptions.columns[5].visible = false
            this.selectedProductOptions.columns[4].visible = false

            // Enabled QUANTITY FIELD for Group Bonus
            this.selectedProductOptions.columns[7].visible = true

            // Remove ROUND in details (Round is in # 6)
            this.selectedProductOptions.columns[6].visible = false
        } else if (this.$attrs.promoType == '8') {
            this.reward_type_description = "Buy any get any"
        }
        else if (this.$attrs.promoType == '9') {
            this.reward_type_description = "Group discount"
        }

        this.productOptions.ajaxURL = this.endPoint + 'products?all=0'
        this.productOptions.ajaxConfig = {
            method: "GET",
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
        }

        this.productOptionsB2.ajaxURL = this.endPoint + 'products?all=0'
        this.productOptionsB2.ajaxConfig = {
            method: "GET",
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
        }

        this.levelData = []
        this.levelDataFilter = []
        this.groupLevelDataFilter = []
        this.groupLevelData = []
        this.groupLevelCount = 1;
        this.levelCount = 1;
        this.levelGDData = []
        this.levelGDDataFilter = []
        this.levelGDCount = 1;

        component_x = this

        let payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
        component_x.paymentTypeOptions = payment_types;
        component_x.sort(component_x.paymentTypeOptions);
        if (component_x.profileId == 0) {
            let siteId = secureStorage.getItem("defaultSiteId");
            component_x.selectedRowKeys.push(siteId);
            component_x.getLocationTreeData();
        }
        // component_x.getLocationTreeData();


        if (component_x.profileId > 0) {
            this.spinning = true
            var promo_data = await HTTPRequest.getRequest(component_x.endPoint + 'promos/' + component_x.profileId, null)

            // Error message if promotion is empty.
            if (promo_data.promo_lines.length <= 0) {
                this.openNotificationWithIcon('error', "No Promo Rewards and Condition found in this Promotion. Try to edit and re-upload the details.")
            }

            component_x.getLocationTreeData();
            component_x.productLocationData = [];
            component_x.productLocationData.children = [];
            // component_x.selectedRowKeys = [];

            if (promo_data == undefined) {
                component_x.$router.go()
            } else {
                if (promo_data["error"] == undefined) {
                    Object.assign(component_x.promo, promo_data)
                    if (promo_data.promo_type == null) {
                        component_x.promo.promo_type = "1"
                    }

                    component_x.promo.reward_type = promo_data.reward_type.split('|')[1]

                    if (promo_data.reward_type == null) {
                        component_x.promo.reward_type = "1"
                    }

                    component_x.getYData = []
                    // console.log(promo_data)
                    component_x.getYData = [];
                    component_x.promo.start_at = moment(promo_data.start_at)
                    component_x.promo.end_at = moment(promo_data.end_at)

                    console.log("INCLUDE ITEM CHECKER")
                    // console.log(component_x.promo.reward_type)
                    if (promo_data.promo_lines.length > 0) {
                        console.log(promo_data.promo_lines[0].include_field)

                        if (component_x.promo.promo_type == '9') {
                            console.log("Group Discount >> Inclue Item")
                            if (promo_data.promo_lines[0].include_field == "all") {
                                console.log("Should be here... include item is all items")
                                component_x.include_item = "1"
                            }

                            else if (promo_data.promo_lines[0].include_field.includes("ex_")) {
                                console.log("Should be here... include item is all items except")
                                component_x.include_item = "2"
                            }

                            else if (promo_data.promo_lines[0].include_field == ("supplierId")) {
                                console.log("Should be here... include item all supplierId")
                                component_x.include_item = "4"
                            }

                            else if (promo_data.promo_lines[0].include_field == ("brandId")) {
                                console.log("Should be here... include item is all brandId")
                                component_x.include_item = "5"
                            }

                            else if (promo_data.promo_lines[0].include_field == ("refcode")) {
                                console.log("Should be here... include item is all refcode")
                                component_x.include_item = "7"
                            }

                            else {
                                console.log("Should be here... include item is all category")
                                component_x.include_item = "6"
                            }
                        } else {
                            if (promo_data.promo_lines[0].include_field == "all") {
                                console.log("Should be here... include item is all items")
                                component_x.include_item = "1"
                            }

                            else if (promo_data.promo_lines[0].include_field.includes("ex_")) {
                                console.log("Should be here... include item is all items except")
                                component_x.include_item = "5"
                            }

                            else if (promo_data.promo_lines[0].include_field == ("supplierId")) {
                                console.log("Should be here... include item all supplierId")
                                component_x.include_item = "2"
                            }

                            else if (promo_data.promo_lines[0].include_field == ("brandId")) {
                                console.log("Should be here... include item is all brandId")
                                component_x.include_item = "3"
                            }

                            else {
                                component_x.include_item = component_x.promo.include_item || "6"
                            }
                        }

                    }

                    // check if DAYS
                    let days_array = (promo_data.valid_day != null) ? promo_data.valid_day.split("") : []
                    if (days_array.length > 0) {
                        component_x.is_specify_date = true
                        component_x.showAdvancedInfo = true
                        component_x.valid_days = {
                            sun: false, mon: false, tue: false,
                            wed: false, thu: false, fri: false, sat: false
                        }

                        for (let index = 0; index < days_array.length; index++) {
                            const element = days_array[index];
                            switch (parseInt(element)) {
                                case 1:
                                    Object.assign(component_x.valid_days, { sun: true })
                                    break;
                                case 2:
                                    Object.assign(component_x.valid_days, { mon: true })
                                    break;
                                case 3:
                                    Object.assign(component_x.valid_days, { tue: true })
                                    break;
                                case 4:
                                    Object.assign(component_x.valid_days, { wed: true })
                                    break;
                                case 5:
                                    Object.assign(component_x.valid_days, { thu: true })
                                    break;
                                case 6:
                                    Object.assign(component_x.valid_days, { fri: true })
                                    break;
                                case 7:
                                    Object.assign(component_x.valid_days, { sat: true })
                                    break;
                            }
                        }
                    }
                    delete component_x.promo.valid_days

                    component_x.replaceDiscount(component_x.promo.reward_type)
                    if (component_x.promo.remark == '2')
                        component_x.replaceDiscountType(component_x.promo.remark)

                    if (promo_data.valid_start_time != null && promo_data.valid_end_time != null) {
                        component_x.is_specify_time = true
                        component_x.showAdvancedInfo = true
                        component_x.picker_date = {
                            valid_start_time: component_x.parsePromoTime(promo_data.valid_start_time, 'start'),
                            valid_end_time: component_x.parsePromoTime(promo_data.valid_end_time, 'end')
                        }
                    }
                    delete component_x.promo.valid_times

                    let expected_value = [];

                    console.log("ITEM CHECKER")
                    console.log(component_x.include_item)

                    if (component_x.promo.promo_type == '9') {
                        //Brand & Categ
                        if (component_x.include_item == '5' || component_x.include_item == '6') {
                            // Pushing the include_value from the promo_lines array to expected_value array
                            // promo_data.promo_lines.forEach(promoLine => {
                            //     expected_value.push(parseInt(promoLine.include_value));
                            // });
                            // this.brandOptions.filter(x => expected_value.includes(x.id)).map(x => x.name)
                            // console.log(expected_value,this.brandOptions)
                            // component_x.allItem.brand_id = expected_value
                        }

                        // Supplier
                        else if (component_x.include_item == '4') {
                            // Pushing the include_value from the promo_lines array to expected_value array
                            // promo_data.promo_lines.forEach(promoLine => {
                            //     expected_value.push(parseInt(promoLine.include_value));
                            // });

                            console.log(">> Supplier")
                            console.log(this.supplierOptions)

                            let p_line = promo_data.promo_lines[0]

                            if (this.supplierOptions.length == 0) {
                                console.log("Get suppliers first...")
                                let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                                this.supplierOptions = suppliers
                                this.sort(this.supplierOptions);
                                component_x.allItem.supplier_id = parseInt(p_line.include_value)
                            } else {
                                component_x.allItem.supplier_id = parseInt(p_line.include_value)
                            }


                        }

                        // Except
                        else if (component_x.include_item == '2') {
                            console.log("Processing exceptions...")
                            let promo_lines_saved = promo_data.promo_lines
                            for (let y = 0; y < promo_lines_saved.length; y++) {
                                let promo_line_saved = promo_lines_saved[y]
                                let exception_item = {}
                                switch (promo_line_saved.include_field) {
                                    case "ex_supplierId":
                                        exception_item = {
                                            "exception_type_display": "Supplier",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": parseInt(promo_line_saved.include_value),
                                            "exception_value_display": ""
                                        }
                                        break;
                                    case "ex_brandId":
                                        exception_item = {
                                            "exception_type_display": "Brand",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": parseInt(promo_line_saved.include_value),
                                            "exception_value_display": ""
                                        }
                                        break;
                                    case "ex_divisionId":
                                        exception_item = {
                                            "exception_type_display": "Division",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_departmentId":
                                        exception_item = {
                                            "exception_type_display": "Department",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_sectionId":
                                        exception_item = {
                                            "exception_type_display": "Section",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_categoryId":
                                        exception_item = {
                                            "exception_type_display": "Category",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                }
                                console.log("Pushing to exceptions..")
                                console.log(exception_item)
                                component_x.promoExceptions.push(exception_item)
                            }
                        }
                    } else {
                        //Brand & Categ
                        if (component_x.include_item == '3' || component_x.include_item == '7') {
                            // Pushing the include_value from the promo_lines array to expected_value array
                            promo_data.promo_lines.forEach(promoLine => {
                                expected_value.push(parseInt(promoLine.include_value));
                            });
                            // this.brandOptions.filter(x => expected_value.includes(x.id)).map(x => x.name)
                            // console.log(expected_value,this.brandOptions)
                            component_x.allItem.brand_id = expected_value
                        }

                        // Supplier
                        else if (component_x.include_item == '2') {
                            // Pushing the include_value from the promo_lines array to expected_value array
                            promo_data.promo_lines.forEach(promoLine => {
                                expected_value.push(parseInt(promoLine.include_value));
                            });

                            component_x.allItem.supplier_id = expected_value
                        }

                        // Except
                        else if (component_x.include_item == '5') {
                            console.log("Processing exceptions...")
                            let promo_lines_saved = promo_data.promo_lines
                            for (var y = 0; y < promo_lines_saved.length; y++) {
                                let promo_line_saved = promo_lines_saved[y]
                                let exception_item = {}
                                switch (promo_line_saved.include_field) {
                                    case "ex_supplierId":
                                        exception_item = {
                                            "exception_type_display": "Supplier",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": parseInt(promo_line_saved.include_value),
                                            "exception_value_display": ""
                                        }
                                        break;
                                    case "ex_brandId":
                                        exception_item = {
                                            "exception_type_display": "Brand",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": parseInt(promo_line_saved.include_value),
                                            "exception_value_display": ""
                                        }
                                        break;
                                    case "ex_divisionId":
                                        exception_item = {
                                            "exception_type_display": "Division",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_departmentId":
                                        exception_item = {
                                            "exception_type_display": "Department",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_sectionId":
                                        exception_item = {
                                            "exception_type_display": "Section",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                    case "ex_categoryId":
                                        exception_item = {
                                            "exception_type_display": "Category",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": promo_line_saved.include_value,
                                            "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                        }
                                        break;
                                }
                                console.log("Pushing to exceptions..")
                                console.log(exception_item)
                                component_x.promoExceptions.push(exception_item)
                            }
                        }
                    }


                    delete component_x.promo.reward_items

                    //Populate Items
                    if (promo_data.promo_lines.length > 0) {

                        // Item and Pool Discounts
                        if (['1', '2'].includes(promo_data.promo_type)) {
                            console.log("Populating Items for Item and Pool Discounts...")

                            component_x.selectedProductData = []
                            component_x.selectedProd = []

                            // Additional Processing for PWP
                            if (promo_data.promo_type == '2') {
                                console.log("Getting Promo text Values for PWP")
                                let header_promo_text = promo_data.promo_text.split(";")
                                component_x.promo.compute_mode = header_promo_text[2]
                                component_x.promo.payment_type_code = header_promo_text[1]
                                component_x.promo.apply_level = header_promo_text[0]
                            }

                            // BY SUPPLIER
                            if (promo_data.promo_lines[0].include_field == "supplierId") {
                                component_x.include_item = "2"

                                let p_line = promo_data.promo_lines[0]
                                // Process Promo text
                                let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                component_x.discount = promo_value

                                component_x.max_application_all = component_x.positiveIntegerValueFromStoredLimit(p_line.promo_text.split('@')[1].replace(")", ""))
                                component_x.allItem.supplier_id = parseInt(p_line.include_value)
                            }

                            // EXCEPT 
                            if (promo_data.promo_lines[0].include_field.includes("ex_")) {
                                component_x.include_item = "5"

                                let p_line = promo_data.promo_lines[0]
                                // Process Promo text
                                let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                component_x.discount = promo_value
                                component_x.max_application_all = component_x.positiveIntegerValueFromStoredLimit(p_line.promo_text.split('@')[1].replace(")", ""))
                            }

                            // BY BRAND
                            else if (promo_data.promo_lines[0].include_field == "brandId") {
                                console.log("BRAND")
                                component_x.include_item = "3"

                                this.searchBrand()

                                let p_line = promo_data.promo_lines[0]
                                // Process Promo text
                                let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                component_x.discount = promo_value
                                component_x.max_application_all = component_x.positiveIntegerValueFromStoredLimit(p_line.promo_text.split('@')[1].replace(")", ""))

                                // promo_data.promo_lines.map(p_line => {
                                //     component_x.allItem.brand_id.push( parseInt(p_line.include_value)  )
                                // })

                                // console.log(component_x.allItem.brand_id)
                                // component_x.allItem.brand_id = parseInt(p_line.include_value)
                            }

                            // BY CATEGORY
                            else if (["divisionId", "departmentId", "sectionId", "categoryId"].includes(promo_data.promo_lines[0].include_field)) {
                                console.log(">>> Process Categories")

                                component_x.include_item = "4"

                                console.log("Categories")
                                console.log(this.categoriesOptions)

                                if (component_x.categoriesOptions.length == 0) {
                                    //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                                    let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                                    this.updateCategoriesOptions(options)
                                }

                                let p_line = promo_data.promo_lines[0]
                                // Process Promo text
                                let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                component_x.discount = promo_value

                                // (1:E1:5%;@2) 
                                component_x.max_application_all = component_x.positiveIntegerValueFromStoredLimit(p_line.promo_text.split('@')[1].replace(")", ""))
                                component_x.inputCategory = JSON.parse(p_line.integration_settings)//.split(",").map(x => parseInt(x))


                                // component_x.inputCategoryKey++;
                                // console.log(">>> INPUT CATEGORY CHECK")
                                // console.log(p_line.include_field_ex)
                                // console.log(component_x.inputCategory)
                            }


                            else {


                                // component_x.include_item = "6"
                                //Loop products
                                component_x.levelData = []
                                promo_data.promo_lines.map(product => {



                                    component_x.selectedProd.push(product.product_id)

                                    let promo_value = ''
                                    let product_required_value = ''

                                    //PERCENT, AMOUNt & CHANGE PRICE

                                    // Default to '0' (no rounding) rather than '' so that a promo
                                    // saved with round = 0 reloads showing 0 instead of blank. A
                                    // round of 0 is encoded with no "^" marker in promo_text, so the
                                    // round-up branch below won't fire for it.
                                    let _round_to_nearest = '0'

                                    if (['1', '2', '3'].includes(component_x.promo.reward_type)) {
                                        promo_value = ((product.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                        if (product.include_field == "all") {
                                            component_x.include_item = "1"
                                            component_x.discount = promo_value
                                            component_x.max_application_all = component_x.positiveIntegerValueFromStoredLimit(product.promo_text.split('@')[1].replace(")", ""))
                                            // (1:E1:10%;@2)
                                        } else {
                                            if (product.description.includes('Round up') || product.promo_text.includes("^")) {
                                                const getRoundUpEdit = lineRoundToNearest('update', product.promo_text)
                                                // Keep '0' when the parsed value is empty (no round-up marker).
                                                _round_to_nearest = (getRoundUpEdit.text !== '' && getRoundUpEdit.text !== null && getRoundUpEdit.text !== undefined)
                                                    ? getRoundUpEdit.text
                                                    : '0'
                                            }
                                        }
                                    }


                                    // RELATIVE PRICING
                                    else if (component_x.promo.reward_type == 4) {
                                        // product_required_value = 'Relative Pricing'
                                        // (1:E1:R5|150,10|100;@1000)

                                        console.log(">> original product_required_value")
                                        console.log(product.promo_text)

                                        promo_value = product.promo_text.split(':')[2].split(';')[0].split(',')
                                        console.log(">> promo_value")
                                        console.log(promo_value)
                                        // [ R5|150, 10|100 ]
                                        let prev_key = 0
                                        if (component_x.levelData.length > 0) {
                                            prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                        }
                                        console.log("PREV KEY :: " + prev_key)
                                        for (let x = 0; x < promo_value.length; x++) {
                                            if (promo_value[x] != '') {
                                                let levelValue = promo_value[x].split("|");
                                                let qty = levelValue[0].replace("R", "");
                                                let discountedPrice = parseFloat(levelValue[1]) || 0;
                                                let discountValue = 0;

                                                if (component_x.promo.remark === "1") {
                                                    // % discount
                                                    discountValue = product.original_price
                                                        ? ((product.original_price - discountedPrice) / product.original_price) * 100
                                                        : 0;
                                                } else if (component_x.promo.remark === "2") {
                                                    // Amount discount
                                                    discountValue = product.original_price - discountedPrice;
                                                }

                                                component_x.levelData.push({
                                                    key: prev_key + (x + 1),
                                                    product_id: product.product_id,
                                                    original_price: product.original_price,
                                                    discount: parseFloat(discountValue.toFixed(2)),
                                                    qty: qty,
                                                    price: discountedPrice,
                                                    editable: true
                                                });

                                            }

                                        }

                                        component_x.levelCount = component_x.levelData.reduce((max, item) => {
                                            return Math.max(max, Number(item.key) || 0);
                                        }, 0) + 1;

                                        console.log(">> Populated Level Data")
                                        console.log(this.levelData)

                                    }

                                    // BUNDLE PRICING
                                    else if (component_x.promo.reward_type == 5) {
                                        console.log("Should process bundle pricing....")

                                        //(1:S3:590,5:985,10:1895@1000) 

                                        promo_value = product.promo_text.split('@')[0].split(',')
                                        console.log(">> promo_value")
                                        console.log(promo_value)

                                        // [ R5|150, 10|100 ]
                                        let prev_key = 0
                                        if (component_x.levelData.length > 0) {
                                            prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                        }
                                        console.log("PREV KEY :: " + prev_key)
                                        for (var x = 0; x < promo_value.length; x++) {
                                            if (promo_value[x] != '') {
                                                let levelValue = promo_value[x].replace('(1:S', '').split(":")
                                                // (1:S3:590,5:985,10:1895@1000)
                                                component_x.levelData.push({
                                                    key: prev_key + (x + 1),
                                                    product_id: product.product_id,
                                                    qty: levelValue[0],
                                                    price: levelValue[1],
                                                    original_price: product.original_price,
                                                    editable: true
                                                })
                                            }

                                        }

                                        component_x.levelCount = component_x.levelData.reduce((max, item) => {
                                            return Math.max(max, Number(item.key) || 0);
                                        }, 0) + 1;

                                        console.log(">> Populated Level Data")
                                        console.log(this.levelData)
                                    }

                                    // BXTX
                                    else if (component_x.promo.reward_type == 6) {
                                        // product_required_value = 'Buy X Take x'
                                        //(1:D1:B2,1;@2)
                                        let promo_parse = product.promo_text.split(':')
                                        product_required_value = promo_parse[2].split(',')[0].replace('B', '')
                                        promo_value = promo_parse[2].split(',')[1].split(';')[0]
                                    }

                                    if (product.include_field != "all") {
                                        var product_desc = product.description.split("||")
                                        component_x.selectedProductData.push({
                                            product_id: product.product_id,
                                            required_value: product_required_value,
                                            promo_value: promo_value,
                                            name: product_desc[1],
                                            retail_price: product.original_price,
                                            barcode: product.product.barcode,
                                            reference_code: component_x.getProductField(product, 'reference_code', product.include_value),
                                            stock_no: product.stock_no,
                                            // round_to_nearest: 1,
                                            round_to_nearest: _round_to_nearest,
                                            max_application: component_x.positiveIntegerValueFromStoredLimit(product.quantity)
                                        })
                                    }
                                })

                            }

                        }

                        // PROMO COUPON :: EDIT
                        else if (['5'].includes(promo_data.promo_type)) {


                            console.log("Edit promo coupon...", promo_data)
                            const getCouponPromoText = parseCouponPromoText('update', '', '', '', '', false, promo_data.promo_text)
                            console.log("Promo Text Edit:", getCouponPromoText)
                            this.promo.computed_coupon_limit = getCouponPromoText.computed_coupon_limit
                            this.promo.computed_coupon_base_on = getCouponPromoText.computed_coupon_base_on
                            this.promo.computed_coupon_print_as_one = getCouponPromoText.computed_coupon_print_as_one
                            this.promo.computed_trigger_amount = formatCurrency(getCouponPromoText.computed_trigger_amount)
                            this.promo.reward_coupon_text = promo_data.reward_coupon_text
                            this.promo.reward_trigger_amount = formatCurrency(promo_data.reward_trigger_amount)
                            this.promo.computed_trigger_label = promo_data.reward_trigger_frequency === 1 ? 'for_minimum_purchase' : 'for_every'
                            promo_data.promo_lines.map(item => {
                                if (item.include_field == 'productCode') {
                                    const couponStubProductValues = component_x.parseCouponStubProductPromoLine(item);
                                    const descriptionParts = String(item.description || '').split('||');
                                    const productName = component_x.getProductField(item, 'name', descriptionParts[1] || '');
                                    component_x.selectedProd.push(item.product_id)
                                    component_x.selectedProductData.push({
                                        product_id: item.product_id,
                                        required_value: 1,
                                        promo_value: couponStubProductValues.promo_value,
                                        name: productName,
                                        retail_price: item.original_price,
                                        barcode: component_x.getProductField(item, 'barcode'),
                                        reference_code: component_x.getProductField(item, 'reference_code'),
                                        stock_no: component_x.getProductField(item, 'stock_no'),
                                        round_to_nearest: couponStubProductValues.round_to_nearest,
                                        max_application: couponStubProductValues.max_application,
                                        quantity: item.quantity || 1
                                    })
                                }
                            })

                            // Receipt Amount coupons must be All Item. If an older
                            // record was saved BASED ON Receipt Amount but with a
                            // specific-item selection, correct the form state
                            // immediately on load (not just the visible control):
                            // force include_item to All Item and drop the stale
                            // selected products so an invalid selection is never
                            // re-submitted. The field is disabled via
                            // couponItemSelectionLocked. Switching to another basis
                            // re-enables it (existing behavior).
                            if (couponBasedOnReceiptAmount(this.promo.promo_type, this.promo.computed_coupon_base_on)) {
                                this.include_item = COUPON_ALL_ITEM_KEY
                                component_x.selectedProd = []
                                component_x.selectedProductData = []
                            }
                        }


                        // Group Bonus
                        else if (['7'].includes(promo_data.promo_type)) {

                            component_x.promo.promo_text = promo_data.promo_text.replace("@", "")

                            component_x.selectedProd = []
                            component_x.selectedProdB = []

                            promo_data.promo_lines.map(p_line => {

                                // console.log("Processling line")
                                // console.log(p_line)
                                if (p_line.promo_type == "P") {
                                    if (p_line.include_field == "refcode") {
                                        component_x.selectedProdB.push(p_line.product_id)

                                        component_x.selectedProductDataB.push({
                                            product_id: p_line.product_id,
                                            required_value: 1,
                                            promo_value: "",
                                            name: p_line.product.name,
                                            retail_price: p_line.original_price,
                                            barcode: p_line.product.barcode,
                                            reference_code: component_x.getProductField(p_line, 'reference_code', p_line.include_value),
                                            stock_no: p_line.stock_no,
                                            quantity: p_line.quantity
                                        })
                                    } else {
                                        component_x.promo.reward_trigger_amount = p_line.quantity
                                    }
                                } else {
                                    if (p_line.include_field == "refcode") {
                                        component_x.selectedProd.push(p_line.product_id)

                                        component_x.selectedProductData.push({
                                            product_id: p_line.product_id,
                                            required_value: 1,
                                            promo_value: "",
                                            name: p_line.product.name,
                                            retail_price: p_line.original_price,
                                            barcode: p_line.product.barcode,
                                            reference_code: component_x.getProductField(p_line, 'reference_code', p_line.include_value),
                                            stock_no: p_line.stock_no,
                                            quantity: p_line.quantity,
                                        })
                                    } else {
                                        // Parse promo text
                                        let reward_type = promo_data.reward_type.split("|")[1]
                                        component_x.promo.reward_type = reward_type
                                        let getPromoTextVal;
                                        if (reward_type == "1") {
                                            // component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("%","")
                                            getPromoTextVal = extractDetailPromoText('GROUPBONUS', '%', p_line.promo_text)
                                        } else if (reward_type == "2") {
                                            // component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("L","")
                                            getPromoTextVal = extractDetailPromoText('GROUPBONUS', 'L', p_line.promo_text)
                                        } else {
                                            // component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("F","")
                                            getPromoTextVal = extractDetailPromoText('GROUPBONUS', 'F', p_line.promo_text)
                                        }
                                        if (getPromoTextVal) {
                                            component_x.promo.promo_discount = getPromoTextVal.discountType
                                            component_x.reward.round_to_nearest = getPromoTextVal.exponent
                                        }

                                    }
                                }

                            })

                            console.log("PRE REQ")
                            console.log(component_x.selectedProdB)

                            console.log("BONUS")
                            console.log(component_x.selectedProd)

                            if (promo_data.promo_lines[0].condition_type == "AMOUNT") {
                                component_x.promo.compute_mode = "every_amt"
                            } else if (promo_data.promo_lines[0].condition_type == "ANY") {
                                component_x.promo.compute_mode = "all_with_qty"
                            } else {
                                component_x.promo.compute_mode = "every_qty"
                            }

                        }

                        // Conditional Promo
                        else if (['8'].includes(promo_data.promo_type)) {

                            if (promo_data.promo_text != null) {
                                this.priotizedDiscountedCriteria = promo_data.promo_text.includes('true') || false
                            } else {
                                this.priotizedDiscountedCriteria = false
                            }

                            promo_data.promo_lines.forEach(product => {
                                const isRealProduct = product.product_id > -1;
                                let promo_value = '';
                                let p_round = '';
                                let p_type_chk = '';

                                // Helper to parse promo_text
                                const parsePromoText = (text) => {
                                    const segment = text.split(':')[2] || '';
                                    const valuePart = segment.split(';')[0] || '';
                                    return {
                                        value: (valuePart.match(/(\d+\.\d+|\d+)/) || [])[0] || '',
                                        round: valuePart.split('^')[1] || '',
                                        typeChar: segment.charAt(0)
                                    };
                                };

                                // Helper to set reward values based on promo type and type character
                                const assignReward = (side, typeChar, value, round) => {
                                    const prefix = side === 'x' ? 'get_x' : 'get_y';

                                    // assignReward('y', p_type_chk, promo_value, p_round);

                                    if (typeChar === 'L') {
                                        this[`${prefix}_type`] = side === 'x' ? 'LSA' : 'LA';
                                        this.reward[`${prefix}_la`] = value;
                                    } else if (typeChar === 'F') {
                                        this[`${prefix}_type`] = side === 'x' ? 'NWP' : 'PO';
                                        this.reward[`${prefix}_po`] = value;
                                    } else {
                                        this[`${prefix}_type`] = side === 'x' ? 'LSP' : 'LP';
                                        this.reward[`${prefix}_lp`] = value;
                                    }

                                    console.log("round", round)
                                    this.reward[`${prefix}_lp_round`] = round;
                                };

                                if (isRealProduct) {
                                    component_x.selectedProd.push(product.product_id);
                                    component_x.selectedProductData.push({
                                        product_id: product.product_id,
                                        required_value: '',
                                        promo_value: '',
                                        name: product.product.name,
                                        retail_price: product.original_price,
                                        barcode: product.product.barcode,
                                        reference_code: component_x.getProductField(product, 'reference_code', product.include_value),
                                        stock_no: product.stock_no,
                                        round_to_nearest: 1,
                                        max_application: 1,
                                        quantity: 1
                                    });
                                } else {
                                    const { value, round, typeChar } = parsePromoText(product.promo_text);
                                    promo_value = value;
                                    p_round = round;
                                    p_type_chk = typeChar;
                                    console.log(promo_value, p_round, p_type_chk)

                                    const type = product.promo_type;

                                    console.log(type)

                                    if (['H', 'L'].includes(type)) {
                                        this.coupleType = '1';
                                        if (type === 'H') assignReward('x', p_type_chk, promo_value, p_round);
                                        if (type === 'L') assignReward('y', p_type_chk, promo_value, p_round);
                                    } else if (['F', 'S'].includes(type)) {
                                        this.coupleType = '2';
                                        if (type === 'F') assignReward('x', p_type_chk, promo_value, p_round);
                                        if (type === 'S') assignReward('y', p_type_chk, promo_value, p_round);
                                    }
                                }
                            });

                        }

                        // Group Discount
                        if (['9'].includes(promo_data.promo_type)) {
                            console.log("Populating Items for Group Discount...")

                            component_x.selectedProductData = []
                            component_x.selectedProd = []

                            // BY SUPPLIER
                            if (promo_data.promo_lines[0].include_field == "supplierId") {
                                component_x.include_item = "4"
                                let p_line = promo_data.promo_lines[0]
                                component_x.allItem.supplier_id = parseInt(p_line.include_value)
                            }

                            // EXCEPT 
                            if (promo_data.promo_lines[0].include_field.includes("ex_")) {
                                component_x.include_item = "2"
                            }

                            // BY BRAND
                            else if (promo_data.promo_lines[0].include_field == "brandId") {
                                console.log("BRAND")
                                component_x.include_item = "5"

                                this.searchBrand()

                                // Process Promo text
                                // let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                // component_x.discount = promo_value
                                // component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")

                                promo_data.promo_lines.map(p_line => {
                                    component_x.allItem.brand_id.push(parseInt(p_line.include_value))
                                })

                                // console.log(component_x.allItem.brand_id)
                                //component_x.allItem.brand_id = parseInt(p_line.include_value)
                            }

                            // BY CATEGORY
                            else if (["divisionId", "departmentId", "sectionId", "categoryId"].includes(promo_data.promo_lines[0].include_field)) {
                                console.log(">>> Process Categories")

                                component_x.include_item = "6"

                                console.log("Categories")
                                console.log(this.categoriesOptions)

                                if (component_x.categoriesOptions.length == 0) {
                                    //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                                    let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                                    this.updateCategoriesOptions(options)
                                }

                                let p_line = promo_data.promo_lines[0]
                                // // Process Promo text
                                // let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+\.\d+|\d+)/)[0];
                                // component_x.discount = promo_value

                                // // (1:E1:5%;@2) 
                                // component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")
                                component_x.inputCategory = JSON.parse(p_line.integration_settings)//.split(",").map(x => parseInt(x))


                                // component_x.inputCategoryKey++;
                                // console.log(">>> INPUT CATEGORY CHECK")
                                // console.log(p_line.include_field_ex)
                                // console.log(component_x.inputCategory)
                            }


                            else {


                                // component_x.include_item = "6"
                                //Loop products
                                component_x.levelData = []
                                promo_data.promo_lines.map(product => {

                                    component_x.selectedProd.push(product.product_id)

                                    if (product.include_field != "all") {
                                        var product_desc = product.description.split("||")
                                        component_x.selectedProductData.push({
                                            product_id: product.product_id,
                                            required_value: 1,
                                            promo_value: "",
                                            name: product_desc[1],
                                            retail_price: product.original_price,
                                            barcode: product.product.barcode,
                                            reference_code: component_x.getProductField(product, 'reference_code', product.include_value),
                                            stock_no: product.stock_no,
                                            // round_to_nearest: 1,
                                            round_to_nearest: 1,
                                            max_application: component_x.positiveIntegerValueFromStoredLimit(product.quantity)
                                        })
                                    }
                                })

                            }

                            // Process promos.promo_text //
                            let header_ptext = promo_data.promo_text

                            // Remove starting "QR"
                            let cleaned = header_ptext.replace(/^(QR|AR|DR)/, "");

                            if (header_ptext.startsWith("QR")) {
                                this.promo.group_discount_type = "1";
                            } else if (header_ptext.startsWith("AR")) {
                                this.promo.group_discount_type = "2";
                            } else if (header_ptext.startsWith("DR")) {
                                this.promo.group_discount_type = "3";
                            }


                            // Extract round if present (e.g., ^2)
                            let round = 1;
                            if (cleaned.indexOf("^") !== -1) {
                                const parts = cleaned.split("^");
                                cleaned = parts[0];         // left side → promo text
                                round = parts[1] || 1;      // right side → round (fallback to 1)
                            }

                            let gDiscLevel = ""
                            // Continue your original parsing
                            if (this.promo.group_discount_type == "1") {
                                gDiscLevel = cleaned
                                    .replace(/,/g, "")             // remove all commas
                                    .split("%")                    // split by %
                                    .filter(Boolean)               // remove empty parts
                                    .map((part, index) => {
                                        const split = part.split(":");
                                        const qty = split[0];
                                        const discount = split[1];
                                        return {
                                            key: index + 1,
                                            qty: qty,
                                            discount: discount
                                        };
                                    });
                            } else if (this.promo.group_discount_type == "2") {
                                gDiscLevel = cleaned
                                    .replace(/,/g, "")             // remove all commas
                                    .split("%")                    // split by %
                                    .filter(Boolean)               // remove empty parts
                                    .map((part, index) => {
                                        const split = part.split(":");
                                        const amt = split[0];
                                        const discount = split[1];
                                        return {
                                            key: index + 1,
                                            amount: amt,
                                            discount: discount
                                        };
                                    });
                            } else {
                                gDiscLevel = cleaned
                                    .split(",")                    // split by ,
                                    .filter(Boolean)               // remove empty parts
                                    .map((part, index) => {
                                        const split = part.split(":");
                                        const amt = split[0];
                                        const discount = split[1];
                                        return {
                                            key: index + 1,
                                            amount: amt,
                                            discount: discount
                                        };
                                    });
                            }


                            // let gDiscLevel = header_ptext.replace(/^QR/, "")        // remove starting "QR"
                            //     .replace(/,/g, "")        // remove all commas
                            //     .split("%")                        // split by %
                            //     .filter(Boolean)                   // remove empty parts
                            //     .map((part, index) => {
                            //         const [qty, discount] = part.split(":");
                            //         return {
                            //             key: index + 1,
                            //             qty: qty,
                            //             discount: discount
                            //         };
                            //     });
                            this.promo.round = round
                            this.groupLevelData = gDiscLevel
                            this.groupLevelDataFilter = gDiscLevel
                            this.groupLevelCount = gDiscLevel.reduce((max, item) => Math.max(max, Number(item.key) || 0), 0) + 1
                            this.groupLevelKey++

                        }
                        // if(component_x.promo.reward_type == 1 )

                        //Populate the customer types
                        //Arvin
                        component_x.customer_type = promo_data.card_type_included
                        if (promo_data.card_type_included.includes("$")) {
                            component_x.customer_type = promo_data.card_type_included
                        } else {
                            component_x.customer_type = 'S'
                            component_x.customer_card_type_ids = promo_data.card_type_included.split(",").map(id => id.toString());
                        }
                        delete component_x.promo.card_type_included

                        //Populate the payment types
                        //Arvin
                        // if(Object.keys(promo_data.payment_types).length > 0){
                        //     let payment_type = promo_data.payment_types
                        //     component_x.payment_type_ids = payment_type.payment_type_ids
                        // }
                        // delete component_x.promo.payment_types

                        // if(Object.keys(promo_data.additional_options).length > 0){
                        //     let additional_options = promo_data.additional_options
                        //     if(additional_options.max_application == component_x.reward.max_application){
                        //         component_x.is_no_of_times = false
                        //     } else {
                        //         component_x.reward.max_application = additional_options.max_application
                        //         component_x.is_no_of_times = true
                        //     }

                        //     if(additional_options.round_to_nearest == component_x.reward.round_to_nearest){
                        //         component_x.is_round_result = false
                        //     } else {
                        //         component_x.is_round_result = true
                        //         component_x.reward.round_to_nearest = additional_options.round_to_nearest
                        //     }
                        //     component_x.apply_discount = additional_options.reward_applied_to
                        //     component_x.is_compute_progressively = additional_options.is_compute_progressively
                        // }
                        // delete component_x.promo.additional_options

                        component_x.selectedRowKeys = [];

                        component_x.selectedRowKeys = promo_data.site_ids
                            .map(siteId => component_x.normalizeSiteId(siteId))
                            .filter(siteId => siteId !== null)

                        let sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites", null);
                        component_x.locationTreelength = sites.length
                        if (component_x.selectedRowKeys.length < component_x.locationTreelength) {
                            component_x.site_selection = "S"
                        }

                        // compare this later with the new params
                        component_x.oldPromoSites = promo_data.site_ids
                            .map(siteId => component_x.normalizeSiteId(siteId))
                            .filter(siteId => siteId !== null)

                        delete component_x.promo.site_ids

                    } else {
                        if (promo_data["error"] != undefined) this.errors = promo_data["error"].split(",");
                    }
                }
            }
            this.spinning = false
        }

        this.checkImportJobs();
    },
    watch: {
        // PromoV2 Coupon Promo rule: when BASED ON becomes "Receipt Amount",
        // force the item selection to "All Item" (include_item '1'). The field
        // is disabled via the couponItemSelectionLocked computed. Switching to
        // another basis leaves include_item as-is and re-enables the field (the
        // computed turns false), so the user can pick an item option again.
        // Applies on create (user selects Receipt Amount) and on edit load (the
        // saved base_on is assigned, which changes this value and triggers here),
        // so an invalid saved selection is corrected immediately.
        'promo.computed_coupon_base_on': function (value) {
            if (couponBasedOnReceiptAmount(this.promo.promo_type, value) && this.include_item != COUPON_ALL_ITEM_KEY) {
                this.include_item = COUPON_ALL_ITEM_KEY;
            }
        },

        selectedRowKeys(newKeys) {
            // debug - log the new selected keys whenever they change
            console.log("selected keys updated wasup: ", newKeys);
        },

        is_specify_date: function () {
            if (this.is_specify_date == false) {
                this.valid_days = {
                    sun: true, mon: true, tue: true,
                    wed: true, thu: true, fri: true, sat: true
                }
            }
        },
        activeKey: function () {
            if (this.activeKey == 1 || this.activeKey == '1') {
                this.allProductsData()
            }
        },
        is_specify_time: function () {
            if (this.is_specify_time == false) {
                this.picker_date = {
                    valid_start_time: this.createTimeMoment('00:00'),
                    valid_end_time: this.createTimeMoment('23:59'),
                }
            }
        },
        is_coupon_limit_printing: function () {
            if (this.is_coupon_limit_printing == false) {
                this.coupon.coupon_maximum = null
                this.coupon.is_coupon_print_one = false
            } else {
                if (this.coupon.coupon == "") {
                    this.coupon.coupon_maximum = 1
                }
            }
        },
        get_y_type: function () {
            if (this.get_y_type == 'FB') {
                this.reward.get_y_la = 0;
                this.reward.get_y_po = 0;
                this.reward.get_y_lp = 0;
                this.reward.get_y_lp_round = 0;
            } else if (this.get_y_type == 'LA') {
                this.reward.get_y_po = 0;
                this.reward.get_y_lp = 0;
                this.reward.get_y_lp_round = 0;
            } else if (this.get_y_type == 'PO') {
                this.reward.get_y_la = 0;
                this.reward.get_y_lp = 0;
                this.reward.get_y_lp_round = 0;
            } else {
                this.reward.get_y_la = 0;
                this.reward.get_y_po = 0;
            }
        },
        get_x_type: function () {
            if (this.get_x_type == 'LSP') {
                this.reward.get_x_la = 0
                this.reward.get_x_po = 0
            } else if (this.get_x_type == 'LSA') {
                this.reward.get_x_lp = 0
                this.reward.get_x_po = 0
            } else {
                this.reward.get_x_lp = 0
                this.reward.get_x_la = 0
            }
        },
        'reward.apply_level': function () {
            if (this.reward.apply_level == 'IL') {
                this.isUpdatePromoRewardAndCondition = true;
                this.reward.apply_discount = "IL"
            }
        },
        // 'promo.compute_mode': function(){
        //     this.promo.reward_trigger_amount = null
        //     this.promo.reward_trigger_frequency = null
        // },
        // promo: {
        //   handler(val){
        //     console.log(">>>> Val")
        //     console.log(val)
        //     if ( val.status == 'A' && this.$refs.uploadProductKey.fileList[0]) {
        //       this.$refs.uploadProductKey.removeFile();
        //       this.openNotificationWithIcon('error', "Upload product CSV file has been removed. You can't upload product for active promotions.")
        //     }
        //     this.canUploadProduct = this.showUploadCSVButton();
        //   },
        //   deep: true
        // },
        site_selection: function (value) {
            if (value == 'A') {
                this.removeValidationError('Please select at least 1 site.');
            }
        },
        include_item: async function (value, oldValue) {
            if (oldValue != undefined && value != oldValue) {
                this.isUpdatePromoRewardAndCondition = true;
                this.clearApplyStepValidationErrors();
            }

            if (this.promo.promo_type == '1' && this.include_item == '6') {
                this.canUploadProduct = this.showUploadCSVButton();
            }
            if (this.include_item == '5' || this.include_item == '2') {
                console.log("Item Except....")
                console.log(this.supplierOptions)
                console.log(this.brandOptions)
                console.log(this.categoriesOptions)

                if (this.supplierOptions.length == 0) {
                    let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                    this.supplierOptions = suppliers
                    this.sort(this.supplierOptions);
                }

                if (this.brandOptions.length == 0) {
                    let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?mode=all", null, null)
                    this.brandOptions = brands
                    this.sort(this.brandOptions);
                }

                if (this.categoriesOptions.length == 0) {
                    //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                    let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                    this.updateCategoriesOptions(options)
                }
            } else if (this.include_item == '4') {

                if (this.categoriesOptions.length == 0) {

                    let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                    this.categoriesOptions = options
                    this.updateCategoriesOptions(options)
                }
            }
        },
        current(newVal) {
            // Promo Coupon
            if (1 == newVal && this.promo.promo_type == '5') {
                this.includeItemOptions = this.includeItemOptions.filter(
                    item => ['1', '6'].includes(item.key)
                )
            }
        },
    },
    data: function () {
        return {
            errorId: 0,
            promoExceptionKey: 0,
            promoExceptions: [],
            inputCategoryKey: 0,
            includeItemOptionsKey: 0,
            discountLabel: "Group Discount - Less Percent",
            selectedProductBRefKey: 0,
            searchQuery: '',
            filteredLocationData: [],
            hasSiteSearchResults: true,
            siteCodesInput: '',
            notifMessage: [],
            selectedSites: [],
            isModalVisible: false,
            promoData: {},
            filterKey: 0,
            filterParams: {},
            toggleAdvanceFilter: false,
            toggleLabel: "Advanced Filter",
            currentFilter: "category_id",
            massUpdateMode: false,
            parentParams: {},
            tags: [],
            advanceFilterParamsText: '',
            canUploadProduct: false,
            openUploadProductsDrawer: false,
            uploadedProductFileMode: false,
            itemSelectionDrawerVisible: false,
            groupBonusItemDrawerVisible: false,
            groupBonusItemDrawerMode: 'prerequisite',
            openPromoExceptionsDrawer: false,
            showAddedProductTabulator: true,

            modalVisible: false,
            modalAvailableFields: false,
            confirmLoading: false,
            massDiscount: '',
            massLimit: '',
            massRound: '',
            massRequired: '',
            locationTreelength: 0,
            refKey: 0,
            keyComp: 0,
            levelData: [],
            groupLevelData: [],
            levelDataFilter: [],
            grouplevelDataFilter: [],
            groupLevelColumns: [
                {
                    title: 'MIN. QTY',
                    dataIndex: 'qty',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'qty'
                    },
                },
                {
                    title: '% DISCOUNT',
                    dataIndex: 'discount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'discount'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            groupLevelColumns2: [
                {
                    title: 'MIN. AMOUNT',
                    dataIndex: 'amount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'amount'
                    },
                },
                {
                    title: '% DISCOUNT',
                    dataIndex: 'discount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'discount'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            groupLevelColumns3: [
                {
                    title: 'MIN. AMOUNT',
                    dataIndex: 'amount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'amount'
                    },
                },
                {
                    title: 'AMOUNT DISCOUNT',
                    dataIndex: 'discount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'discount'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            levelColumns: [
                {
                    title: 'QUANTITY',
                    dataIndex: 'qty',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'qty'
                    },
                },
                {
                    title: 'PRICE IS',
                    dataIndex: 'price',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'price'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            levelRelativeColumns: [
                {
                    title: 'QUANTITY',
                    dataIndex: 'qty',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'qty'
                    },
                },
                {
                    title: 'DISCOUNT (%)',
                    dataIndex: 'discount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'discount'
                    },
                },
                {
                    title: 'PRICE IS',
                    dataIndex: 'price',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'price'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            levelGDCount: 1,
            levelGDData: [],
            levelGDDataFilter: [],
            levelGDColumns: [
                {
                    title: '',
                    dataIndex: 'amount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'amount'
                    },
                },
                {
                    title: '',
                    dataIndex: 'percentOrAmount',
                    width: '35%',
                    scopedSlots: {
                        customRender: 'percentOrAmount'
                    },
                },
                {
                    title: '',
                    dataIndex: 'operation',
                    scopedSlots: {
                        customRender: 'operation'
                    },
                }
            ],
            checkboxGDLabel: "",
            gbCheckboxValue: false,
            changeDisplayB: false,
            searchTextB: '',
            filterCaptionB: "Search by Name",
            filterFieldB: "name",

            changeDisplay: false,
            searchText: '',
            filterCaption: "Search by Name",
            filterField: "name",

            changeDisplay1: false,
            searchText1: '',
            filterCaption1: "Search by Name",
            filterField1: "name",

            levelCount: 1,
            groupLevelKey: 0,
            groupLevelCount: 1,
            activeProductId: 0,
            activeProductName: "",
            activeProductOriginalPrice: 0,
            coupon: {
                coupon_required: "1",
                coupon_amount: "100",
                coupon_expired: moment().endOf('day'),
                coupon_maximum: "",
                coupon_message: "****************************************\nCongratulations!  You have won a free\ngift certificate worth {egc_amount}.\n\nThis coupon is valid until: {coupon_expiry}\n\n{coupon_barcode}\n\nNo. {site_code}-{terminal_code}-{or_no}-{seq_no}\n{date}/{time}\n****************************************\n",
                is_coupon_print_one: false
            },
            is_coupon_limit_printing: false,
            coupon_description: "Enter quantity required to activate promo",
            spinning: false,
            promo: {
                reward_type: '1',
                priority_level: 1,
                promo_type: this.$attrs.promoType,
                start_at: moment().startOf('day'),
                end_at: moment().endOf('day'),
                status: 'A',
                apply_level: "exclusive",
                payment_type_code: 'CASH',
                compute_mode: 'every',
                remark: '1',
                group_discount_type: '1',

                promo_text: '',
                reward_trigger_amount: 1000,

                // Coupon
                reward_coupon_text: '***********************************************\nCongratulations!\nYou have won a free gift\ncertificate\nThis coupon is valid until: {expiry_date}\nNo.{site_code}-{terminal_code}-{or_no}-{seq_no}\n{date}/{time}\n**********************************************',
                computed_coupon_base_on: 'selected_items_amount',
                computed_coupon_limit: 0,
                computed_coupon_print_as_one: false,
                computed_trigger_amount: 1000,
                computed_trigger_label: 'for_minimum_purchase',
                coupon_text_attributes: `
{site_code}-Site Code
{terminal_code}-Terminal No
{trans_id}-Transaction No
{or_no}-Receipt No
{seq_no}-Sequence No
{date}-Date Printed
{time}-Time Printed
{cashier}-Cashier name
{customer_code}-Card No.
{amount_due}-Amount Due
{promo_name}-Promo Name
{expiry_date}-Expiry Date of coupon
{coupon_count}-Count value of coupons when using 'Print as one' option
to add barcode in coupon print out use opening tag <barcode> and closing tag </barcode>
ex. <barcode>99102910&lt</barcode>
To add qrcode in coupon print out use the opening tag <qr_code>
and closing tag </qr_code>
ex. <qr_code>https://qr-creator.com/mobi/Ncy&lt;</qr_code>;
Format options:
{BOLD}-Sets the character in its right to bold font.
{NORMAL}-Sets the character in its right to normal font.`
            },
            reward: {
                max_application: 1000,
                round_to_nearest: 0,
                apply_discount: "IL",
                apply_level: "IL",
                apply_header: "IL",
                required_value: 1,
                get_y_lp: 0,
                get_y_lp_round: 0,
                get_y_la: 0,
                get_y_po: 0,
                get_x_lp: 0,
                get_x_lp_round: 0,
                get_x_la: 0,
                get_x_po: 0
            },
            get_y_type: 'LP',
            get_x_type: 'LSP',
            allItem: {
                supplier_id: [],
                brand_id: []
            },
            reward_type_description: "",
            picker_date: {
                valid_start_time: moment().startOf('day'),
                valid_end_time: moment().startOf('day').hour(23).minute(59).second(0),
            },
            exceptBrand: [],
            exceptSupplier: [],
            exceptCategory: [],
            discount: "1",
            max_application_all: 0,
            typeVisible: false,
            site_selection: 'A',
            site_ids: [],
            productLocationData: [],
            oldPromoSites: [],
            isUpdatePromoSite: false,
            isUpdatePromoRewardAndCondition: false,
            selectedRowKeys: [],
            siteOptions: [],
            customer_card_type_ids: [],
            customerCardTypeOptions: [],
            customer_type: '$ALL$',
            is_specify_time: false,
            is_specify_date: false,
            is_no_of_times: false,
            is_round_result: false,
            is_compute_progressively: false,
            valid_days: {
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: true,
                sun: true
            },
            include_item: "1",
            includeItemOptions: [
                { key: "1", value: "All Items" },
                { key: "2", value: "All Items from a Specific Supplier" },
                { key: "3", value: "All Items from a Specific Brand" },
                { key: "4", value: "All Items from a Specific Category" },
                { key: "5", value: "All Items Except" },
                { key: "6", value: "Select Specific Items" }
            ],
            includeItemGroupDiscountOptions: [
                { key: "1", value: "All Items" },
                { key: "2", value: "All Items Except" },
                { key: "3", value: "All Items Inclusive" },
                { key: "4", value: "All Items from a Specific Supplier" },
                { key: "5", value: "All Items from a Specific Brand" },
                { key: "6", value: "All Items from a Specific Category" },
                { key: "7", value: "Select Specific Items" }
            ],
            priotizedDiscountedCriteria: false,
            coupleType: "",
            coupleTypeOptions: [
                { key: "1", value: "Higher - Lower" },
                { key: "2", value: "First - Second" }
            ],
            inputCategory: [],
            showAdvancedInfo: false,
            dateFormat: "MM/DD/YYYY",
            // Date + time display format for the start/end datetime pickers.
            // Matches the convention in SalesChannelPromotionForm.vue so the
            // full selected time is captured (not truncated to start-of-day).
            dateTimeFormat: "MM/DD/YYYY hh:mm:ss a",
            itemPoolOptions: [
                { key: "1", value: "Percent Discount" },
                { key: "2", value: "Amount Discount" },
                { key: "3", value: "Change Price" },
                // {key: "5", value: "Buy X Take Y"},
                { key: "4", value: "Relative Pricing" },
                { key: "5", value: "Bundle Pricing" },
                { key: "6", value: "Buy X Take X" }
            ],
            discountTypeOptions: [
                { key: "1", value: "Percent Discount" },
                { key: "2", value: "Amount Discount" },
                { key: "3", value: "Change Price" },
            ],
            pwpOptions: [
                { key: "1", value: "Percent Discount" },
                { key: "2", value: "Amount Discount" },
                { key: "3", value: "Change Price" }
            ],
            conditionalOptions: [
                { key: "1", value: "Buy any get any" },
            ],
            groupDiscountOptions: [
                { key: "1", value: "Group Discount" },
            ],
            multiLevelTypeOptions: [
                { key: "1", value: "Discount with No Requirements (Default)" },
                { key: "2", value: "Discount with Minimum Amount" },
                { key: "3", value: "Discount with Required Quantity" },
            ],
            buyXOptions: [
                // {key: "1", value: "Buy X Take X"},
                { key: "2", value: "Buy X Take Y" }
            ],
            pricingOptions: [
                { key: "1", value: "Tiered Pricing" },
                { key: "2", value: "Volume Pricing" },
                { key: "3", value: "Bundle Pricing" }
            ],
            couponOptions: [
                { key: "1", value: "Generate Coupon with Required Quantity" },
                { key: "2", value: "Generate Coupon with Required Amount" }
            ],
            // condtionalOptions: [
            //     {key: "1", value: "Buy all get X"},
            //     {key: "2", value: "Buy any get any"},
            //     {key: "3", value: "Pool"}
            // ],
            // groupDiscountOptions: [
            //     {key: "1", value: "Simple Percentage Discount"},
            //     {key: "2", value: "Percentage Discount based on Bracket"},
            //     {key: "3", value: "Amount Discount For Every Sold Value"}
            // ],
            replaceDiscountKey: null,
            PoolOptionKey: "TQ",
            PoolOptionValue: null,
            exceptionText: "CA",
            exceptionOptions: [
                { key: 'CA', value: 'Category' },
                { key: 'SP', value: 'Supplier' },
                { key: 'BR', value: 'Brand' }
            ],
            exceptionValue: null,
            supplierOptions: [],
            brandOptions: [],
            selectedProd: [],
            selectedProdB: [],
            productData: [],
            productDataB: [],

            promoExceptionsOptions: [
                { title: 'Exception Type', dataIndex: 'exception_type_display', key: 'exception_type_display' },
                { title: "Exception Value", dataIndex: "exception_type_display", key: "exception_value", scopedSlots: { customRender: "render-select" } },
                { title: "Action", dataIndex: "exception_value", key: "action", scopedSlots: { customRender: "render-action" } }
            ],

            // promoExceptionsOptions:{
            //     height: "100%",
            //     pagination:"remote",
            //     paginationDataSent:{
            //         "page":"page",
            //         "size":"per_page"
            //     },
            //     paginationSize:10,
            //     columns: [
            //         {
            //             title:'Type',
            //             field:'exception_type_display',
            //             width:"50%",
            //             headerSort: false
            //         },
            //         {
            //             title:'Value',
            //             field:'exception_value_display',
            //             width:"50%",
            //             headerSort: false 
            //         },
            //     ]
            // },
            productOptions: {
                height: "100%",
                pagination: "remote",
                paginationDataSent: {
                    "page": "page",
                    "size": "per_page"
                },
                paginationSize: 10,
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'STOCK NO.',
                        field: 'stock_no',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'BRAND',
                        field: 'brand_name',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "10%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: '',
                        width: "10%",
                        headerSort: false,
                        formatter: this.addButton,
                        cellClick: this.selectProduct,
                        align: 'center'
                    }
                ]
            },
            productOptionsGD: {
                height: "100%",
                pagination: "remote",
                paginationDataSent: {
                    "page": "page",
                    "size": "per_page"
                },
                paginationSize: 10,
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'STOCK NO.',
                        field: 'stock_no',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'BRAND',
                        field: 'brand_name',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "10%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: '',
                        width: "10%",
                        headerSort: false,
                        formatter: this.addButton,
                        cellClick: this.selectProduct,
                        align: 'center'
                    }
                ]
            },
            productOptionsB2: {
                height: "100%",
                pagination: "remote",
                paginationDataSent: {
                    "page": "page",
                    "size": "per_page"
                },
                paginationSize: 10,
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'STOCK NO.',
                        field: 'stock_no',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "20%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: '',
                        width: "10%",
                        headerSort: false,
                        formatter: this.addButtonB,
                        cellClick: this.selectProductB,
                        align: 'center'
                    }
                ]
            },
            productOptionsB: {
                height: "100%",
                pagination: "remote",
                paginationDataSent: {
                    "page": "page",
                    "size": "per_page"
                },
                paginationSize: 10,
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'STOCK NO.',
                        field: 'stock_no',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "20%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: '',
                        width: "10%",
                        headerSort: false,
                        formatter: this.addButtonB,
                        cellClick: this.selectProductB,
                        align: 'center'
                    }
                ]
            },
            schemeOptions: {
                height: "100%",
                selectable: 1,
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            component_x.setActiveProductRow(cell.getRow());
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "15%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'LIMIT',
                        field: 'max_application',
                        width: "15%",
                        headerSort: false,
                        editor: this.positiveIntegerCellEditor
                    },
                    // RC 2025/03/11 - Remove for Relative/Bundle/Buy X Take Y #309
                    // {
                    //     title: 'ROUND',
                    //     field: 'round_to_nearest',
                    //     width: "15%",
                    //     headerSort: false,
                    //     editor: "input"
                    // },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        formatter: this.printIcon,
                        field: 'action',
                        width: "15%",
                        headerSort: false
                    },
                ],
                rowSelectionChanged: function (data, rows) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                    if (rows.length > 0) {
                        component_x.setActiveProductRow(rows[rows.length - 1]);
                        return;
                    }

                    component_x.activeProductId = 0;
                    component_x.activeProductName = "";
                    component_x.activeProductOriginalPrice = 0;
                    component_x.levelDataFilter = [];
                },
            },
            preReqOptions2: {
                height: "100%",
                selectable: 1,
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "40%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'QUANTITY',
                        field: 'quantity',
                        width: "15%",
                        headerSort: false,
                        editor: "input"
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "15%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    }
                ]
            },
            preReqOptions: {
                height: "100%",
                selectable: 1,
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "40%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "30%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    }
                ]
            },
            couponHeaderOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "50%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "20%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            couponLineOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "15%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'QUANTITY',
                        field: 'required_value',
                        width: "10%",
                        headerSort: false,
                        editor: "input"
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedProductData: [],
            selectedProductDataB: [],
            selectedProductOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                paginationSizeSelector: [10, 20, 30, 40, 50],
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "35%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "10%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "10%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'PERCENT DISCOUNT',
                        field: 'promo_value',
                        width: "10%",
                        headerSort: false,
                        editor: this.wholeNumberCellEditor,
                        align: 'center'
                    },
                    {
                        title: 'LIMIT',
                        field: 'max_application',
                        width: "10%",
                        headerSort: false,
                        editor: this.positiveIntegerCellEditor,
                        align: 'center'
                    },
                    {
                        title: 'ROUND',
                        field: 'round_to_nearest',
                        width: "10%",
                        headerSort: false,
                        editor: this.nonNegativeIntegerCellEditor,
                        align: 'center'
                    },
                    {
                        title: 'QUANTITY',
                        field: 'quantity',
                        width: "10%",
                        headerSort: false,
                        formatter: this.quantityAmount,
                        editor: "input",
                        align: 'right',
                        visible: false
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedProductOptionsGD: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                paginationSizeSelector: [10, 20, 30, 40, 50],
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "35%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "10%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "10%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedInlineProductOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'Barcode',
                        field: 'barcode',
                        width: "20%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "10%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'PERCENT DISCOUNT',
                        field: 'promo_value',
                        width: "20%",
                        headerSort: false,
                        editor: this.wholeNumberCellEditor,
                        align: 'center'
                    },
                    {
                        title: 'ROUND',
                        field: 'round_to_nearest',
                        width: "10%",
                        headerSort: false,
                        editor: this.nonNegativeIntegerCellEditor,
                        align: 'center'
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedBuyXGetXProductOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "25%",
                        headerSort: false
                    },
                    {
                        title: 'Barcode',
                        field: 'barcode',
                        width: "10%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "15%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'BUY QTY',
                        field: 'required_value',
                        width: "15%",
                        headerSort: false,
                        editor: "input"
                    },
                    {
                        title: 'TAKE QTY',
                        field: 'promo_value',
                        width: "15%",
                        headerSort: false,
                        editor: this.wholeNumberCellEditor
                    },
                    {
                        title: 'LIMIT',
                        field: 'max_application',
                        width: "10%",
                        headerSort: false,
                        editor: this.positiveIntegerCellEditor
                    },
                    // RC 2025/03/11 - Remove for Relative/Bundle/Buy X Take Y #309
                    // {
                    //     title: 'ROUND',
                    //     field: 'round_to_nearest',
                    //     width: "5%",
                    //     headerSort: false,
                    //     editor: "input"
                    // },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedListBProductOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'BARCODE',
                        field: 'barcode',
                        width: "25%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "20%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'QUANTITY',
                        field: 'required_value',
                        width: "15%",
                        headerSort: false,
                        editor: "input"
                    },
                    {
                        title: '',
                        field: '',
                        width: "10%",
                        headerSort: false
                    }
                ]
            },
            selectedBuyXGetYProductOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        formatter: "rowSelection",
                        titleFormatter: "rowSelection",
                        hozAlign: "center",
                        headerSort: false,
                        titleFormatterParams: {
                            rowRange: "active" //only toggle the values of the active filtered rows
                        },
                        cellClick: function (e, cell) {
                            cell.getRow().toggleSelect();
                        },
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "30%",
                        headerSort: false
                    },
                    {
                        title: 'Barcode',
                        field: 'barcode',
                        width: "15%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "25%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                    {
                        title: 'QUANTITY',
                        field: 'required_value',
                        width: "25%",
                        headerSort: false,
                        editor: "input"
                    },
                    {
                        title: 'ACTION',
                        align: 'center',
                        formatter: this.addDeleteButton,
                        width: "10%",
                        cellClick: this.selectProductAction,
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ],
                rowSelectionChanged: function (data) {
                    //update selected row counter on selection change
                    component_x.selectedRowCount = data.length;
                },
            },
            selectedGetYProductOptions: {
                height: "100%",
                pagination: "local",
                paginationSize: 10,
                columns: [
                    {
                        title: 'NAME',
                        field: 'name',
                        width: "50%",
                        headerSort: false
                    },
                    {
                        title: 'RETAIL PRICE',
                        field: 'retail_price',
                        width: "50%",
                        headerSort: false,
                        formatter: this.retailPrice,
                        align: 'right'
                    },
                ]
            },
            exceptData: [],
            exceptOptions: {
                height: "100%",
                paginationSize: 10,
                pagination: "local",
                columns: [
                    {
                        title: 'EXCEPTION',
                        field: 'field_text',
                        width: "25%",
                        headerSort: false
                    },
                    {
                        title: '',
                        field: 'id_text',
                        width: "25%",
                        headerSort: false
                    },
                    {
                        title: '',
                        field: '',
                        width: "5%",
                        headerSort: false
                    }
                ]
            },
            couponAvailableFieldsData: [
                { fields: 'terminal_id', description: "Terminal Id" },
                { fields: 'terminal_code', description: "Terminal No." },
                { fields: 'trans_number', description: "Transaction No." },
                { fields: 'trans_date', description: "Transaction Date" },
                { fields: 'trans_time', description: "Transaction Time" },
                { fields: 'or_no', description: "Receipt No." },
                { fields: 'site_code', description: "Site Code" },
                { fields: 'cashier', description: "Cashier Name" },
                { fields: 'customer_code', description: "Card No." },
                { fields: 'customer_name', description: "Customer Name" },
                { fields: 'amount_due', description: "Amount Due" },
                { fields: 'reprinted', description: "If Coupon is reprinted" },
                { fields: 'expiry_date', description: "Expiry Date of coupon" }
            ],
            couponAvailableFieldsOption: {
                columns: [
                    {
                        title: 'Field Name',
                        field: 'fields',
                        width: "50%",
                        headerSort: false
                    },
                    {
                        title: 'Description',
                        field: 'description',
                        width: "50%",
                        headerSort: false
                    }]
            },
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
            searchFilter: "name",
            current: 0,
            fetching: false,
            getYData: [],
            payment_type_code: "ALL",
            payment_type_ids: [],
            paymentTypeOptions: [],
            is_ref_code: false,
            viewOnly: false,
            errors: [],
            doneLoading: false,
            promotionId: 0,
            exportFileName: `${'Promotion'}-${moment().format('YYYYMMDDHHmmss')}`,
            csvHeaders: {},
            exportData: [],
            tempItemListData: [],
            selectedRowCount: 0,
            activeKey: '1',
            isCouponTextCollapsed: false
        }
    },
    methods: {
        ...mapActions(['updateCategoriesOptions']),
        moment,
        changeParams(params, actualParams, mode) {
            this.tags = []
            var parametersCopy = this.parentParams
            var mergedParameters = Object.assign({}, parametersCopy, params);

            this.params = mergedParameters
            this.filterParams = actualParams
            this.massUpdateMode = mode
            const defaultFilters = ["status", "is_non_trade", "stock_status", "category_name",
                "supplier_name", "start_at", "brand_names", "tag_names", "sub_brand_names", "product_group_names",
                "inputCategory", "inputBrand", "inputSubBrand", "inputProductGroup", "inputSupplierType", "inputSupplier", "inputDate",
                "statusFilter", "inputTag", "dateString", "isNonTrade", "stockStatus", "inputProductSeriesName", "product_series_name", "inputProductSeriesDate", "product_series_date"]

            if (Object.keys(this.parentParams)[0] != undefined) {
                this.tags.push(Object.keys(this.parentParams)[0] + ":" + Object.values(this.parentParams)[0])
            }

            this.advanceFilterParamsText = ''
            Object.keys(params).forEach(function (key) {
                if (!defaultFilters.includes(key)) {
                    component_x.tags.push(`${key}: ${params[key]}`)
                    component_x.advanceFilterParamsText += `&${key}=${params[key]}`
                }
            })

            if (params["status"] != undefined) {
                switch (params["status"]) {
                    case "A":
                        this.tags.push("Status: Active")
                        break;
                    case "I":
                        this.tags.push("Status: Inactive")
                        break;
                    case "P":
                        this.tags.push("Status: Phased Out")
                        break;
                }
            }

            if (params["is_non_trade"] != undefined) {
                this.tags.push("Non-trade: " + params["is_non_trade"])
            }

            if (params["stock_status"] != undefined) {
                switch (params["stock_status"]) {
                    case "1":
                        this.tags.push("Stock: Out of Stock")
                        break;
                    case "2":
                        this.tags.push("Stock: On Stock")
                        break;
                    case "3":
                        this.tags.push("Stock: Negative Stock")
                        break;
                }
            }

            if (params["category_name"] != undefined) {
                this.tags.push("Category: " + params["category_name"])
            }

            if (params["supplier_name"] != undefined) {
                this.tags.push("Supplier: " + params["supplier_name"])
            }

            if (params["start_at"] != undefined) {
                this.tags.push("Price Change Date: " + params["start_at"] + " to " + params["end_at"])
            }

            if (params["brand_names"] != undefined) {
                for (var i = 0; i < params["brand_names"].length; i++) {
                    this.tags.push("Brand: " + params["brand_names"][i])
                }
            }

            if (params["tag_names"] != undefined) {
                for (var j = 0; j < params["tag_names"].length; j++) {
                    this.tags.push("Tag: " + params["tag_names"][j])
                }
            }

            if (actualParams == null) {
                this.params = {}
                this.parentParams = {}
                this.tags = []
            }

            if (this.groupBonusItemDrawerVisible) {
                if (this.groupBonusItemDrawerMode === 'bonus') {
                    this.allProductsDataBDrawer()
                } else {
                    this.allProductsDataGBDrawer()
                }
            } else if (this.itemSelectionDrawerVisible) {
                this.allProductsDataDrawer()
            } else {
                this.allProductsData()
            }
            this.advanceFilter(false);
        },
        disableInvalidEndDate(current) {
            if (!this.promo.start_at) return false;

            return current && current.isBefore(this.promo.start_at, 'day');
        },
        closeFilter() {
            this.advanceFilter(false)
        },
        advanceFilter(value) {
            this.toggleAdvanceFilter = value
            if (this.toggleAdvanceFilter == true) {
                this.toggleLabel = "Collapse Filter"
            } else {
                this.toggleLabel = "Advanced Filter"
            }
        },
        openItemSelectionDrawer() {
            this.itemSelectionDrawerVisible = true;
            this.$nextTick(() => {
                this.allProductsDataDrawer();
            });
        },
        closeItemSelectionDrawer() {
            this.itemSelectionDrawerVisible = false;
        },
        openGroupBonusItemDrawer(mode) {
            this.groupBonusItemDrawerMode = mode;
            this.groupBonusItemDrawerVisible = true;
            this.$nextTick(() => {
                if (mode === 'prerequisite') {
                    this.allProductsDataGBDrawer();
                } else {
                    this.allProductsDataBDrawer();
                }
            });
        },
        closeGroupBonusItemDrawer() {
            this.groupBonusItemDrawerVisible = false;
        },
        hasUploadedProductFile() {
            const uploadProduct = this.$refs.uploadProductKey;
            return Boolean(uploadProduct && uploadProduct.fileList && uploadProduct.fileList[0]);
        },
        productUploadReplacesManualInputs() {
            return true;
        },
        handleProductUploadFileChange({ hasFile }) {
            this.uploadedProductFileMode = hasFile;
            if (hasFile) {
                this.closeProductSelectionDrawers();
            }
            this.resetManualInputsReplacedByUpload();
            this.clearApplyStepValidationErrors();
        },
        closeProductSelectionDrawers() {
            this.itemSelectionDrawerVisible = false;
            this.groupBonusItemDrawerVisible = false;
        },
        resetManualInputsReplacedByUpload() {
            if (!this.productUploadReplacesManualInputs()) {
                return;
            }

            if (['1', '2', '5'].includes(this.promo.promo_type)) {
                this.discount = '';
                this.max_application_all = 0;
                this.allItem.supplier_id = [];
                this.allItem.brand_id = [];
                this.inputCategory = [];
                this.promoExceptions = [];
                this.selectedProductData = [];
                this.levelData = [];
                this.levelDataFilter = [];
                this.levelCount = 1;
                this.refKey++;
            } else if (this.promo.promo_type == '7') {
                this.promo.compute_mode = null;
                this.promo.reward_trigger_amount = '';
                this.promo.promo_text = '';
                this.promo.promo_discount = '';
                this.reward.round_to_nearest = 0;
                this.selectedProductData = [];
                this.selectedProductDataB = [];
                this.selectedProductBRefKey++;
                this.refKey++;
            } else if (this.promo.promo_type == '8') {
                this.coupleType = '';
                this.priotizedDiscountedCriteria = false;
                this.selectedProductData = [];
                this.reward.get_x_lp = '';
                this.reward.get_x_lp_round = 0;
                this.reward.get_x_la = '';
                this.reward.get_x_po = '';
                this.reward.get_y_lp = '';
                this.reward.get_y_lp_round = 0;
                this.reward.get_y_la = '';
                this.reward.get_y_po = '';
                this.refKey++;
            } else if (this.promo.promo_type == '9') {
                this.include_item = '1';
                this.allItem.supplier_id = [];
                this.allItem.brand_id = [];
                this.inputCategory = [];
                this.promoExceptions = [];
                this.selectedProductData = [];
                this.promo.group_discount_type = '1';
                this.promo.round = '';
                this.groupLevelData = [];
                this.groupLevelDataFilter = [];
                this.groupLevelCount = 1;
                this.refKey++;
                this.groupLevelKey++;
            }
        },
        toggleUploadProductsDrawer(bool) {
            if (bool && !(this.promo.status == 'I' || (this.promo.status == 'A' && !this.promo.id))) {
                this.$notification['error']({
                    message: 'Error',
                    description: "Only Inactive Promotions are allowed to upload Products"
                });

                return;
            }

            if (bool) {
                this.closeProductSelectionDrawers();
            }

            this.openUploadProductsDrawer = bool;
        },
        togglePromoExceptionsDrawer(bool) {
            this.openPromoExceptionsDrawer = bool;
        },
        showUploadCSVButton() {
            const promoType = this.promo.promo_type;
            const rewardType = this.promo.reward_type;
            //   return (((promoType == '1' && (rewardType == '3' || this.include_item == '6')) || ['2', '7', '8'].includes(promoType)) && !this.viewOnly)
            return (((promoType == '1' && (rewardType == '3' || this.include_item == '6')) || ['2', '8', '7', '9'].includes(promoType)) && !this.viewOnly)
        },
        showExportProductButton() {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(this.promo.promo_type));
        },
        clearExportJsonData() {

        },
        exportProduct() {
            const promoType = parseInt(this.promo.promo_type)
            let specialData = {}

            if (promoType == 2) {
                specialData = { applyLevel: this.reward.apply_level }
            }

            if (promoType == 6) {
                specialData = { coupleType: this.coupleType }
            }


            const data = exportProductCSV(
                promoType,
                this.promo.reward_type,
                this.selectedProductData,
                this.selectedProductDataB,
                specialData
            );

            const { csvHeaders, csvData } = data;

            this.csvHeaders = csvHeaders;
            this.exportData = csvData;

            setTimeout(() => { this.$refs.exportCsvBtn.click() }, 200)
        },
        addMassProducts(products) {
            const productIds = products.map(prod => prod.product_id);
            this.selectedProductData = [...this.selectedProductData, ...products];
            this.selectedProd = [...this.selectedProd, ...productIds];
            if (this.itemSelectionDrawerVisible) {
                this.allProductsDataDrawer()
            } else if (this.groupBonusItemDrawerVisible && this.groupBonusItemDrawerMode === 'bonus') {
                this.allProductsDataBDrawer()
            } else {
                this.allProductsData()
            }
        },
        replaceStatus(value) {
            this.keyComp++;
            this.promo.status = value;
        },
        changeFilter(value) {
            this.filterField = value
            this.filterCaption = "Filter By " + this._.startCase(this.filterField)
        },
        changeFilter1(value) {
            this.filterField1 = value
            value = (value == 'product_id') ? 'id' : value
            this.filterCaption1 = "Filter By " + this._.startCase(value)
        },
        changeFilterB(value) {
            this.filterFieldB = value
            value = (value == 'product_id') ? 'id' : value
            this.filterCaptionB = "Filter By " + this._.startCase(value)
        },
        //Group Levels
        groupLevelHandleAdd() {
            console.log(">>Triggered add")
            this.isUpdatePromoRewardAndCondition = true

            const groupLevelCount = this.groupLevelData.reduce((max, item) => Math.max(max, Number(item.key) || 0), 0) + 1;

            if (this.promo.group_discount_type == "1") {
                this.groupLevelData.push({
                    key: groupLevelCount,
                    qty: "",
                    discount: ""
                });

                this.groupLevelDataFilter.push({
                    key: groupLevelCount,
                    qty: "",
                    discount: ""
                });
            } else {
                this.groupLevelData.push({
                    key: groupLevelCount,
                    amount: "",
                    discount: ""
                });

                this.groupLevelDataFilter.push({
                    key: groupLevelCount,
                    amount: "",
                    discount: ""
                });
            }


            this.groupLevelEdit(groupLevelCount);
            this.groupLevelCount = groupLevelCount + 1;
            this.groupLevelKey++;

        },
        groupLevelOnDelete(key) {
            const dataSource = [...this.groupLevelData];
            const dataFilter = [...this.groupLevelDataFilter];
            this.groupLevelData = dataSource.filter(item => item.key !== key);
            this.groupLevelDataFilter = dataFilter.filter(item => item.key !== key);
            this.isUpdatePromoRewardAndCondition = true
            this.groupLevelKey++;
        },
        groupLevelEdit(key) {
            const newData = [...this.groupLevelData];
            const newDataFilter = [...this.groupLevelDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];
            if (target) {
                target.editable = true;
                targetFilter.editable = true;
                this.groupLevelData = newData;
                this.groupLevelDataFilter = newDataFilter;
            }
            console.log("---------")
            console.log(this.groupLevelDataFilter)
        },
        groupLevelHandleChangeTable(value, key, column) {
            const newData = [...this.groupLevelData];
            const newDataFilter = [...this.groupLevelDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];

            this.errors = [];
            if (target) {
                target[column] = value;
                targetFilter[column] = value;

                this.groupLevelData = newData;
                this.groupLevelDataFilter = newDataFilter;
            }

            this.isUpdatePromoRewardAndCondition = true
        },
        //levels
        levelOnDelete(key) {
            const dataSource = [...this.levelData];
            const dataFilter = [...this.levelDataFilter];
            this.levelData = dataSource.filter(item => item.key !== key);
            this.levelDataFilter = dataFilter.filter(item => item.key !== key);
            this.isUpdatePromoRewardAndCondition = true
        },
        levelHandleAdd() {
            this.isUpdatePromoRewardAndCondition = true
            if (this.activeProductId > 0) {
                const nextLevelKey = this.levelData.reduce((max, item) => {
                    return Math.max(max, Number(item.key) || 0);
                }, 0) + 1;
                const newLevelRow = {
                    key: nextLevelKey,
                    product_id: this.activeProductId,
                    original_price: this.activeProductOriginalPrice,
                    qty: "",
                    price: "",
                    discount: ""
                };

                this.levelData.push({
                    ...newLevelRow
                });

                this.levelDataFilter.push({
                    ...newLevelRow
                });

                this.levelEdit(nextLevelKey);
                this.levelCount = nextLevelKey + 1;
            } else {
                alert("Please click the product that you want to add level")
            }
        },
        levelEdit(key) {
            const newData = [...this.levelData];
            const newDataFilter = [...this.levelDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];
            if (target) {
                target.editable = true;
                targetFilter.editable = true;
                this.levelData = newData;
                this.levelDataFilter = newDataFilter;
            }
        },
        levelHandleChangeTable(value, key, column) {
            const newData = [...this.levelData];
            const newDataFilter = [...this.levelDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];

            this.errors = [];
            if (target) {
                target[column] = value;
                targetFilter[column] = value;

                const originalPrice = parseFloat(target.original_price) || 0;
                const discount = parseFloat(target.price) || 0;
                const bundleQty = parseFloat(target.qty) || 0;
                const isBundlePricing = this.promo.reward_type === '5';
                const discountToValidate = isBundlePricing && bundleQty > 0
                    ? discount / bundleQty
                    : discount;
                let hasError = false;

                console.log("Discount")
                console.log(target.discount != null)
                console.log("------")
                console.log(isBundlePricing)
                console.log(discountToValidate)
                console.log(originalPrice)

                if (discount <= 0 && target.price != null && target.price !== '') {
                    this.errors.push(`Discount must be greater than 0 for item ${target.name || key}.`);
                    hasError = true;
                }

                if (discountToValidate >= originalPrice) {
                    this.errors.push(`Discount cannot be greater than the original price for item ${target.name || key}.`);
                    hasError = true;
                }
                this.levelData = newData;
                this.levelDataFilter = newDataFilter;

                if (hasError) {
                    this.$notification['error']({
                        message: 'Error',
                        description: this.errors.join(",")
                    });
                }
            }

            this.isUpdatePromoRewardAndCondition = true
        },
        levelHandleChangeTableRelative(value, key, column) {
            const newData = [...this.levelData];
            const newDataFilter = [...this.levelDataFilter];
            const target = newData.find(item => key === item.key);
            const targetFilter = newDataFilter.find(item => key === item.key);

            // Clear previous errors for this item (optional, if you want per-key tracking)
            this.errors = [];

            if (target) {
                target[column] = value;
                targetFilter[column] = value;

                const originalPrice = parseFloat(target.original_price) || 0;
                const discount = parseFloat(target.discount) || 0;
                const bundleQty = parseFloat(target.qty) || 0;
                const isBundlePricing = this.promo.reward_type === '5' || this.promo.remark === '5';
                const discountToValidate = isBundlePricing && bundleQty > 0
                    ? discount / bundleQty
                    : discount;
                console.log("------")
                console.log(isBundlePricing)
                console.log(discountToValidate)
                let hasError = false;

                // console.log("Discount")
                // console.log(target.discount != null)

                if (discount <= 0 && target.discount != null && target.discount !== '') {
                    this.errors.push(`Discount must be greater than 0 for item ${target.name || key}.`);
                    hasError = true;
                }

                if (this.promo.remark === '1') {
                    // Percent discount
                    if (discount > 100) {
                        this.errors.push(`Discount rate cannot exceed 100% for item ${target.name || key}.`);
                        hasError = true;
                    }

                    if (!hasError) {
                        const discountRate = discount / 100;
                        target.price = parseFloat((originalPrice * (1 - discountRate)).toFixed(2));
                        targetFilter.price = target.price;
                    }

                } else {
                    // Amount discount
                    if (discountToValidate > originalPrice) {
                        this.errors.push(`Discount cannot be greater than the original price for item ${target.name || key}.`);
                        hasError = true;
                    }

                    if (!hasError) {
                        target.price = parseFloat((originalPrice - discountToValidate).toFixed(2));
                        targetFilter.price = target.price;
                    }
                }

                if (!hasError) {
                    this.levelData = newData;
                    this.levelDataFilter = newDataFilter;
                } else {
                    this.$notification['error']({
                        message: 'Error',
                        description: this.errors.join(",")
                    });
                }
            }

            this.isUpdatePromoRewardAndCondition = true;
        },

        //end levels
        levelGDOnDelete(key) {
            const dataSource = [...this.levelGDData];
            const dataFilter = [...this.levelGDDataFilter];
            this.levelGDData = dataSource.filter(item => item.key !== key);
            this.levelGDDataFilter = dataFilter.filter(item => item.key !== key);
            this.isUpdatePromoRewardAndCondition = true
        },
        levelGDHandleAdd() {
            this.isUpdatePromoRewardAndCondition = true
            const { levelGDCount } = this;
            this.levelGDData.push({
                key: levelGDCount,
                amount: "",
                percentOrAmount: ""
            });

            this.levelGDDataFilter.push({
                key: levelGDCount,
                amount: "",
                percentOrAmount: ""
            });
            this.levelGDEdit(levelGDCount);
            this.levelGDCount = levelGDCount + 1;
        },
        levelGDEdit(key) {
            const newData = [...this.levelGDData];
            const newDataFilter = [...this.levelGDDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];
            if (target) {
                target.editable = true;
                targetFilter.editable = true;
                this.levelGDData = newData;
                this.levelGDDataFilter = newDataFilter;
            }
        },
        levelGDHandleChangeTable(value, key, column) {
            const newData = [...this.levelGDData];
            const newDataFilter = [...this.levelGDDataFilter];
            const target = newData.filter(item => key === item.key)[0];
            const targetFilter = newDataFilter.filter(item => key === item.key)[0];
            if (target) {
                target[column] = value;
                targetFilter[column] = value;
                this.levelGDData = newData;
                this.levelGDDataFilter = newDataFilter;
            }
            this.isUpdatePromoRewardAndCondition = true
        },

        getProduct: async function (group) {
            let searchProduct = group.selectedObject;
            this.getYData = []
            this.getYData.push({
                product_id: searchProduct.id,
                name: searchProduct.name,
                retail_price: searchProduct.retail_price.replace(',', ''),
                reward_value: 1
            });
        },
        printIcon() {
            return "<i class='fas fa-angle-right'></i>";
        },
        setActiveProductRow(row) {
            if (!row) { return; }

            const { product_id, name, retail_price } = row.getData();
            this.activeProductId = product_id;
            this.activeProductName = name;
            this.activeProductOriginalPrice = retail_price;

            const newData = [...this.levelData];
            this.levelDataFilter = newData.filter(item => item.product_id === product_id);
        },
        setActiveProductId(e, row) {
            this.setActiveProductRow(row);
        },
        productsEndpoint(input) {
            return this.endPoint + 'products?all=0&' + this.searchFilter + '=' + input
        },
        allProductsData() {
            this.changeDisplay = true
            this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
            this.productOptions.ajaxConfig = {
                method: "GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
            }

            this.table = new Tabulator("#product-table", this.productOptions);
        },
        allProductsDataDrawer() {
            if (this.table && typeof this.table.destroy === 'function') {
                this.table.destroy();
            }
            this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
            this.productOptions.ajaxConfig = {
                method: "GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
            }

            this.table = new Tabulator("#product-table-drawer", this.productOptions);
        },
        allProductsDataGBDrawer() {
            if (this.table && typeof this.table.destroy === 'function') {
                this.table.destroy();
            }
            this.productOptionsB2.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
            this.productOptionsB2.ajaxConfig = {
                method: "GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
            }

            this.table = new Tabulator("#group-bonus-item-drawer-table", this.productOptionsB2);
        },
        allProductsDataBDrawer() {
            if (this.table && typeof this.table.destroy === 'function') {
                this.table.destroy();
            }
            this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterFieldB + '=' + this.searchTextB + this.advanceFilterParamsText
            this.productOptions.ajaxConfig = {
                method: "GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip': secureStorage.getItem("ipAddress") },
            }

            this.table = new Tabulator("#group-bonus-item-drawer-table", this.productOptions);
        },
        formattedDisplay(result) {
            if (this.searchFilter == 'barcode') {
                return result.barcode
            } else if (this.searchFilter == 'stock_no') {
                return result.stock_no
            } else if (this.searchFilter == 'reference_code') {
                return result.reference_code
            } else {
                return result.name
            }
        },
        // Show available fields
        showAvailableFields() {
            this.modalAvailableFields = true;
        },
        // Advanced Info
        showAdvancedInfoDiv() {
            this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
        },
        massAssign() {
            this.modalVisible = true;
        },
        addAllGroupBonus: async function () {
            this.isUpdatePromoRewardAndCondition = true;
            this.spinning = true
            this.showAddedProductTabulator = false;

            let all_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
            if (all_products.last_page == 1) {
                let array = all_products.data
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProdB.includes(element.id) == false) {
                        this.selectedProdB.push(element.id)

                        this.selectedProductDataB.push({
                            product_id: element.id,
                            required_value: 1,
                            name: element.name,
                            retail_price: element.retail_price,
                            barcode: element.barcode,
                            reference_code: element.reference_code,
                            stock_no: element.stock_no
                        })
                    }
                }

                if (this.groupBonusItemDrawerVisible) {
                    this.allProductsDataGBDrawer()
                }
            } else if (all_products.last_page > 1) {
                let array = all_products.data
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProdB.includes(element.id) == false) {
                        this.selectedProdB.push(element.id)

                        this.selectedProductDataB.push({
                            product_id: element.id,
                            required_value: 1,
                            name: element.name,
                            retail_price: element.retail_price,
                            barcode: element.barcode,
                            reference_code: element.reference_code,
                            stock_no: element.stock_no
                        })
                    }
                }

                for (let i = 2; i < all_products.last_page + 1; i++) {
                    let loop_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&page=' + i + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                    let array = loop_products.data
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        if (this.selectedProdB.includes(element.id) == false) {
                            this.selectedProdB.push(element.id)

                            this.selectedProductDataB.push({
                                product_id: element.id,
                                required_value: 1,
                                name: element.name,
                                retail_price: element.retail_price,
                                barcode: element.barcode,
                                reference_code: element.reference_code,
                                stock_no: element.stock_no
                            })
                        }
                    }
                }
                if (this.groupBonusItemDrawerVisible) {
                    this.allProductsDataGBDrawer()
                }
            }
            this.spinning = false;

            setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
        },
        addAll: async function () {
            this.isUpdatePromoRewardAndCondition = true;
            this.spinning = true
            this.showAddedProductTabulator = false;
            const searchField = (this.groupBonusItemDrawerVisible && this.groupBonusItemDrawerMode === 'bonus')
                ? this.filterFieldB
                : this.filterField;
            const searchValue = (this.groupBonusItemDrawerVisible && this.groupBonusItemDrawerMode === 'bonus')
                ? this.searchTextB
                : this.searchText;

            let all_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&' + searchField + '=' + searchValue + this.advanceFilterParamsText, null);
            if (all_products.last_page == 1) {
                let array = all_products.data
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false) {
                        this.selectedProd.push(element.id)

                        this.selectedProductData.push({
                            product_id: element.id,
                            required_value: 1,
                            name: element.name,
                            retail_price: element.retail_price.replace(',', ''),
                            barcode: element.barcode,
                            reference_code: element.reference_code,
                            stock_no: element.stock_no
                        })
                    }
                }

                if (this.itemSelectionDrawerVisible) {
                    this.allProductsDataDrawer()
                } else if (this.groupBonusItemDrawerVisible && this.groupBonusItemDrawerMode === 'bonus') {
                    this.allProductsDataBDrawer()
                } else {
                    this.allProductsData()
                }
            } else if (all_products.last_page > 1) {
                let array = all_products.data
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false) {
                        this.selectedProd.push(element.id)

                        this.selectedProductData.push({
                            product_id: element.id,
                            required_value: 1,
                            name: element.name,
                            retail_price: element.retail_price.replace(',', ''),
                            barcode: element.barcode,
                            reference_code: element.reference_code,
                            stock_no: element.stock_no
                        })
                    }
                }

                for (let i = 2; i < all_products.last_page + 1; i++) {
                    let loop_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&page=' + i + searchField + '=' + searchValue + this.advanceFilterParamsText, null);
                    let array = loop_products.data
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        if (this.selectedProd.includes(element.id) == false) {
                            this.selectedProd.push(element.id)

                            this.selectedProductData.push({
                                product_id: element.id,
                                required_value: 1,
                                name: element.name,
                                retail_price: element.retail_price.replace(',', ''),
                                barcode: element.barcode,
                                reference_code: element.reference_code,
                                stock_no: element.stock_no
                            })
                        }
                    }
                }
                if (this.itemSelectionDrawerVisible) {
                    this.allProductsDataDrawer()
                } else if (this.groupBonusItemDrawerVisible && this.groupBonusItemDrawerMode === 'bonus') {
                    this.allProductsDataBDrawer()
                } else {
                    this.allProductsData()
                }
            }
            this.spinning = false;

            setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
        },
        handleOk() {
            this.isUpdatePromoRewardAndCondition = true
            this.confirmLoading = true;
            this.sanitizeMassDiscount();
            this.sanitizeMassLimit();
            this.sanitizeMassRound();

            for (let s = 0; s < this.selectedProductData.length; s++) {
                if (this.showMassDiscount && this.massDiscount != '') {
                    this.$set(this.selectedProductData[s], 'promo_value', this.massDiscount)
                }

                if (this.showMassLimit && this.massLimit != '') {
                    this.$set(this.selectedProductData[s], 'max_application', this.massLimit)
                }

                if (this.showMassRound && this.massRound != '') {
                    this.$set(this.selectedProductData[s], 'round_to_nearest', this.massRound)
                }

                if (this.showMassRequired && this.massRequired != '') {
                    if (this.isCouponStubProductMassAssign) {
                        this.$set(this.selectedProductData[s], 'max_application', this.massRequired)
                        this.$set(this.selectedProductData[s], 'quantity', this.massRequired)
                    }
                    this.$set(this.selectedProductData[s], 'required_value', this.massRequired)
                }
            }

            this.refKey++

            this.modalVisible = false;
            this.confirmLoading = false;
        },
        wholeNumberValue(value) {
            if (value === null || value === undefined) {
                return '';
            }

            return String(value).replace(/\D/g, '');
        },
        isPositiveIntegerValue(value) {
            return /^[1-9]\d*$/.test(String(value || ''));
        },
        positiveIntegerValue(value) {
            if (value === null || value === undefined) {
                return '';
            }

            const stringValue = String(value).trim();
            if (stringValue === '') {
                return '';
            }

            return this.isPositiveIntegerValue(stringValue) ? stringValue : '';
        },
        // Non-negative integer: allows 0 (used by round_to_nearest, which may be 0),
        // unlike isPositiveIntegerValue which requires >= 1.
        isNonNegativeIntegerValue(value) {
            return /^(0|[1-9]\d*)$/.test(String(value || ''));
        },
        nonNegativeIntegerValue(value) {
            if (value === null || value === undefined) {
                return '';
            }

            const stringValue = String(value).trim();
            if (stringValue === '') {
                return '';
            }

            return this.isNonNegativeIntegerValue(stringValue) ? stringValue : '';
        },
        positiveIntegerValueFromStoredLimit(value) {
            if (value === null || value === undefined) {
                return '';
            }

            const stringValue = String(value).replace(/,/g, '').trim();
            if (stringValue === '') {
                return '';
            }

            if (this.isPositiveIntegerValue(stringValue)) {
                return stringValue;
            }

            const numericValue = Number(stringValue);
            if (!Number.isNaN(numericValue) && numericValue > 0 && Number.isInteger(numericValue)) {
                return String(numericValue);
            }

            return stringValue;
        },
        positiveDecimalValue(value) {
            if (value === null || value === undefined) {
                return '';
            }

            let hasDecimalPoint = false;
            return String(value).split('').filter(character => {
                if (/^\d$/.test(character)) {
                    return true;
                }

                if (character === '.' && !hasDecimalPoint) {
                    hasDecimalPoint = true;
                    return true;
                }

                return false;
            }).join('');
        },
        allowWholeNumberKey(event) {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];

            if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
                return;
            }

            if (!/^\d$/.test(event.key)) {
                event.preventDefault();
            }
        },
        allowPositiveDecimalKey(event) {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];

            if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
                return;
            }

            if (/^\d$/.test(event.key)) {
                return;
            }

            if (event.key === '.') {
                const value = event.target.value || '';
                const selectedValue = value.slice(event.target.selectionStart, event.target.selectionEnd);
                if (!value.includes('.') || selectedValue.includes('.')) {
                    return;
                }
            }

            event.preventDefault();
        },
        preventNonWholeNumberPaste(event) {
            const text = (event.clipboardData || window.clipboardData).getData('text');
            if (/\D/.test(text)) {
                event.preventDefault();
            }
        },
        allowPositiveIntegerKey(event) {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];

            if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
                return;
            }

            if (!/^\d$/.test(event.key)) {
                event.preventDefault();
                return;
            }

            const value = event.target.value || '';
            const start = event.target.selectionStart == null ? value.length : event.target.selectionStart;
            const end = event.target.selectionEnd == null ? value.length : event.target.selectionEnd;
            const nextValue = value.slice(0, start) + event.key + value.slice(end);

            if (!this.isPositiveIntegerValue(nextValue)) {
                event.preventDefault();
            }
        },
        preventNonPositiveIntegerPaste(event) {
            const text = (event.clipboardData || window.clipboardData).getData('text');
            const value = event.target.value || '';
            const start = event.target.selectionStart == null ? value.length : event.target.selectionStart;
            const end = event.target.selectionEnd == null ? value.length : event.target.selectionEnd;
            const nextValue = value.slice(0, start) + text + value.slice(end);

            if (!this.isPositiveIntegerValue(nextValue)) {
                event.preventDefault();
            }
        },
        // Keydown/paste guards that allow 0 (for round_to_nearest).
        allowNonNegativeIntegerKey(event) {
            const allowedKeys = [
                'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'
            ];

            if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
                return;
            }

            if (!/^\d$/.test(event.key)) {
                event.preventDefault();
                return;
            }

            const value = event.target.value || '';
            const start = event.target.selectionStart == null ? value.length : event.target.selectionStart;
            const end = event.target.selectionEnd == null ? value.length : event.target.selectionEnd;
            const nextValue = value.slice(0, start) + event.key + value.slice(end);

            if (!this.isNonNegativeIntegerValue(nextValue)) {
                event.preventDefault();
            }
        },
        preventNonNonNegativeIntegerPaste(event) {
            const text = (event.clipboardData || window.clipboardData).getData('text');
            const value = event.target.value || '';
            const start = event.target.selectionStart == null ? value.length : event.target.selectionStart;
            const end = event.target.selectionEnd == null ? value.length : event.target.selectionEnd;
            const nextValue = value.slice(0, start) + text + value.slice(end);

            if (!this.isNonNegativeIntegerValue(nextValue)) {
                event.preventDefault();
            }
        },
        preventNonPositiveDecimalPaste(event) {
            const text = (event.clipboardData || window.clipboardData).getData('text');
            const value = event.target.value || '';
            const nextValue = value.slice(0, event.target.selectionStart) + text + value.slice(event.target.selectionEnd);

            if (!/^\d*\.?\d*$/.test(nextValue)) {
                event.preventDefault();
            }
        },
        sanitizeMassDiscount() {
            this.massDiscount = this.wholeNumberValue(this.massDiscount);
        },
        sanitizeMassLimit() {
            this.massLimit = this.positiveIntegerValue(this.massLimit);
        },
        sanitizeMassRound() {
            // Round may be 0 (no rounding), so use the non-negative sanitizer.
            this.massRound = this.nonNegativeIntegerValue(this.massRound);
        },
        sanitizeMaxApplicationAll(value) {
            this.max_application_all = this.positiveIntegerValue(value);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizeDiscount() {
            this.discount = this.wholeNumberValue(this.discount);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizeDiscountInput(value) {
            this.discount = this.wholeNumberValue(value);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizePromoDiscount() {
            this.promo.promo_discount = this.wholeNumberValue(this.promo.promo_discount);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizeRewardDiscount(field) {
            this.reward[field] = this.wholeNumberValue(this.reward[field]);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizeRewardDiscountInput(field, value) {
            this.reward[field] = this.wholeNumberValue(value);
            this.isUpdatePromoRewardAndCondition = true;
        },
        sanitizeRewardDecimalInput(field, value) {
            this.reward[field] = this.positiveDecimalValue(value);
            this.isUpdatePromoRewardAndCondition = true;
        },
        wholeNumberCellEditor(cell, onRendered, success, cancel) {
            const component = component_x || this;
            const sanitize = value => component.wholeNumberValue(value);
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'tabulator-editing';
            input.style.width = '100%';
            input.value = sanitize(cell.getValue());

            const complete = () => success(sanitize(input.value));

            input.addEventListener('keydown', event => {
                component.allowWholeNumberKey(event);
                if (event.key === 'Enter') {
                    complete();
                } else if (event.key === 'Escape') {
                    cancel();
                }
            });
            input.addEventListener('paste', component.preventNonWholeNumberPaste);
            input.addEventListener('input', () => {
                input.value = sanitize(input.value);
            });
            input.addEventListener('blur', complete);

            onRendered(() => {
                input.focus();
                input.select();
            });

            return input;
        },
        positiveIntegerCellEditor(cell, onRendered, success, cancel) {
            const component = component_x || this;
            const sanitize = value => component.positiveIntegerValue(value);
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'tabulator-editing';
            input.style.width = '100%';
            input.value = sanitize(cell.getValue());

            const complete = () => success(sanitize(input.value));

            input.addEventListener('keydown', event => {
                component.allowPositiveIntegerKey(event);
                if (event.key === 'Enter') {
                    complete();
                } else if (event.key === 'Escape') {
                    cancel();
                }
            });
            input.addEventListener('paste', component.preventNonPositiveIntegerPaste);
            input.addEventListener('input', () => {
                input.value = sanitize(input.value);
            });
            input.addEventListener('blur', complete);

            onRendered(() => {
                input.focus();
                input.select();
            });

            return input;
        },
        // Tabulator editor for round_to_nearest: allows 0 (and positive integers).
        nonNegativeIntegerCellEditor(cell, onRendered, success, cancel) {
            const component = component_x || this;
            const sanitize = value => component.nonNegativeIntegerValue(value);
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'tabulator-editing';
            input.style.width = '100%';
            input.value = sanitize(cell.getValue());

            const complete = () => success(sanitize(input.value));

            input.addEventListener('keydown', event => {
                component.allowNonNegativeIntegerKey(event);
                if (event.key === 'Enter') {
                    complete();
                } else if (event.key === 'Escape') {
                    cancel();
                }
            });
            input.addEventListener('paste', component.preventNonNonNegativeIntegerPaste);
            input.addEventListener('input', () => {
                input.value = sanitize(input.value);
            });
            input.addEventListener('blur', complete);

            onRendered(() => {
                input.focus();
                input.select();
            });

            return input;
        },
        handleCancel() {
            this.modalVisible = false;
            this.modalAvailableFields = false;
            this.isModalVisible = false;
        },

        addButton(cell) {
            if (this.viewOnly) { return null; }

            let product_id = cell.getRow().getData().id

            let button = ""
            if (this.selectedProd.includes(product_id) == false) {
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
            } else {
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
            }
            return button
        },
        addButtonB(cell) {
            if (this.viewOnly) { return null; }

            let product_id = cell.getRow().getData().id

            let button = ""
            if (this.selectedProdB.includes(product_id) == false) {
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
            } else {
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
            }
            return button
        },
        retailPrice(cell) {
            return this.formatMyNumber(cell.getRow().getData().retail_price, 2)
        },
        quantityAmount(cell) {
            return this.formatMyNumber(cell.getRow().getData().quantity, 2)
        },
        formatMyNumber(number, decimal) {
            if (isNaN(number)) {
                return '0.00'
            }
            var splitNum;
            number = Math.abs(number);
            number = number.toFixed(decimal);
            splitNum = number.split('.');
            splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return splitNum.join(".");
        },
        addException() {
            let exception_type_text = this.exceptionOptions.find(x => x.key === this.exceptionText).value
            let exception_type_value = this.exceptionText

            let excepted_text = ""
            let excepted_value = 0
            if (this.exceptionText == 'BR') {
                excepted_text = this.brandOptions.find(x => x.id === this.exceptBrand).name
                excepted_value = this.exceptBrand
            } else if (this.exceptionText == 'SP') {
                excepted_text = this.supplierOptions.find(x => x.id === this.exceptSupplier).name
                excepted_value = this.exceptSupplier
            } else {
                if (this.exceptCategory.length > 0) {
                    let resultLength = this.exceptCategory.length
                    let divisions = this.categoriesOptions.find(x => x.value === this.exceptCategory[0]).children

                    let departments = []
                    let sections = []
                    let categories = []
                    switch (resultLength) {
                        case 5:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            categories = sections.find(x => x.value === this.exceptCategory[3]).children
                            excepted_text = categories.find(x => x.value === this.exceptCategory[4]).label
                            exception_type_text = 'Category'
                            exception_type_value = 'CA'
                            excepted_value = this.exceptCategory[4];
                            break;
                        case 4:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            excepted_text = sections.find(x => x.value === this.exceptCategory[3]).label
                            exception_type_text = 'Section'
                            exception_type_value = 'SC'
                            excepted_value = this.exceptCategory[3];
                            break;
                        case 3:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            excepted_text = departments.find(x => x.value === this.exceptCategory[2]).label
                            exception_type_text = 'Department'
                            exception_type_value = 'DP'
                            excepted_value = this.exceptCategory[2];
                            break;
                        case 2:
                            alert("Select atleast in department level")
                            break;
                    }
                }
            }

            if (excepted_value != 0 && excepted_text != "") {
                this.exceptData.push({
                    field_text: exception_type_text,
                    field_value: exception_type_value,
                    id_text: excepted_text,
                    id_value: excepted_value
                })
            }
        },
        selectProduct(e, cell) {
            this.isUpdatePromoRewardAndCondition = true
            if (e.target.id == '') { return; }

            this.showAddedProductTabulator = false;

            let button = document.getElementById(e.target.id);
            let product_id = cell.getRow().getData().id;
            const stock_no = cell.getRow().getData().stock_no;

            if (this.selectedProd.includes(product_id) == false) {
                this.selectedProd.push(product_id)

                let promo_value = "0.00"
                if (this.promo.promo_type == "2" || this.promo.promo_type == "3") {
                    promo_value = "0"
                } else {
                    if (this.reward_type == "1") {
                        promo_value = "0"
                    }
                }
                this.selectedProductData.push({
                    product_id: product_id,
                    name: cell.getRow().getData().name,
                    retail_price: cell.getRow().getData().retail_price.replace(',', ''),
                    promo_value: promo_value,
                    barcode: cell.getRow().getData().barcode,
                    reference_code: cell.getRow().getData().reference_code,
                    required_value: 1,
                    round_to_nearest: this.promo.promo_type == '5' ? '2' : undefined,
                    stock_no: stock_no,
                    quantity: 1,
                })

                this.checkItemIfMatrix(cell.getRow().getData(), promo_value)

                button.className = "btn btn-sm btn-default"
                button.innerHTML = "UNDO"
            } else {
                const index = this.selectedProd.indexOf(product_id);

                const dataSource = [...this.selectedProductData];
                this.selectedProductData = dataSource.filter(item => item.product_id !== product_id);

                if (index > -1) {
                    this.selectedProd.splice(index, 1);

                    button.className = "btn btn-sm btn-success"
                    button.innerHTML = "ADD"
                }
            }

            setTimeout(() => { this.showAddedProductTabulator = true; }, 300);
        },
        selectProductB(e, cell) {


            console.log("selectProductB")
            this.isUpdatePromoRewardAndCondition = true
            if (e.target.id == '') { return; }

            let button = document.getElementById(e.target.id)
            let product_id = cell.getRow().getData().id
            const stock_no = cell.getRow().getData().stock_no;
            if (this.selectedProdB.includes(product_id) == false) {

                console.log("Product NOT YET selected")
                this.selectedProdB.push(product_id)

                let promo_value = "0.00"
                if (this.promo.promo_type == "2" || this.promo.promo_type == "3") {
                    promo_value = "0"
                } else {
                    if (this.reward_type == "1") {
                        promo_value = "0"
                    }
                }

                this.selectedProductDataB.push({
                    product_id: product_id,
                    name: cell.getRow().getData().name,
                    reference_code: cell.getRow().getData().reference_code,
                    retail_price: cell.getRow().getData().retail_price.replace(',', ''),
                    promo_value: promo_value,
                    barcode: cell.getRow().getData().barcode,
                    required_value: 1,
                    stock_no: stock_no,
                    quantity: 0 // Set initial 0, will be update on done method
                })

                this.selectedProductBRefKey++;

                button.className = "btn btn-sm btn-default"
                button.innerHTML = "UNDO"
            } else {

                console.log("Product ALREADY selected")
                const index = this.selectedProdB.indexOf(product_id);

                const dataSource = [...this.selectedProductDataB];
                this.selectedProductDataB = dataSource.filter(item => item.product_id !== product_id);

                if (index > -1) {
                    this.selectedProdB.splice(index, 1);
                    this.selectedProductBRefKey++;
                    button.className = "btn btn-sm btn-success"
                    button.innerHTML = "ADD"
                }
            }
        },
        openNotificationWithIcon(type, message) {
            this.$notification[type]({
                message: 'Error',
                description: message
            });
        },
        // checkSelectedProductValue(){
        //     if(this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6'))){
        //         let non_zero = true
        //         for (let s = 0; s < this.selectedProductData.length; s++) {
        //             let product = this.selectedProductData[s]
        //             let promo_value = product.promo_value
        //             if(promo_value== "0" || promo_value == "0.00" || promo_value.trim() == ""){
        //                 non_zero = false
        //             }
        //         }
        //         return non_zero
        //     } else {
        //         return true
        //     }
        // },
        isBlankOrZero(value) {
            if (value === null || value === undefined) {
                return true;
            }

            const normalizedValue = String(value).replace(/,/g, '').trim();
            if (normalizedValue === '') {
                return true;
            }

            const numericValue = Number(normalizedValue);
            return !Number.isNaN(numericValue) && numericValue <= 0;
        },
        isBlank(value) {
            return value === null || value === undefined || String(value).replace(/,/g, '').trim() === '';
        },
        isInvalidPositiveNumber(value) {
            if (value === null || value === undefined) {
                return true;
            }

            const normalizedValue = String(value).replace(/,/g, '').trim();
            if (normalizedValue === '') {
                return true;
            }

            const numericValue = Number(normalizedValue);
            return Number.isNaN(numericValue) || numericValue <= 0;
        },
        normalizeAmount(value, fallback = '0') {
            if (value === null || value === undefined) {
                return fallback;
            }

            return String(value).replace(/,/g, '').trim() || fallback;
        },
        normalizeCouponStubRound(value) {
            if (value === null || value === undefined) {
                return '2';
            }

            const normalizedValue = String(value).replace(/,/g, '').trim();
            if (normalizedValue === '' || Number.isNaN(Number(normalizedValue))) {
                return '2';
            }

            return normalizedValue;
        },
        getProductField(productLine, field, fallback = '') {
            if (productLine && productLine.product && productLine.product[field] != null) {
                return productLine.product[field];
            }

            if (productLine && productLine[field] != null) {
                return productLine[field];
            }

            return fallback;
        },
        buildCouponStubProductPromoText(product) {
            const promoValue = this.normalizeAmount(product.promo_value);
            const maxApplication = this.normalizeAmount(product.max_application, '1');
            const roundToNearest = this.normalizeCouponStubRound(product.round_to_nearest);
            const round = lineRoundToNearest('create', roundToNearest);

            if (this.promo.reward_type == '2') {
                return `(1:E1:L${promoValue}${round.text};@${maxApplication})`;
            }

            if (this.promo.reward_type == '3') {
                return `(1:E1:F${promoValue}${round.text};@${maxApplication})`;
            }

            return `(1:E1:${promoValue}%${round.text};@${maxApplication})`;
        },
        parseCouponStubProductPromoLine(productLine) {
            const promoText = productLine.promo_text || '';
            const values = {
                promo_value: this.normalizeAmount(this.promo.reward_trigger_amount, ''),
                round_to_nearest: '2',
                max_application: this.positiveIntegerValueFromStoredLimit(productLine.quantity) || 1
            };

            if (!promoText) {
                return values;
            }

            const promoValueMatch = promoText.match(/:E1:(?:L|F)?([\d.]+)%?/);
            if (promoValueMatch) {
                values.promo_value = promoValueMatch[1];
            }

            const maxApplicationMatch = promoText.match(/@([\d.]+)/);
            if (maxApplicationMatch) {
                values.max_application = this.positiveIntegerValueFromStoredLimit(maxApplicationMatch[1]);
            }

            values.round_to_nearest = this.normalizeCouponStubRound(lineRoundToNearest('update', promoText).text);

            return values;
        },
        removeValidationError(message) {
            this.errors = (this.errors || []).filter(error => error !== message);
        },
        clearApplyStepValidationErrors() {
            const applyStepErrors = [
                'Enter valid discount value.',
                'Please specify discount value of selected products.',
                'Complete level discount values for selected products.',
                'Enter valid reward/discount amount greater than 0.',
                'Please select an items. It must not be empty.',
                'Enter valid discount value for the first conditional discount.',
                'Enter valid discount value for the second conditional discount.'
            ];

            this.errors = (this.errors || []).filter(error => !applyStepErrors.includes(error));
        },
        normalizeErrorMessages(errors) {
            const messages = Array.isArray(errors) ? errors : String(errors || '').split(',');
            return this._.uniq(messages.map(error => String(error || '').trim()).filter(Boolean));
        },
        normalizeSaveErrorMessages(request) {
            if (request && request.error !== undefined) {
                const messages = this.normalizeErrorMessages(request.error);
                return messages.length > 0 ? messages : ['Unable to save promotion.'];
            }

            return ['Unable to save promotion.'];
        },
        isPromotionSaveSuccess(request) {
            return request
                && request.error === undefined
                && request.promo_id !== undefined
                && request.promo_id !== null
                && request.promo_id !== '';
        },
        showPromotionSaveFailure(request) {
            this.errors = this.normalizeSaveErrorMessages(request);
            this.$notification['error']({
                message: 'Error',
                description: this.errors.join(',')
            });
        },
        normalizePromoLineNumber(value, fallback) {
            if (value === null || value === undefined || String(value).trim() === '') {
                return fallback;
            }

            return value;
        },
        normalizePromoLinesForSave(promoLines) {
            return promoLines.map(line => ({
                ...line,
                quantity: this.normalizePromoLineNumber(line.quantity, 0),
                original_price: this.normalizePromoLineNumber(line.original_price, 0),
                group_id: this.normalizePromoLineNumber(line.group_id, -1)
            }));
        },
        getLimitRoundValidationErrors() {
            if (this.productUploadFileMode) {
                return [];
            }

            const errors = [];

            if (this.showMassLimit && this.massLimit !== '' && !this.isPositiveIntegerValue(this.massLimit)) {
                errors.push('Limit must be a positive whole number.');
            }

            if (this.showMassRound && this.massRound !== '' && !this.isNonNegativeIntegerValue(this.massRound)) {
                errors.push('Round must be a whole number (0 or greater).');
            }

            this.selectedProductData.forEach(product => {
                const maxApplication = this.positiveIntegerValueFromStoredLimit(product.max_application);
                if (product.max_application !== '' && product.max_application !== null && product.max_application !== undefined
                    && !this.isPositiveIntegerValue(maxApplication)) {
                    errors.push('Limit must be a positive whole number.');
                }

                if (product.round_to_nearest !== '' && product.round_to_nearest !== null && product.round_to_nearest !== undefined
                    && String(product.round_to_nearest).trim() != '0' && product.round_to_nearest != 0
                    && !this.isPositiveIntegerValue(product.round_to_nearest)) {
                    errors.push('Round must be a positive whole number.');
                }
            });

            return this._.uniq(errors);
        },
        selectedProductPromoValueRequired() {
            if (this.promo.promo_type == '2') {
                return true;
            }

            if (this.promo.promo_type == '3') {
                return true;
            }

            if (this.promo.promo_type == '5') {
                // Coupon Promo lists the participating items only; it does not
                // define a per-product discount value, so the "Please specify
                // discount value of selected products." requirement must NOT apply.
                return requiresProductDiscountValue(this.promo.promo_type);
            }

            if (this.promo.promo_type != '1') {
                return false;
            }

            if (['1', '2'].includes(this.promo.reward_type)) {
                return this.include_item == '6';
            }

            return ['3', '6'].includes(this.promo.reward_type);
        },
        getConditionalDiscountValue(type, group) {
            const rewardMap = group === 'x'
                ? { LSP: 'get_x_lp', LSA: 'get_x_la', NWP: 'get_x_po' }
                : { LP: 'get_y_lp', LA: 'get_y_la', PO: 'get_y_po' };

            return this.reward[rewardMap[type]];
        },
        getCouponStubValidationErrors() {
            if (this.promo.promo_type != '5') {
                return [];
            }

            const errorMsg = [];

            if (this.isInvalidPositiveNumber(this.promo.computed_trigger_amount)) {
                errorMsg.push("Invalid input promo trigger amount. It must not be empty or zero.");
            }

            if (this.isInvalidPositiveNumber(this.promo.reward_trigger_amount)) {
                errorMsg.push("Enter valid reward/discount amount greater than 0.");
            }

            const computedCouponLimit = String(this.promo.computed_coupon_limit == null ? '' : this.promo.computed_coupon_limit).trim();
            if (this.promo.computed_trigger_label === 'for_every'
                && (computedCouponLimit === '' || Number(computedCouponLimit) < 0)) {
                errorMsg.push("Invalid input coupon limit. It must not be empty.");
            }

            if (this.selectedProductData.length === 0 && this.include_item == '6') {
                errorMsg.push("Please select an items. It must not be empty.");
            }

            return errorMsg;
        },
        getLevelDiscountErrors() {
            if (!(this.promo.promo_type == '1' && ['4', '5'].includes(this.promo.reward_type))) {
                return [];
            }

            if (this.selectedProductData.length == 0) {
                return [];
            }

            const selectedProductIds = this.selectedProductData.map(product => String(product.product_id));
            const configuredProductIds = this.levelData
                .filter(level => {
                    if (this.promo.reward_type == '4' && this.promo.remark != '3' && this.promo.remark != '') {
                        return !this.isBlankOrZero(level.qty) && !this.isBlankOrZero(level.discount);
                    }

                    return !this.isBlankOrZero(level.qty) && !this.isBlankOrZero(level.price);
                })
                .map(level => String(level.product_id));

            const hasMissingLevel = selectedProductIds.some(productId => !configuredProductIds.includes(productId));
            return hasMissingLevel ? ['Complete level discount values for selected products.'] : [];
        },
        getApplyStepDiscountErrors(forceValidation = false) {
            if (!forceValidation && this.current != 1) {
                return [];
            }

            if (this.productUploadFileMode) {
                return [];
            }

            let errorMsg = [];

            if (
                ['1', '2'].includes(this.promo.promo_type) &&
                ['1', '2'].includes(this.promo.reward_type) &&
                this.include_item <= 5 &&
                this.isBlankOrZero(this.discount)
            ) {
                errorMsg.push('Enter valid discount value.');
            }

            if (this.selectedProductPromoValueRequired()) {
                const hasBlankPromoValue = this.selectedProductData.some(product => this.isBlankOrZero(product.promo_value));
                if (hasBlankPromoValue) {
                    errorMsg.push('Please specify discount value of selected products.');
                }
            }

            errorMsg = [...errorMsg, ...this.getLevelDiscountErrors()];
            errorMsg = [...errorMsg, ...this.getCouponStubValidationErrors()];

            if (this.promo.promo_type == '7' && this.isBlankOrZero(this.promo.promo_discount)) {
                errorMsg.push('Enter valid discount value.');
            }

            if (this.promo.promo_type == '8') {
                if (this.isBlank(this.getConditionalDiscountValue(this.get_x_type, 'x'))) {
                    errorMsg.push('Enter valid discount value for the first conditional discount.');
                }

                if (this.isBlankOrZero(this.getConditionalDiscountValue(this.get_y_type, 'y'))) {
                    errorMsg.push('Enter valid discount value for the second conditional discount.');
                }
            }

            if (this.promo.promo_type == '9') {
                errorMsg = [...errorMsg, ...this.groupDiscountValidationMessages];
            }

            return this._.uniq(errorMsg);
        },
        checkIfHasErrors(current) {
            let noError = true;
            let errorMsg = [];

            if (this.promo.name.length > 100) {
                noError = false
                errorMsg.push('Promotion Name field should not exceed 100 characters.');
            }

            if ((current + 1) == 1) { return { noError, errorMsg }; }

            let discountErrors = this.getApplyStepDiscountErrors();
            const hasUploadingFile = this.hasUploadedProductFile();

            if (discountErrors.length > 0) {
                noError = false;
                errorMsg = [...errorMsg, ...discountErrors];
            }

            if (this.promo.promo_type == '6' && this.promo.reward_type == '1') {
                if (this.promo.status == 'A' && this.selectedProductData.length > 0 &&
                    (this.getYData.length == 0 || !this.getYData[0].product_id)) {
                    noError = false;
                    errorMsg.push('Please select a reward product (Item X).');
                }
            }

            if ((['1', '2'].includes(this.promo.promo_type) && (this.promo.reward_type == '3' || this.include_item == '6')) ||
                (this.promo.promo_type == '3') ||
                (this.promo.promo_type == '6' && this.promo.reward_type == '1') ||
                (this.promo.promo_type == '6' && (this.promo.reward_type == '2' || this.promo.reward_type == '3') && [1, 2].includes(parseInt(this.coupleType)))
            ) {
                if (this.selectedProductData.length == 0 && !hasUploadingFile) {
                    noError = false;
                    errorMsg.push('Please select at least 1 product or upload a CSV file to populate the product.');
                }
            } else if (this.promo.promo_type == '6' && (this.promo.reward_type == '2' || this.promo.reward_type == '3') && ![1, 2].includes(parseInt(this.coupleType))) {
                if (this.selectedProductData.length == 0 && !hasUploadingFile) {
                    noError = false;
                    errorMsg.push('Please select at least 1 prerequisite item or upload a CSV file to populate the product.');
                }
            }

            if (this.promo.promo_type == '3' && this.promo.reward_type != '1' &&
                this.promo.status == 'A' && !hasUploadingFile &&
                (this.getYData.length == 0 || !this.getYData[0].product_id)) {
                noError = false;
                errorMsg.push("You can't activate this promotion without a Reward Product (Item Y). Please specify Item Y.");
            }

            return { noError, errorMsg: this._.uniq(errorMsg) };
        },

        async nextPage(current) {

            console.log("Checking current page and promo type...")
            console.log(current)
            // console.log(">>> INCLUDE ITEM <<<")
            // console.log(this.include_item)

            let errorMsg = []

            // console.log("CURRENT")
            // console.log(this.current)

            if (this.current == 1 && this.promo.promo_type == '7' && !this.productUploadFileMode) {
                console.log(">>>>IF")
                if (this.promo.compute_mode == null) {
                    errorMsg.push("Select correct value for computation Mode. ");
                }

                if (this.promo.compute_mode != 'all_with_qty' && (this.promo.reward_trigger_amount == null || this.promo.reward_trigger_amount == '')) {
                    errorMsg.push("Enter valid value for amount/quantity required.");
                }

                if (this.selectedProductDataB.length == 0) {
                    errorMsg.push("Select pre-requistite item/s");
                }

                if (this.promo.compute_mode === 'all_with_qty' && this.selectedProductDataB.length > 0) {
                    const hasValidQuantity = this.selectedProductDataB.some(item => {
                        const qty = Number(item.quantity);
                        return !isNaN(qty) && qty === 0;
                    });

                    if (hasValidQuantity) {
                        errorMsg.push("Item/s with a quantity of 0 are not allowed");
                    }
                }

                if (this.selectedProductData.length == 0) {
                    errorMsg.push("Select bonus item/s");
                }

                if (this.isBlankOrZero(this.promo.promo_discount)) {
                    errorMsg.push("Enter valid discount value.");
                }

                if (errorMsg.length > 0) {
                    errorMsg.map(error => {
                        this.openNotificationWithIcon('error', error);
                    })
                } else {
                    this.current = current + 1
                    this.spinning = true
                    if (this.customerCardTypeOptions.length == 0) {
                        let customer_card_types = await HTTPRequest.getRequest(this.endPoint + "customer_card_types/get_valid_customer_card_types", null);
                        this.customerCardTypeOptions = customer_card_types;
                        this.sort(this.customerCardTypeOptions)
                    }

                    if (this.siteOptions.length == 0) {
                        let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                        this.siteOptions = sites;
                        this.sort(this.siteOptions)
                    }
                    this.spinning = false
                }
            } else {
                let { noError, errorMsg } = this.checkIfHasErrors(current);
                console.log(">>>>ELSE")

                if (this.promo.promo_type == "5" && this.current == 1) {
                    console.log("Coupon validation here...")

                    const couponStubErrors = this.getCouponStubValidationErrors();
                    noError = noError && couponStubErrors.length == 0;
                    errorMsg = this._.uniq([...errorMsg, ...couponStubErrors]);
                }

                if (noError) {
                    this.current = current + 1
                    this.spinning = true
                    if (this.current == 1) {
                        if (this.supplierOptions.length == 0 && this.include_item == "2") {
                            let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                            this.supplierOptions = suppliers
                            this.sort(this.supplierOptions);
                        }

                        if (this.brandOptions.length == 0 && this.include_item == "3") {
                            // var userBrands = secureStorage.getItem("userBrands") || ""
                            // let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?userBrands=" + userBrands, null, null)
                            let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?mode=all", null, null)
                            if (brands != null) {
                                this.brandOptions = brands
                                this.sort(this.brandOptions);
                            }
                        }

                        // console.log("Categories")
                        // console.log(this.categoriesOptions)

                        // if(this.categoriesOptions.length == 0 && this.include_item == "4"){
                        // //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                        //     let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                        //     this.categoriesOptions = options
                        //     this.updateCategoriesOptions(options)
                        // }

                    } else if (this.current == 2) {
                        if (this.customerCardTypeOptions.length == 0) {
                            let customer_card_types = await HTTPRequest.getRequest(this.endPoint + "customer_card_types/get_valid_customer_card_types", null);
                            this.customerCardTypeOptions = customer_card_types;
                            this.sort(this.customerCardTypeOptions)
                        }

                        if (this.siteOptions.length == 0) {
                            let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                            this.siteOptions = sites;
                            this.sort(this.siteOptions)
                        }
                    }
                    this.spinning = false
                } else {
                    errorMsg.map(error => {
                        this.openNotificationWithIcon('error', error);
                    })
                }

            }

            // if(this.current == 1 && this.promo.promo_type == '1' && this.include_item == '2'){
            //     if(this.discount == 0 || this.discount == '' || this.discount == null){

            //     }
                
            // }

        },
        async backPage(current) {
            this.current = current - 1
        },
        cancel() {
            this.$emit('closeDrawer');
        },
        close() {
            this.$emit('refreshPage', event)
        },
        async done() {
            this.doneLoading = true
            // console.log(this)
            this.validateForm()

            const hasUploadingFile = this.hasUploadedProductFile();
            const hasOngoingUpload = await this.checkImportJobBeforeSaving();

            if (this.site_selection == 'S' && this.getSelectedSiteIds().length == 0) {
                this.errors.push('Please select at least 1 site.');
            }

            this.errors = this._.uniq([...this.errors, ...this.getApplyStepDiscountErrors(true)]);
            this.errors = this._.uniq([...this.errors, ...this.getLimitRoundValidationErrors()]);

            if (this.promo.promo_type == '9' && !this.productUploadFileMode) {
                if (this.promo.group_discount_type == '1') {
                    this.groupLevelDataFilter = this.groupLevelDataFilter.filter(item => {
                        return !(item.qty === "" && item.discount === "");
                    });
                } else {
                    this.groupLevelDataFilter = this.groupLevelDataFilter.filter(item => {
                        return !(item.amount === "" && item.discount === "");
                    });
                }

                if (this.groupLevelDataFilter.length == 0)
                    this.errors.push("Please input discount details in the configuration page.")
            }

            if (this.errors.length > 0) {
                this.$notification['error']({
                    message: 'Error',
                    description: this.errors.join(",")
                });
                this.doneLoading = false
                return false
            }



            if (this.promo.promo_type != '5') {
                this.promo.reward_coupon_text = null
            }

            if (this.promo.status != 'A' && hasUploadingFile && hasOngoingUpload) {
                // Checker if User is uploading a file when there's an ongoing upload process
                this.doneLoading = false;
                return;
            } else if (this.promo.status == 'A' && hasOngoingUpload) {
                // Checker if User will activate the promo and there's an ongoing upload process
                this.doneLoading = false;
                return;
            }

            let promotion_hash = {}
            let promo_sites = []

            //promo_sites - Arvin //
            //promo_sites - Arvin//
            if (this.site_selection == 'A') {
                this.siteOptions.forEach((el) => {
                    promo_sites.push(el.id)
                })
                // console.log(promo_sites)
            } else {
                var site_ids = this.getSelectedSiteIds();
                console.log("Selected Sites")
                console.log(this.selectedRowKeys)
                console.log(site_ids)
                promo_sites = site_ids;
            }

            // check if promo site is updated
            var isUpdatePromoSite = false
            if (this._.xor(promo_sites, this.oldPromoSites).length === 0) {
                isUpdatePromoSite = false
            } else {
                isUpdatePromoSite = true
            }

            let promos = []
            let promo_lines = []


            if (this.is_specify_date == true) {
                let day_arr = []
                if (this.valid_days.sun == true) { day_arr.push("1") }
                if (this.valid_days.mon == true) { day_arr.push("2") }
                if (this.valid_days.tue == true) { day_arr.push("3") }
                if (this.valid_days.wed == true) { day_arr.push("4") }
                if (this.valid_days.thu == true) { day_arr.push("5") }
                if (this.valid_days.fri == true) { day_arr.push("6") }
                if (this.valid_days.sat == true) { day_arr.push("7") }
                promos.valid_day = day_arr
                this.promo.valid_day = day_arr
            } else {
                promos.valid_day = []
                this.promo.valid_day = []
            }

            if (this.is_specify_time == true) {
                promos.valid_start_time = this.picker_date.valid_start_time.format("HH:mm")
                promos.valid_end_time = this.picker_date.valid_end_time.format("HH:mm")
                this.promo.valid_start_time = this.picker_date.valid_start_time.format("HH:mm")
                this.promo.valid_end_time = this.picker_date.valid_end_time.format("HH:mm")
            } else {
                promos.valid_start_time = null
                promos.valid_end_time = null
                this.promo.valid_start_time = null
                this.promo.valid_end_time = null
            }

            //Promo Type = Item and Pool Discounts //
            if (['1', '2'].includes(this.promo.promo_type)) {

                if (this.promo.promo_type == '1') {
                    this.promo.reward_trigger_frequency = 0
                    this.promo.reward_type_desc = "REFCODEBONUS|" + this.promo.reward_type
                } else if (this.promo.promo_type == '2') {
                    this.promo.reward_type_desc = "PWPWP|" + this.promo.reward_type
                    // inclusive;CASH;every 
                    if (this.promo.reward_trigger_frequency == '' || this.promo.reward_trigger_frequency == null) {
                        this.promo.reward_trigger_frequency = 0
                    }
                    this.promo.promo_text = this.promo.apply_level + ";" + this.promo.payment_type_code + ";" + this.promo.compute_mode
                }

                console.log("INCLUDE ITEM")
                console.log(this.include_item)
                // START -- Promo Lines Process Saving //

                if (!this.productUploadFileMode) {
                    if (this.max_application_all == 0) {
                        this.max_application_all = 999
                    }

                    //All Items
                    if (this.include_item == "1") {

                    let promo_text = ''
                    let promo_description = ''

                    // Percent Discount
                    if (this.promo.reward_type == "1") {
                        promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^'
                    }

                    // Amount Discount
                    else if (this.promo.reward_type == "2") {
                        promo_text = '(1:E1:L' + this.discount + ';@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                    }

                    promo_lines.push({
                        include_field: "all",
                        include_value: "",
                        exclude_field: "",
                        exclude_value: "",
                        promo_text: promo_text,
                        include_field_ex: "all",
                        include_value_ex: "",
                        exclude_field_ex: "",
                        exclude_value_ex: "",
                        description: promo_description,
                        quantity: "",
                        original_price: "",
                        group_id: "",
                        promo_type: "P",
                        condition_type: "EVERY",
                        status: "A",
                        product_id: -1
                    })

                    //Specific Supplier
                }

                // Supplier
                else if (this.include_item == "2") {

                    let promo_text = ''
                    let promo_description = ''
                    // Percent Discount
                    if (this.promo.reward_type == "1") {
                        promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^'
                    }

                    // Amount Discount
                    else if (this.promo.reward_type == "2") {
                        promo_text = '(1:E1:L' + this.discount + ';@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                    }


                    promo_lines.push({
                        include_field: "supplierId",
                        include_value: this.allItem.supplier_id,
                        exclude_field: "",
                        exclude_value: "",
                        promo_text: promo_text,
                        description: promo_description,
                        include_field_ex: "supplierId",
                        include_value_ex: this.allItem.supplier_id,
                        exclude_field_ex: "",
                        exclude_value_ex: "",
                        quantity: "",
                        original_price: "",
                        group_id: "",
                        promo_type: "P",
                        condition_type: "EVERY",
                        status: "A",
                        product_id: -1
                    })
                    // Change Price
                    // else if (this.promo.reward_type == "3"){
                    //     promo_text = '(1:E1:F' + this.discount + ';@' + this.max_application_all + ')'
                    //     promo_description = '^1:New Price ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                    // } 

                    //Specific Brand
                }

                // Brand
                else if (this.include_item == "3") {
                    let brands = this.allItem.brand_id
                    console.log("BRAND ID VALUES")
                    console.log(this.allItem.brand_id)

                    let promo_text = ''
                    let promo_description = ''
                    // Percent Discount
                    if (this.promo.reward_type == "1") {
                        promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^'
                    }

                    // Amount Discount
                    else if (this.promo.reward_type == "2") {
                        promo_text = '(1:E1:L' + this.discount + ';@' + this.max_application_all + ')'
                        promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                    }

                    brands.forEach(b => {
                        promo_lines.push({
                            include_field: "brandId",
                            include_value: b,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: "brandId",
                            include_value_ex: b,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: 1,
                            original_price: "",
                            group_id: 1,
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A"
                        })
                    })


                    //Specific Category
                }

                // Categories
                else if (this.include_item == "4") {

                    if (this.inputCategory.length > 0) {
                        let resultLength = this.inputCategory.length
                        let category_id = 0
                        let category_type = ""

                        switch (resultLength) {
                            case 5:
                                category_type = "categoryId"
                                category_id = this.inputCategory[4];
                                break;
                            case 4:
                                category_type = "sectionId"
                                category_id = this.inputCategory[3];
                                break;
                            case 3:
                                category_type = "departmentId"
                                category_id = this.inputCategory[2];
                                break;
                            case 2:
                                category_type = "divisionId"
                                category_id = this.inputCategory[1];
                                break;
                            case 1:
                                alert("Select atleast in division level")
                                return
                        }

                        let promo_text = ''
                        let promo_description = ''

                        console.log(">>>>Checker Input Category")
                        console.log(this.inputCategory)

                        let cascader_value = this.inputCategory.toString()
                        // Percent Discount
                        if (this.promo.reward_type == "1") {
                            promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^'
                        }

                        // Amount Discount
                        else if (this.promo.reward_type == "2") {
                            promo_text = '(1:E1:L' + this.discount + ';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                        }

                        promo_lines.push({
                            include_field: category_type,
                            include_value: category_id,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: category_type,
                            include_value_ex: category_id,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: "",
                            original_price: "",
                            group_id: "",
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A",
                            integration_settings: "[" + cascader_value + "]"
                            // product_id: ""
                        })


                    } else {
                        alert("No Category Selected")
                        return
                    }
                    //Except Selected Items
                }

                // All Items Except
                else if (this.include_item == "5") {

                    if (this.promoExceptions.length > 0) {

                        let promo_text = ''
                        let promo_description = ''
                        // Percent Discount
                        if (this.promo.reward_type == "1") {
                            promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^'
                        }

                        console.log("NEW PROMO EXCEPTIONS")
                        console.log(this.promoExceptions)

                        for (let s = 0; s < this.promoExceptions.length; s++) {
                            let exempt = this.promoExceptions[s]

                            let cacscader_value = null
                            if (exempt.exception_type == "ex_supplierId" || exempt.exception_type == "ex_brandId") {
                                cacscader_value = null
                            } else {
                                cacscader_value = "[" + exempt.exception_value_display + "]"
                            }

                            promo_lines.push({
                                include_field: exempt.exception_type,
                                include_field_ex: exempt.exception_type,
                                include_value: exempt.exception_value,
                                include_value_ex: exempt.exception_value,
                                exclude_field: "",
                                exclude_value: "",
                                exclude_field_ex: "",
                                exclude_value_ex: "",
                                promo_text: promo_text,
                                description: promo_description,
                                quantity: "",
                                original_price: "",
                                group_id: "",
                                promo_type: "P",
                                condition_type: "EVERY",
                                status: "A",
                                integration_settings: cacscader_value
                            })

                        }
                    } else {
                        alert("No Item Selected")
                        return
                    }

                    console.log("PROMO LINES")
                    console.log(promo_lines)
                }

                // Default
                else {


                    console.log("Selected Items...")

                    for (let s = 0; s < this.selectedProductData.length; s++) {
                        let product = this.selectedProductData[s]

                        console.log(">> Product")
                        console.log(product)

                        console.log("levelData")
                        console.log(this.levelData)

                        let max_application = this.positiveIntegerValueFromStoredLimit(product.max_application)
                        let round_to_nearest = product.round_to_nearest

                        if (max_application == '' || max_application == null || max_application == undefined) {
                            max_application = this.reward.max_application
                        }

                        if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined) {
                            round_to_nearest = this.reward.round_to_nearest
                        }


                        console.log("Before Round:", round_to_nearest)

                        const getRoundUpAdd = lineRoundToNearest('create', round_to_nearest)

                        console.log("After Round:", getRoundUpAdd)

                        //let product_value = product.barcode
                        let product_value = product.reference_code
                        if (this.is_ref_code == true) {
                            product_value = product.reference_code
                        }

                        let promo_text = ""
                        let promo_description = ""

                        if (max_application == 0) {
                            max_application = 999
                        }

                        // Percent Discount
                        if (this.promo.reward_type == "1") {
                            promo_text = '(1:E1:' + product.promo_value + '%' + getRoundUpAdd.text + ';@' + max_application + ')'
                            promo_description = '^1:Less ' + product.promo_value + '%' + getRoundUpAdd.desc + ', Limit to ' + max_application + '^'
                        }

                        // Amount Discount
                        else if (this.promo.reward_type == "2") {
                            promo_text = '(1:E1:L' + product.promo_value + getRoundUpAdd.text + ';@' + max_application + ')'
                            promo_description = '^1:Less ' + product.promo_value + getRoundUpAdd.desc + ', Limit to ' + max_application + '^'
                        }

                        // Change Price
                        else if (this.promo.reward_type == "3") {
                            promo_text = '(1:E1:F' + product.promo_value + getRoundUpAdd.text + ';@' + max_application + ')'
                            promo_description = '^1:New Price ' + product.promo_value + getRoundUpAdd.desc + ', Limit to ' + max_application + '^'
                        }

                        // Relative Pricing
                        // levelDataFilter
                        else if (this.promo.reward_type == "4") {
                            let level_text = ''
                            for (let x = 0; x < this.levelData.length; x++) {
                                let levelValue = this.levelData[x]
                                if (product.product_id == levelValue.product_id) {
                                    console.log(levelValue)
                                    level_text += levelValue.qty + '|' + levelValue.price + ","
                                }
                            }
                            promo_text = '(1:E1:R' + level_text.slice(0, -1) + ';@' + parseInt(max_application) + ')'
                            promo_description = '^1:Relative (R' + level_text.slice(0, -1) + '), Limit to ' + parseInt(max_application) + '^'
                        }

                        // Bundle Pricing
                        else if (this.promo.reward_type == "5") {
                            console.log("Bundle Pricing")
                            // promo_text = '(1:D1:' + product.promo_value + 'L;@' + max_application + ')'
                            // promo_description = '^1:Bundling ' + product.promo_value + ', Limit to ' + max_application + '^'
                            let level_text = ''
                            for (var x = 0; x < this.levelData.length; x++) {
                                let levelValue = this.levelData[x]
                                if (product.product_id == levelValue.product_id) {
                                    console.log(levelValue)
                                    level_text += levelValue.qty + ':' + levelValue.price + ','
                                }
                            }

                            // (1:S2:30,4:50)
                            // ^1:Bundling (S2:30,4:50), Limit to 10^

                            promo_text = '(1:S' + level_text.slice(0, -1) + '@' + parseInt(max_application) + ')'
                            promo_description = '^1:Bundling (S' + level_text.slice(0, -1) + '), Limit to ' + parseInt(max_application) + '^'
                        }

                        // Buy X Take X
                        else if (this.promo.reward_type == "6") {
                            promo_text = '(1:D1:B' + product.required_value + ',' + product.promo_value + ';@' + max_application + ')'
                            promo_description = '^1:Buy ' + product.required_value + ' Take ' + product.promo_value + ', Limit to ' + max_application + '^'
                        }

                        if (this.include_type == '5') {
                            promo_lines.push({
                                include_field: "refcode",
                                include_value: product_value,
                                exclude_field: "refcode",
                                exclude_value: product_value,
                                promo_text: promo_text,
                                include_field_ex: "",
                                include_value_ex: "",
                                exclude_field_ex: "refcode",
                                exclude_value_ex: product_value,
                                description: promo_description + '||' + product.name,
                                quantity: max_application,
                                original_price: product.retail_price.replace(',', ''),
                                group_id: 1,
                                promo_type: "P",
                                condition_type: "EVERY",
                                status: "A",
                                product_id: product.product_id
                            })
                        } else {
                            promo_lines.push({
                                include_field: "refcode",
                                include_value: product_value,
                                exclude_field: "",
                                exclude_value: "",
                                promo_text: promo_text,
                                include_field_ex: "refcode",
                                include_value_ex: product_value,
                                exclude_field_ex: "",
                                exclude_value_ex: "",
                                description: promo_description + '||' + product.name,
                                quantity: max_application,
                                original_price: product.retail_price.replace(',', ''),
                                group_id: 1,
                                promo_type: "P",
                                condition_type: "EVERY",
                                status: "A",
                                product_id: product.product_id
                            })
                        }


                    }
                }

                    // END -- Promo Lines Process Saving //
                }

            }

            // PROMO COUPON :: CREATE
            else if (this.promo.promo_type == '5') {
                this.promo.computed_trigger_amount = this.normalizeAmount(this.promo.computed_trigger_amount)
                this.promo.reward_trigger_amount = this.normalizeAmount(this.promo.reward_trigger_amount)
                this.promo.computed_coupon_limit = this.normalizeAmount(this.promo.computed_coupon_limit)

                const computedPromoText = parseCouponPromoText('create', this.promo.computed_trigger_label,
                    this.promo.computed_coupon_base_on,
                    this.promo.computed_coupon_limit,
                    this.promo.computed_trigger_amount,
                    this.promo.computed_coupon_print_as_one)
                this.promo.promo_text = computedPromoText
                this.promo.reward_type_desc = `COUPON|${this.promo.reward_type}`
                this.promo.reward_trigger_frequency = this.promo.computed_trigger_label === 'for_minimum_purchase' ? 1 : 0
                this.promo.reward_coupon_text = this.promo.reward_coupon_text
                if (this.include_item == '6') {
                    for (let x = 0; x < this.selectedProductData.length; x++) {
                        let data = this.selectedProductData[x]
                        const promoText = this.buildCouponStubProductPromoText(data);
                        const maxApplication = this.normalizeAmount(data.max_application, '1');
                        promo_lines.push({
                            include_field: "productCode",
                            include_value: data.product_id,
                            exclude_field: null,
                            exclude_value: null,
                            promo_text: promoText,
                            include_field_ex: "productCode",
                            include_value_ex: data.product_id,
                            exclude_field_ex: null,
                            exclude_value_ex: null,
                            description: `||${data.name || ''}`,
                            quantity: maxApplication,
                            original_price: this.normalizeAmount(data.retail_price || data.original_price),
                            group_id: 1,
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A",
                            product_id: data.product_id
                        })
                    }
                } else if (this.include_item == '1') {
                    promo_lines.push({
                        include_field: "all",
                        include_value: null,
                        exclude_field: null,
                        exclude_value: null,
                        promo_text: null,
                        include_field_ex: "all",
                        include_value_ex: null,
                        exclude_field_ex: null,
                        exclude_value_ex: null,
                        description: null,
                        quantity: 0,
                        original_price: 0,
                        group_id: 1,
                        promo_type: "P",
                        condition_type: "EVERY",
                        status: "A",
                        product_id: -1
                    })
                }
            }

            // Promo Type = Group Bonus //
            else if (['7'].includes(this.promo.promo_type)) {

                let p_text = this.promo.promo_text

                if (p_text == "0" || String(p_text) === 'undefined') {
                    p_text = "999"
                }
                this.promo.reward_type_desc = "GROUPBONUS|" + this.promo.reward_type
                this.promo.promo_text = "@" + p_text

                if (this.promo.reward_trigger_frequency == '' || this.promo.reward_trigger_frequency == null) {
                    this.promo.reward_trigger_frequency = 0
                }

                if (!this.productUploadFileMode) {
                    let p_condition_type = "EVERY"
                    if (this.promo.compute_mode == 'every_amt') {
                        p_condition_type = "AMOUNT"
                    }

                    else if (this.promo.compute_mode == 'all_with_qty') {
                        p_condition_type = 'ANY'
                    }

                // START - Processing of pre-requisite items //
                // [1.1] Pre-req Item Processing
                for (let x = 0; x < this.selectedProductDataB.length; x++) {
                    let pre_req_item = this.selectedProductDataB[x]

                    console.log("Preq Qty:", pre_req_item.quantity)

                    let preqQty = 1 // Fixed
                    if (this.promo.compute_mode === 'all_with_qty') {
                        preqQty = pre_req_item.quantity
                    }

                    // CONDITION 1
                    promo_lines.push({
                        include_field: "refcode",
                        include_value: pre_req_item.reference_code,
                        exclude_field: null,
                        exclude_value: null,
                        promo_text: "",
                        include_field_ex: "refcode",
                        include_value_ex: pre_req_item.reference_code,
                        exclude_field_ex: null,
                        exclude_value_ex: null,
                        description: "",
                        original_price: pre_req_item.retail_price.replace(',', ''),
                        group_id: 1,
                        promo_type: "P",
                        condition_type: p_condition_type,
                        status: "A",
                        product_id: pre_req_item.product_id,
                        quantity: preqQty
                    })
                }

                // CONDITION 2
                let prereq_p_text = "(1:E1:0%;)(2:E1:0%;)(3:E1:0%;)"
                let prereq_p_desc = "^1:Less 0%^^2:Less 0%^^3:Less 0%^"

                let rewardTriggerAmount = 0
                if (this.promo.compute_mode !== 'all_with_qty') {
                    rewardTriggerAmount = this.promo.reward_trigger_amount
                }

                promo_lines.push({
                    include_field: "",
                    include_value: "",
                    exclude_field: null,
                    exclude_value: null,
                    promo_text: prereq_p_text,
                    include_field_ex: "",
                    include_value_ex: "",
                    exclude_field_ex: null,
                    exclude_value_ex: null,
                    description: prereq_p_desc,
                    quantity: rewardTriggerAmount,
                    original_price: 0,
                    group_id: 1,
                    promo_type: "P",
                    condition_type: p_condition_type,
                    status: "A"
                })
                //  END - Processing of pre-requisite items //

                //  START - Processing of bonus items //
                // [2.1] Bonus Item Processing
                for (let x = 0; x < this.selectedProductData.length; x++) {
                    let bonus_item = this.selectedProductData[x]

                    promo_lines.push({
                        include_field: "refcode",
                        include_value: bonus_item.reference_code,
                        exclude_field: null,
                        exclude_value: null,
                        promo_text: "",
                        include_field_ex: "refcode",
                        include_value_ex: bonus_item.reference_code,
                        exclude_field_ex: null,
                        exclude_value_ex: null,
                        description: "",
                        quantity: String(bonus_item.quantity).replace(',', ''),
                        original_price: bonus_item.retail_price.replace(',', ''),
                        group_id: 1,
                        promo_type: "B",
                        condition_type: p_condition_type,
                        status: "A",
                        product_id: bonus_item.product_id
                    })
                }
                // [2.2] Discount Processing
                let bonus_p_text = ""
                let bonus_p_desc = ""

                let max_application_gb = this.promo.promo_text.replace("@", "")
                console.log(">> Max Application Check")
                console.log(max_application_gb)
                if (parseInt(max_application_gb) == 0) {
                    max_application_gb = "999"
                }

                const getRoundUpAdd = lineRoundToNearest('create', this.reward.round_to_nearest)

                if (this.promo.reward_type == "2") {
                    bonus_p_text = "E1:L" + this.promo.promo_discount + getRoundUpAdd.text + ";" + this.promo.promo_text
                    bonus_p_desc = "Less " + this.promo.promo_discount + getRoundUpAdd.desc + ", Limit to " + max_application_gb
                } else if (this.promo.reward_type == "1") {
                    bonus_p_text = "E1:" + this.promo.promo_discount + "%" + getRoundUpAdd.text + ";" + this.promo.promo_text
                    bonus_p_desc = "Less " + this.promo.promo_discount + "%" + getRoundUpAdd.desc + ", Limit to " + max_application_gb
                } else {
                    bonus_p_text = "E1:F" + this.promo.promo_discount + getRoundUpAdd.text + ";" + this.promo.promo_text
                    bonus_p_desc = "New Price: " + this.promo.promo_discount + getRoundUpAdd.desc + ", Limit to " + max_application_gb
                }

                promo_lines.push({
                    include_field: "",
                    include_value: "",
                    exclude_field: null,
                    exclude_value: null,
                    promo_text: bonus_p_text,
                    include_field_ex: "",
                    include_value_ex: "",
                    exclude_field_ex: null,
                    exclude_value_ex: null,
                    description: bonus_p_desc,
                    quantity: 1,
                    original_price: 0,
                    group_id: 1,
                    promo_type: "B",
                    condition_type: p_condition_type,
                    status: "A"
                })
                // END - Processing of bonus items //
                }
            }

            // Promo Type = Conditional //
            else if (['8'].includes(this.promo.promo_type)) {
                this.promo.reward_type_desc = "CONDITIONAL|" + this.promo.reward_type
                if (this.promo.reward_trigger_frequency == '' || this.promo.reward_trigger_frequency == null) {
                    this.promo.reward_trigger_frequency = 0
                }
                if (!this.productUploadFileMode) {
                    let x_promo_type = ""
                    let y_promo_type = ""
                    if (this.coupleType == "1") {
                        this.promo.promo_text = "HIGHERLOWER"
                        x_promo_type = "H"
                        y_promo_type = "L"
                    } else {
                        this.promo.promo_text = "FIRSTSECOND"
                        x_promo_type = "F"
                        y_promo_type = "S"
                    }

                    if (this.priotizedDiscountedCriteria == true) {
                        this.promo.promo_text += ";true"
                    }

                for (let s = 0; s < this.selectedProductData.length; s++) {
                    let product = this.selectedProductData[s]
                    let product_value = product.reference_code
                    promo_lines.push({
                        include_field: "refcode",
                        include_value: product_value,
                        exclude_field: "",
                        exclude_value: "",
                        promo_text: "",
                        include_field_ex: "refcode",
                        include_value_ex: product_value,
                        exclude_field_ex: "",
                        exclude_value_ex: "",
                        description: "",
                        quantity: 1,
                        original_price: product.retail_price.replace(',', ''),
                        group_id: 1,
                        promo_type: "B",
                        condition_type: "",
                        status: "A",
                        product_id: product.product_id
                    })
                }

                let x_promo_text = ""
                let x_promo_description = ""
                const XgetRoundUpAdd = lineRoundToNearest('create', this.reward.get_x_lp_round.toString())
                console.log(this.reward.get_x_lp_round)
                console.log(XgetRoundUpAdd)
                let y_promo_text = ""
                let y_promo_description = ""
                const YgetRoundUpAdd = lineRoundToNearest('create', this.reward.get_y_lp_round.toString())
                console.log(this.reward.get_y_lp_round)
                console.log(YgetRoundUpAdd)
                const max_application = 999

                // Handle X record //
                if (this.get_x_type == "LSP") {
                    x_promo_text = '1:E1:' + this.reward.get_x_lp + '%' + XgetRoundUpAdd.text + ";@" + max_application
                    x_promo_description = '1:Less ' + this.reward.get_x_lp + '%,' + XgetRoundUpAdd.desc + ', Limit to ' + max_application
                } else if (this.get_x_type == "LSA") {
                    x_promo_text = '1:E1:L' + this.reward.get_x_la + XgetRoundUpAdd.text + ';@' + max_application
                    x_promo_description = '1:Less ' + this.reward.get_x_la + XgetRoundUpAdd.desc + ', Limit to ' + max_application
                } else {
                    x_promo_text = '1:E1:F' + this.reward.get_x_po + XgetRoundUpAdd.text + ';@' + max_application
                    x_promo_description = '1:New Price ' + this.reward.get_x_po + XgetRoundUpAdd.desc + ', Limit to ' + max_application
                }

                promo_lines.push({
                    include_field: "",
                    include_value: "",
                    exclude_field: "",
                    exclude_value: "",
                    promo_text: x_promo_text,
                    include_field_ex: "",
                    include_value_ex: "",
                    exclude_field_ex: "",
                    exclude_value_ex: "",
                    description: x_promo_description,
                    quantity: 1,
                    original_price: 0,
                    group_id: 1,
                    promo_type: x_promo_type,
                    condition_type: "",
                    status: "A",
                    product_id: -1
                })

                // Handle Y record //
                if (this.get_y_type == "LP") {
                    y_promo_text = '1:E1:' + this.reward.get_y_lp + '%' + YgetRoundUpAdd.text + ";@" + max_application
                    y_promo_description = '1:Less ' + this.reward.get_y_lp + '%,' + YgetRoundUpAdd.desc + ', Limit to ' + max_application
                } else if (this.get_y_type == "LA") {
                    y_promo_text = '1:E1:L' + this.reward.get_y_la + YgetRoundUpAdd.text + ';@' + max_application
                    y_promo_description = '1:Less ' + this.reward.get_y_la + YgetRoundUpAdd.desc + ', Limit to ' + max_application
                } else {
                    y_promo_text = '1:E1:F' + this.reward.get_y_po + YgetRoundUpAdd.text + ';@' + max_application
                    y_promo_description = '1:New Price ' + this.reward.get_y_po + YgetRoundUpAdd.desc + ', Limit to ' + max_application
                }

                promo_lines.push({
                    include_field: "",
                    include_value: "",
                    exclude_field: "",
                    exclude_value: "",
                    promo_text: y_promo_text,
                    include_field_ex: "",
                    include_value_ex: "",
                    exclude_field_ex: "",
                    exclude_value_ex: "",
                    description: y_promo_description,
                    quantity: 1,
                    original_price: 0,
                    group_id: 1,
                    promo_type: y_promo_type,
                    condition_type: "",
                    status: "A",
                    product_id: -1
                })
                }

            }

            // Promo Type = Group Discount //
            else if (['9'].includes(this.promo.promo_type)) {
                this.promo.reward_trigger_frequency = 0
                this.promo.reward_type_desc = "GROUPDISCOUNT|" + this.promo.reward_type
                // START -- Promo Lines Process Saving //

                if (!this.productUploadFileMode) {
                    if (this.max_application_all == 0) {
                        this.max_application_all = 999
                    }

                //All Items
                if (this.include_item == "1") {

                    let promo_text = ''
                    let promo_description = ''


                    promo_lines.push({
                        include_field: "all",
                        include_value: "",
                        exclude_field: "",
                        exclude_value: "",
                        promo_text: promo_text,
                        include_field_ex: "all",
                        include_value_ex: "",
                        exclude_field_ex: "",
                        exclude_value_ex: "",
                        description: promo_description,
                        quantity: "",
                        original_price: "",
                        group_id: "",
                        promo_type: "B",
                        condition_type: "",
                        status: "A",
                        product_id: -1
                    })

                }

                // Supplier
                else if (this.include_item == "4") {

                    let promo_text = ''
                    let promo_description = ''


                    promo_lines.push({
                        include_field: "supplierId",
                        include_value: this.allItem.supplier_id,
                        exclude_field: "",
                        exclude_value: "",
                        promo_text: promo_text,
                        description: promo_description,
                        include_field_ex: "supplierId",
                        include_value_ex: this.allItem.supplier_id,
                        exclude_field_ex: "",
                        exclude_value_ex: "",
                        quantity: "",
                        original_price: "",
                        group_id: "",
                        promo_type: "B",
                        condition_type: "",
                        status: "A",
                        product_id: -1
                    })
                }

                // Brand
                else if (this.include_item == "5") {
                    let brands = this.allItem.brand_id
                    console.log("BRAND ID VALUES")
                    console.log(this.allItem.brand_id)

                    let promo_text = ''
                    let promo_description = ''

                    brands.forEach(b => {
                        promo_lines.push({
                            include_field: "brandId",
                            include_value: b,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: "brandId",
                            include_value_ex: b,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: 1,
                            original_price: "",
                            group_id: 1,
                            promo_type: "B",
                            condition_type: "",
                            status: "A"
                        })
                    })

                }

                // Categories
                else if (this.include_item == "6") {

                    if (this.inputCategory.length > 0) {
                        let resultLength = this.inputCategory.length
                        let category_id = 0
                        let category_type = ""

                        switch (resultLength) {
                            case 5:
                                category_type = "categoryId"
                                category_id = this.inputCategory[4];
                                break;
                            case 4:
                                category_type = "sectionId"
                                category_id = this.inputCategory[3];
                                break;
                            case 3:
                                category_type = "departmentId"
                                category_id = this.inputCategory[2];
                                break;
                            case 2:
                                category_type = "divisionId"
                                category_id = this.inputCategory[1];
                                break;
                            case 1:
                                alert("Select atleast in division level")
                                return
                        }

                        let promo_text = ''
                        let promo_description = ''

                        console.log(">>>>Checker Input Category")
                        console.log(this.inputCategory)

                        let cascader_value = this.inputCategory.toString()

                        promo_lines.push({
                            include_field: category_type,
                            include_value: category_id,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: category_type,
                            include_value_ex: category_id,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: "",
                            original_price: "",
                            group_id: "",
                            promo_type: "B",
                            condition_type: "",
                            status: "A",
                            integration_settings: "[" + cascader_value + "]"
                            // product_id: ""
                        })


                    } else {
                        alert("No Category Selected")
                        return
                    }
                    //Except Selected Items
                }

                // All Items Except
                else if (this.include_item == "2") {

                    if (this.promoExceptions.length > 0) {

                        let promo_text = ''
                        let promo_description = ''

                        console.log("NEW PROMO EXCEPTIONS")
                        console.log(this.promoExceptions)

                        for (let s = 0; s < this.promoExceptions.length; s++) {
                            let exempt = this.promoExceptions[s]

                            let cacscader_value = null
                            if (exempt.exception_type == "ex_supplierId" || exempt.exception_type == "ex_brandId") {
                                cacscader_value = null
                            } else {
                                cacscader_value = "[" + exempt.exception_value_display + "]"
                            }

                            promo_lines.push({
                                include_field: exempt.exception_type,
                                include_field_ex: exempt.exception_type,
                                include_value: exempt.exception_value,
                                include_value_ex: exempt.exception_value,
                                exclude_field: "",
                                exclude_value: "",
                                exclude_field_ex: "",
                                exclude_value_ex: "",
                                promo_text: promo_text,
                                description: promo_description,
                                quantity: "",
                                original_price: "",
                                group_id: "",
                                promo_type: "B",
                                condition_type: "",
                                status: "A",
                                integration_settings: cacscader_value
                            })

                        }
                    } else {
                        alert("No Item Selected")
                        return
                    }

                    console.log("PROMO LINES")
                    console.log(promo_lines)
                }

                // Default
                else if (this.include_item == "7") {


                    console.log("Selected Items...")

                    for (let s = 0; s < this.selectedProductData.length; s++) {
                        let product = this.selectedProductData[s]

                        console.log(">> Product")
                        console.log(product)


                        //let product_value = product.barcode
                        let product_value = product.reference_code
                        if (this.is_ref_code == true) {
                            product_value = product.reference_code
                        }

                        let promo_text = ""
                        let promo_description = ""

                        let max_application = 0
                        if (max_application == 0) {
                            max_application = 1
                        }


                        promo_lines.push({
                            include_field: "refcode",
                            include_value: product_value,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: "refcode",
                            include_value_ex: product_value,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description + '||' + product.name,
                            quantity: max_application,
                            original_price: product.retail_price.replace(',', ''),
                            group_id: 1,
                            promo_type: "B",
                            condition_type: "",
                            status: "A",
                            product_id: product.product_id
                        })



                    }
                }

                // END -- Promo Lines Process Saving //
                }
            }

            //Customer Types - Arvin // 
            if (this.customer_type == 'S' && this.customer_card_type_ids.length > 0) {
                this.promo.card_type_included = this.customer_card_type_ids.toString()
            } else if (this.customer_type == 'S' && this.customer_card_type_ids.length == 0) {
                var cardtypes = this.customerCardTypeOptions.map(function (item) {
                    return item['id'];
                });
                this.promo.card_type_included = cardtypes.toString()
            } else {
                this.promo.card_type_included = this.customer_type
            }

            // Process Payment Type Code
            // this.promo.promo_text = this.payment_type_code

            // if(this.payment_type_ids.length > 0){
            //     promo_conditions.push({
            //         is_exception: false,
            //         condition_type: "PT",
            //         operation: "IN",
            //         array_values: this.payment_type_ids,
            //         pair_no: 0
            //     })
            // }

            //Compare promos

            //Compare promo_lines

            //Compare promo_sites

            this.promo.promo_sites_updated = isUpdatePromoSite
            this.promo.promo_reward_and_condition_updated = this.isUpdatePromoRewardAndCondition
            this.promo.promo_sites = promo_sites
            this.promo.promo_lines = this.normalizePromoLinesForSave(promo_lines)
            this.promo.include_item = this.include_item
            this.promo.discount = this.discount



            const accountId = secureStorage.getItem("accountId");

            if (this.$refs.uploadProductKey.fileList[0] && this.canUploadProduct) {
                let fileResponse = null
                console.log("Should handle s3 uploading")
                this.promo.upload_mode = "1"
                fileResponse = {}
                fileResponse.path = "s3-background-processing"
                promotion_hash.upload_product_path = fileResponse.path;
            }


            // remove coupon computed fields
            const couponKeys = [
                'computed_coupon_base_on',
                'computed_coupon_limit',
                'computed_coupon_print_as_one',
                'computed_trigger_amount',
                'computed_trigger_label',
                'coupon_text_attributes'
            ]

            for (let x = 0; x < couponKeys.length; x++) {
                delete this.promo[couponKeys[x]]
            }


            if (this.promo.promo_type != '5') {
                this.promo.reward_coupon_text = null
            }

            if (this.promo.promo_type == '9') {


                // Add promo text procesisng here //

                let promo_text = ""
                if (this.promo.group_discount_type == '1') {
                    promo_text = 'QR'
                } else if (this.promo.group_discount_type == '2') {
                    promo_text = 'AR'
                } else {
                    promo_text = 'DR'
                }


                let promo_description = ''
                for (const groupLevel of this.groupLevelData) {
                    if (this.promo.group_discount_type == '1') {
                        promo_text += `${groupLevel.qty}:${groupLevel.discount}%,`
                    } else if (this.promo.group_discount_type == '2') {
                        promo_text += `${groupLevel.amount}:${groupLevel.discount}%,`
                    } else {
                        promo_text += `${groupLevel.amount}:${groupLevel.discount},`
                    }
                }
                promo_text = promo_text.slice(0, -1);
                // Round may legitimately be 0 (no rounding). Use an explicit
                // numeric check instead of a truthiness check so that 0 is
                // preserved; fall back to 1 only for blank/null/negative/
                // non-numeric values (unchanged behavior for those cases).
                const _rawRound = this.promo ? this.promo.round : undefined;
                const _parsedRound = Number(_rawRound);
                const round = (_rawRound !== null && _rawRound !== '' && _rawRound !== undefined
                    && Number.isFinite(_parsedRound) && _parsedRound >= 0)
                    ? _parsedRound
                    : 1;
                promo_text = `${promo_text}^${round}`
                this.promo.group_discount_type = null

                delete this.promo.round
                this.promo.promo_text = promo_text
                this.promo.promo_description = promo_description

            }

            // this.promo.status = "A"
            promotion_hash.promo = this.promo;

            console.log("PROMO HASH")
            console.log(promotion_hash)

            let request = []
            if (this.profileId > 0) {
                // console.log(this.promo)
                request = await HTTPRequest.putRequest(this.endPoint + 'promos/' + this.profileId, null, promotion_hash)
            } else {
                request = await HTTPRequest.postRequest(this.endPoint + 'promos', null, promotion_hash)
            }

            if (!this.isPromotionSaveSuccess(request)) {
                this.showPromotionSaveFailure(request)
                this.doneLoading = false
                return false
            }

            if (this.profileId > 0) {
                this.create_action_history("Update")
            } else {
                this.promotionId = request.promo_id
                this.create_action_history("Create")
            }

            // Handling of S3 Uploading
            if (this.$refs.uploadProductKey.fileList[0] && this.canUploadProduct) {
                const uplodingFile = this.$refs.uploadProductKey.fileList[0];
                const s3FileName = `${moment().format('MMDDYYhhmmss')}_promov2_${accountId}_${request.promo_id}_${request.job_id}.csv`
                const myRenamedFile = new File([uplodingFile], s3FileName);

                // uploadModeChecker = this.$refs.uploadProductKey.uploadMode
                // if(uploadModeChecker == "1"){
                console.log("Should upload in s3")
                // 1709782510622_document_62_161893_1_0_8.csv
                let fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'promotionsv2')
                console.log(fileResponse)
                // }
            }
            this.$emit('refreshPage', event, this.profileId > 0 ? 'update' : 'create')
            this.doneLoading = false
        },
        async create_action_history(action) {
            var id = 0
            if (this.profileId) {
                id = this.profileId
            } else {
                id = this.promotionId
            }
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                promotion_id: id,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'promotions_action_histories/', null, actionHistoryPayload)
        },
        replaceDiscountType(value) {
            console.log(value)
            this.levelData = [];
            this.levelDataFilter = [];
            if (value == "1") {
                this.levelRelativeColumns[1].title = "DISCOUNT (%)"
            } else {
                this.levelRelativeColumns[1].title = "DISCOUNT (Amt)"
            }
        },
        replaceDiscount(value) {

            console.log("Value >> " + value)
            console.log("Promo >> ")
            console.log(this.promo)

            this.promo.remark = this.promo.remark || ''

            this.isUpdatePromoRewardAndCondition = true;


            if (this.promo.promo_type == "3") {
                if (value == "1") {
                    this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
                } else {
                    this.reward_type_description = "Buy quantity of item X to item Y for new price, for a discount, or for free (Buy T-Shirt, Get Umbrella for Free)"
                }
            }

            // Item & Pool Discount
            else if (["1", "2"].includes(this.promo.promo_type)) {

                if (this.promo.promo_type == "2") {
                    console.log("PWP")
                    if (value == "1") {
                        this.reward_type_description = "Apply PWP percent discount"
                        this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                        this.selectedInlineProductOptions.columns[4].title = "PERCENT DISCOUNT"
                    } else if (value == "2") {
                        this.reward_type_description = "Apply PWP amount discount"
                        // this.selectedInlineProductOptions.columns[5].title = "MINIMUM AMOUNT"
                        this.selectedInlineProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    } else {
                        this.reward_type_description = "Apply PWP change price discount"
                        // this.selectedInlineProductOptions.columns[5].title = "REQUIRED QUANTITY"
                        this.include_item = "6"
                        this.selectedInlineProductOptions.columns[4].title = "NEW PRICE"
                    }
                } else {
                    console.log("Item & Pool Discount")
                    // PERCENT
                    if (value == "1") {
                        this.reward_type_description = "Apply a discount to an item by percentage (e.g 10%)"
                        this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                    }

                    // AMOUNT DISCOUNT
                    else if (value == '2') {
                        this.reward_type_description = "Apply a discount to an item by amount (e.g P100 off)"
                        this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    }

                    // NEW PRICE
                    else if (value == '3') {
                        this.reward_type_description = "Apply a discount to an item by giving it new price upon purchase"
                        this.selectedProductOptions.columns[4].title = "NEW PRICE"
                    }

                    // RELATIVE
                    else if (value == "4") {
                        this.reward_type_description = "When quantity is greater than or equal to X, price is X"
                        this.levelColumns[0].title = "QTY >="
                        this.levelColumns[1].title = "PRICE IS"
                    }

                    // BUNDLE
                    else if (value == "5") {
                        this.reward_type_description = "For a bundle of X, subtotal is X (e.g for every 5 items, subtotal is P20.00)"
                        this.levelColumns[0].title = "BUNDLE OF"
                        this.levelColumns[1].title = "SUBTOTAL IS"
                    }
                    //  BUY X TAKE X
                    else if (value == "6") {
                        this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
                    }
                }

                // Handle Include Item Options
                if (value > 1) {
                    this.includeItemOptions = [
                        // {key: "1", value: "All Items"},
                        // {key: "2", value: "All Items from a Specific Supplier"},
                        // {key: "3", value: "All Items from a Specific Brand"},
                        // {key: "4", value: "All Items from a Specific Category"},
                        // {key: "5", value: "All Items Except"},
                        { key: "6", value: "Select Specific Items" }
                    ]
                    this.includeItemOptionsKey++;
                    this.include_item = "6"
                } else {
                    this.includeItemOptions = [
                        { key: "1", value: "All Items" },
                        { key: "2", value: "All Items from a Specific Supplier" },
                        { key: "3", value: "All Items from a Specific Brand" },
                        { key: "4", value: "All Items from a Specific Category" },
                        { key: "5", value: "All Items Except" },
                        { key: "6", value: "Select Specific Items" }
                    ]
                    this.includeItemOptionsKey++;
                }

            }

            else if (this.promo.promo_type == "5") {
                if (value == "1") {
                    this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
                    this.coupon_description = "Enter quantity required to activate promo"
                } else {
                    this.reward_type_description = "Coupon will be printed if the transaction meets the amount criteria specified (e.g. For a minimum purchase of P2000, Get 200 Reward Points)"
                    this.coupon_description = "Enter amount required to activate promo"
                }
            }

            else if (this.promo.promo_type == "6") {
                if (value == "1") {
                    this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
                } else if (value == "3") {
                    this.reward_type_description = `Buy target ${(this.PoolOptionKey == "TQ") ? "quantity" : "amount"} get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)`
                } else {
                    this.reward_type_description = "Buy any item on list get any item  (e.g Buy any item on the list, Get Discounted or Free Item on the list)"
                }
                if (value == "3") {
                    this.selectedBuyXGetYProductOptions.columns[4].visible = false
                } else {
                    this.selectedBuyXGetYProductOptions.columns[4].visible = true
                }
            }

            else if (this.promo.promo_type == "7") {

                console.log("PROMO TYPE 7")
                let label_str = ""
                if (value == "1") {
                    label_str = "Group Discount - Less Percent"
                    // this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                } else if (value == '2') {
                    label_str = "Group Discount - Less Amount"
                    // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                } else {
                    label_str = "Group Discount - New Price"
                    // this.selectedProductOptions.columns[4].title = "NEW PRICE"
                }
                this.reward_type_description = label_str
                this.discountLabel = label_str
            }

            else {
                if (value == "1") {
                    this.reward_type_description = "Apply a discount to an item by percentage (e.g 10%)"
                    this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                } else if (value == '2') {
                    this.reward_type_description = "Apply a discount to an item by amount (e.g P100 off)"
                    this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                } else if (value == '4') {
                    this.reward_type_description = "Relative Pricing"
                    // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                } else if (value == '5') {
                    this.reward_type_description = "Bundle Pricing"
                    // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                } else if (value == '6') {
                    this.reward_type_description = "Buy X Take X"
                    // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                }
                else {
                    this.reward_type_description = "Apply a discount to an item by giving it new price upon purchase"
                    this.selectedProductOptions.columns[4].title = "NEW PRICE"
                }
            }
            this.replaceDiscountKey = value
            this.refKey++
        },
        showDrawer() {
            this.typeVisible = true;
        },
        onClose() {
            this.typeVisible = false;
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        async filter(inputValue) {
            if (inputValue.length >= 3) {
                this.categoriesOptions = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view?name=' + inputValue, null);
            }
        },
        sort(data) {
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        async searchSupplier(value) {
            this.fetching = true;

            let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers?name=" + value, null, null)
            if (suppliers != null) {
                this.supplierOptions = suppliers
                this.sort(this.supplierOptions);
            } else {
                this.supplierOptions = []
            }

            this.fetching = false;
        },
        async searchBrand(value) {
            this.fetching = true;

            // Start
            // [Easyday Plus] Searching for brand name is not working under Promotion Management
            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
            // var userBrands = secureStorage.getItem("userBrands") || ""
            let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value + "&userBrands=true", null, null)

            // [Easyday Plus] Searching for brand name is not working under Promotion Management
            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
            // End

            if (brands != null) {
                this.brandOptions = brands
                this.sort(this.brandOptions);
            } else {
                this.brandOptions = []
            }

            this.fetching = false;
        },
        validateForm() {
            this.errors = [];
            this.errors.push(ValidateField.required('Code', this.promo.code));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.promo.code));
            this.errors.push(ValidateField.charMinAndMax('Code', this.promo.code, 0, 30));
            this.errors.push(ValidateField.required('Name', this.promo.name));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.promo.name));
            this.errors.push(ValidateField.charMinAndMax('Name', this.promo.name, 0, 50));
            // this.errors.push(ValidateField.required('Code', this.inputCode));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
            // this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
            // this.errors.push(ValidateField.required('Name', this.inputName));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
            // this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));
            this.errors = this._.compact(this.errors); this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            // return this.errors.length;
        },
        checkImportJobBeforeSaving: async function () {
            const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
            if (!importJob || importJob.length == 0) {
                return false;
            }

            const hasUploadingFile = this.$refs.uploadProductKey.fileList[0];

            const errMsg = hasUploadingFile ? "Can't upload another file when there's an Ongoing upload of Products" : "Can't activate a promotion with Ongoing upload of Products";

            if (importJob[0].formatted_status == 'Ongoing') {
                this.$notification['warning']({
                    message: 'Ongoing Upload',
                    duration: 0,
                    description: `${errMsg} [PromotionUploadProduct-${this.profileId}]. Click 'View Jobs' to review uploading process.`,
                    btn: h => {
                        return h(
                            'base-button',
                            {
                                props: {
                                    type: 'warning',
                                    class: 'btn-sm',
                                },
                                on: {
                                    click: () => component_x.$router.push("/jobs"),
                                },
                            },
                            'View Jobs',
                        );
                    },
                });

                return true;
            }

            return false;
        },
        createTimeMoment(time) {
            const [hour, minute] = time.split(':').map(value => Number(value));
            return moment().startOf('day').hour(hour).minute(minute).second(0);
        },
        parsePromoTime(value, fallback) {
            if (!value) {
                return fallback === 'end' ? this.createTimeMoment('23:59') : this.createTimeMoment('00:00');
            }

            const rawValue = String(value);
            const literalTime = rawValue.match(/T(\d{1,2}):(\d{2})/) || rawValue.match(/^(\d{1,2}):(\d{2})/);
            if (literalTime) {
                return this.createTimeMoment(`${literalTime[1]}:${literalTime[2]}`);
            }

            const parsedTime = moment(rawValue, ['h:mm A', 'hh:mm A', 'HH:mm', 'HH:mm:ss'], true);
            if (parsedTime.isValid()) {
                return this.createTimeMoment(parsedTime.format('HH:mm'));
            }

            return fallback === 'end' ? this.createTimeMoment('23:59') : this.createTimeMoment('00:00');
        },
        normalizeSiteId(value) {
            const normalizedValue = String(value == null ? '' : value).trim();
            if (!/^\d+$/.test(normalizedValue)) {
                return null;
            }

            return Number(normalizedValue);
        },
        getSelectedSiteIds() {
            return this._.uniq((this.selectedRowKeys || [])
                .map(key => this.normalizeSiteId(key))
                .filter(siteId => siteId !== null));
        },
        async getLocationTreeData() {
            // component_x.productLocationData = [];
            var apiData = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_tree_sites", null);

            const nodesByKey = {};
            const roots = [];

            apiData.forEach(site => {
                const key = String(site.key);
                nodesByKey[key] = {
                    ...site,
                    key: this.normalizeSiteId(site.key) || site.key,
                    title: site.code ? `${site.code} - ${site.title}` : site.title,
                    children: []
                };
            });

            apiData.forEach(site => {
                const parentKey = site.parent_id == null ? null : String(site.parent_id);
                const node = nodesByKey[String(site.key)];

                if (!parentKey) {
                    if (!roots.includes(node)) {
                        roots.push(node);
                    }
                    return;
                }

                if (!nodesByKey[parentKey]) {
                    nodesByKey[parentKey] = {
                        id: parentKey,
                        key: parentKey,
                        title: site.location || 'Sites',
                        children: []
                    };
                    if (!roots.includes(nodesByKey[parentKey])) {
                        roots.push(nodesByKey[parentKey]);
                    }
                }

                nodesByKey[parentKey].children.push(node);
            });

            Object.values(nodesByKey).forEach(node => {
                node.children.sort((a, b) => a.title.localeCompare(b.title));
            });

            const removeKeyAndRenameToID = (object, deleteKey) => {
                // if object
                // delete object[deleteKey];
                if (object["key"] != null && !String(object["key"]).includes("L", 0)) {
                    object["key"] = parseInt(object["key"]);
                }

                Object.values(object).forEach(val => {
                    if (val === null || typeof val !== 'object') return;
                    removeKeyAndRenameToID(val, deleteKey);
                });
            };

            this.productLocationData = roots;
            removeKeyAndRenameToID(this.productLocationData, 'key');

            // sort so that unspecified first
            this.productLocationData.sort((a, b) =>
                a.title < b.title ? -1 : Number(a.title > b.title)
            );

            // console.log(this.productData)
            // end location tagging convert children and parent || tree data for site products
            this.filteredLocationData = [...this.productLocationData];
        },
        processSiteCodesInput() {
            // split the input by commas and trim whitespace
            this.notifMessage = [];
            if (this.siteCodesInput.length == 0) {
                this.notifMessage.push('No inputed site code!');
                this.promoActionNotification('Opps...', 'error');
                return
            }
            const siteCodes = this.siteCodesInput.split(',').map(code => code.trim());
            const newSelectedRowKeys = [...this.selectedRowKeys];
            this.notifMessage = [];
            this.selectedSites = [];

            console.log("haha: ", siteCodes);

            // iterate over the site codes and find corresponding nodes
            siteCodes.forEach(siteCode => {
                const node = this.findNodeBySiteCode(this.productLocationData, siteCode);
                if (node) {
                    // valid site codes
                    if (!newSelectedRowKeys.map(key => String(key)).includes(String(node.key))) {
                        console.log("node: ", node);
                        // add the node's key to selectedRowKeys if not already present
                        newSelectedRowKeys.push(node.key);
                    }
                    this.selectedSites.push(node); // store selected site
                } else {
                    // invalid site codes - show validation error notif message
                    this.notifMessage.push(`Site code "${siteCode}" does not exist.`);
                }
            });

            if (this.notifMessage.length) {
                this.promoActionNotification('Invalid site codes', 'error');
            } else {
                this.promoActionNotification('Site codes added', 'success');
                this.isModalVisible = true;
            }

            // update selectedRowKeys to reflect the new valid site codes
            this.selectedRowKeys = newSelectedRowKeys;

            // use $nextTick for DOM updates
            this.$nextTick(() => {
                // force update to ensure DOM is updated
                this.$forceUpdate();
            });
        },
        handleOk_() {
            this.isModalVisible = false;
        },
        showSelectedSites() {
            this.selectedSites = [];
            const selectedKeys = (this.selectedRowKeys || []).map(key => String(key));
            const collectSelectedSites = (nodes) => {
                nodes.forEach(node => {
                    if (selectedKeys.includes(String(node.key))) {
                        this.selectedSites.push(node);
                    }
                    if (node.children) {
                        collectSelectedSites(node.children);
                    }
                });
            };
            collectSelectedSites(this.productLocationData);
            this.isModalVisible = true;
        },
        clearSiteCodes() {
            // clear all selected data
            this.siteCodesInput = ''; // for input
            this.selectedRowKeys = []; // selected keys
            this.searchQuery = ''; // for search
            this.filteredLocationData = this.productLocationData; // reset to original tree data

            // use $nextTick for DOM updates
            this.$nextTick(() => {
                // force update to ensure DOM is updated
                this.$forceUpdate();
            });
        },
        // find a node by site code
        findNodeBySiteCode(data, siteCode) {
            let foundNode = null;
            for (const node of data) {
                if (node.title.startsWith(siteCode + ' -')) {
                    foundNode = node;
                    break;
                }
                if (node.children && node.children.length > 0) {
                    foundNode = this.findNodeBySiteCode(node.children, siteCode);
                    if (foundNode) break;
                }
            }
            return foundNode;
        },
        filterSites() {
            const query = (this.searchQuery || '').toLowerCase().trim();

            this.productLocationData = this.applySiteTreeVisibility(this.productLocationData, query);
            this.filteredLocationData = this.productLocationData;
            this.hasSiteSearchResults = !query || this.siteTreeHasVisibleNode(this.productLocationData);
        },
        applySiteTreeVisibility(data, query, ancestorMatches = false) {
            return data.map(item => {
                const selfMatches = !query || [
                    item.id,
                    item.key,
                    item.code,
                    item.title
                ].some(value => String(value || '').toLowerCase().includes(query));
                const matchesQuery = ancestorMatches || selfMatches;
                const children = item.children ? this.applySiteTreeVisibility(item.children, query, matchesQuery) : undefined;
                const hasVisibleChild = children && children.some(child => !child.style || child.style.display !== 'none');
                const visible = matchesQuery || hasVisibleChild;

                return {
                    ...item,
                    children,
                    style: visible ? {} : { display: 'none' }
                };
            });
        },
        siteTreeHasVisibleNode(data) {
            return data.some(item => {
                if (!item.style || item.style.display !== 'none') {
                    return true;
                }

                return item.children && this.siteTreeHasVisibleNode(item.children);
            });
        },
        onCheckSiteId(selectedRowKeys) {
            this.selectedRowKeys = Array.isArray(selectedRowKeys)
                ? selectedRowKeys
                : ((selectedRowKeys && Array.isArray(selectedRowKeys.checked)) ? selectedRowKeys.checked : []);
        },
        getNotificationStyle(type) { // helper function for notification styles
            return {
                success: {
                    color: 'rgba(0, 0, 0, 0.65)',
                    border: '1px solid #b7eb8f',
                    backgroundColor: '#f6ffed'
                },
                warning: {
                    color: 'rgba(0, 0, 0, 0.65)',
                    border: '1px solid #ffe58f',
                    backgroundColor: '#fffbe6'
                },
                error: {
                    color: 'rgba(0, 0, 0, 0.65)',
                    border: '1px solid #ffa39e',
                    backgroundColor: '#fff1f0'
                },
                info: {
                    color: 'rgba(0, 0, 0, 0.65)',
                    border: '1px solid #91d5ff',
                    backgroundColor: '#e6f7ff'
                }
            }[type];
        },
        promoActionNotification(action, type) {
            if (type === 'success') {
                this.$notification[type]({
                    message: this._.startCase(action) + ' action success',
                    style: this.getNotificationStyle(type)
                });
            } else if (type === 'error') {
                this.$notification[type]({
                    message: this._.startCase(action) + ' action failed',
                    description: () => {
                        return <ul class='m-0 p-0'>
                            {this.notifMessage.map((value, index) => {
                                return <li key={index}>{value}</li>;
                            })}
                        </ul>;
                    },
                    style: this.getNotificationStyle(type)
                });
            }
        },
        checkImportJobs: async function () {
            //Check if with ongoing jobs
            const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
            if (importJob != undefined && importJob.length > 0) {
                if (importJob[0].formatted_status == 'Ongoing') {
                    this.$notification['success']({
                        message: 'Ongoing Upload',
                        duration: 0,
                        description: "There's an ongoing upload of CSV file for this Promotion. Click 'View Jobs' to review.",
                        btn: h => {
                            return h(
                                'base-button',
                                {
                                    props: {
                                        type: 'success',
                                        class: 'btn-sm',
                                    },
                                    on: {
                                        click: () => component_x.$router.push("/jobs"),
                                    },
                                },
                                'View Jobs',
                            );
                        },
                    });
                } else if (importJob[0].formatted_status == 'With errors') {
                    this.$notification['warning']({
                        message: 'Upload Error',
                        duration: 0,
                        description: `CSV file uploaded with errors [PromotionUploadProduct-${this.profileId}] but you can ignore it and continue processing the promotion. Click 'View Jobs' button to review.`,
                        btn: h => {
                            return h(
                                'base-button',
                                {
                                    props: {
                                        type: 'warning',
                                        class: 'btn-sm',
                                    },
                                    on: {
                                        click: () => component_x.$router.push("/jobs"),
                                    },
                                },
                                'View Jobs',
                            );
                        },
                    });
                }
            }
        },
        async checkItemIfMatrix(data, promo_value) {
            if (data.product_type == "M") {
                var child_items = await HTTPRequest.getRequest(this.endPoint + 'products?search_type=P&matrix_parent_id=' + data.id, null);
                for (let i = 0; i < child_items.total; i++) {
                    var value = child_items.data[i]
                    if (this.selectedProd.includes(value.id) == false) {
                        this.selectedProd.push(value.id)
                        let button = document.getElementById("add_" + value.id);
                        this.selectedProductData.push({
                            product_id: value.id,
                            name: value.name,
                            retail_price: value.retail_price.replace(',', ''),
                            promo_value: promo_value,
                            barcode: value.barcode,
                            reference_code: value.reference_code,
                            required_value: 1,
                            round_to_nearest: this.promo.promo_type == '5' ? '2' : undefined,
                            stock_no: value.stock_no
                        })
                        if (button != undefined && button != null) {
                            button.className = "btn btn-sm btn-default"
                            button.innerHTML = "UNDO"
                        }
                    }
                }
            }
        },
        addDeleteButton(cell) {
            if (this.viewOnly) { return null; }
            let product_id = cell.getRow().getData().product_id
            let button = '<button id="' + product_id + '" class="btn btn-sm btn-danger">Delete</button>';
            return button
        },
        searchItemListProduct: function () {
            const tabulatorComponent = this.$refs.addedProductTabulator;
            const tabulatorInstance = tabulatorComponent && tabulatorComponent.getInstance
                ? tabulatorComponent.getInstance()
                : null;

            if (!tabulatorInstance) {
                return;
            }

            const searchText = String(this.searchText1 || '').trim();
            if (searchText === '') {
                tabulatorInstance.clearFilter();
                return;
            }

            tabulatorInstance.setFilter((data, params) => {
                return this.itemListProductMatchesSearch(params.searchText, data);
            }, { searchText });
        },
        syncSelectedProductEdit(cell) {
            const rowData = cell && cell.getRow ? cell.getRow().getData() : cell && cell._cell && cell._cell.row
                ? cell._cell.row.data
                : null;

            if (!rowData || rowData.product_id === undefined || rowData.product_id === null) {
                return;
            }

            const productIndex = this.selectedProductData.findIndex(product => {
                return String(product.product_id) === String(rowData.product_id);
            });

            if (productIndex < 0) {
                return;
            }

            this.$set(this.selectedProductData, productIndex, {
                ...this.selectedProductData[productIndex],
                ...rowData
            });

            const tempIndex = this.tempItemListData.findIndex(product => {
                return String(product.product_id) === String(rowData.product_id);
            });

            if (tempIndex >= 0) {
                this.$set(this.tempItemListData, tempIndex, {
                    ...this.tempItemListData[tempIndex],
                    ...rowData
                });
            }

            this.isUpdatePromoRewardAndCondition = true;
        },
        updateExceptions(value) {
            this.promoExceptions = [...this.promoExceptions, ...value]
            this.promoExceptionKey++;
            this.togglePromoExceptionsDrawer(false)
        },
        deleteException(record) {
            console.log("Should delete record...")
            let checker = this.promoExceptions.findIndex(element => (element["exception_type"] === record["exception_type"] && element["exception_value"] === record["exception_value"]));
            if (checker >= 0)
                this.promoExceptions.splice(checker, 1);
        },
        itemListProductMatchesSearch(inputValue, item) {
            const value = item && item[this.filterField1] !== undefined && item[this.filterField1] !== null
                ? item[this.filterField1]
                : '';

            return String(value).toLowerCase().indexOf(String(inputValue || '').toLowerCase()) != -1;
        },
        filterItemList(inputValue, path) {
            return path.filter((item) => {
                return this.itemListProductMatchesSearch(inputValue, item);
            });

        },
        selectProductAction: function (e, cell) {
            this.isUpdatePromoRewardAndCondition = true
            if (e.target.id == '') { return; }
            const index = this.selectedProd.indexOf(parseInt(e.target.id));
            const dataSource = [...this.selectedProductData];
            this.selectedProductData = dataSource.filter(item => item.product_id !== e.target.id);
            if (index > -1) {
                cell.getRow().delete();
                this.selectedProd.splice(index, 1);
                this.tempItemListData.splice(index, 1);
                this.selectedProductData.splice(index, 1);
            }
        },
        DeleteAll: function () {
            const tabulatorInstance = this.$refs.addedProductTabulator.getInstance()
            if (tabulatorInstance) {
                var selectedRows = tabulatorInstance.getSelectedRows()
                var selectedData = tabulatorInstance.getSelectedData()
                for (var i = 0; i < selectedRows.length; i++) {
                    const index = this.selectedProd.indexOf(parseInt(selectedData[i].product_id));
                    if (index > -1) {
                        this.selectedProductData.splice(index, 1);
                        this.selectedProd.splice(index, 1);
                        this.tempItemListData.splice(index, 1);
                        selectedRows[i].delete();
                    }
                }
            }
        },
    }
}
</script>

<style scoped>
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
    overflow: hidden;
}

.promotion-wizard-shell {
    padding-bottom: 72px;
}

.promotion-form-steps {
    margin-bottom: 12px;
}

.promotion-summary-strip {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
    margin: 16px 0 24px;
}

.promotion-summary-chip {
    border: 1px solid #d9e2ec;
    border-radius: 12px;
    padding: 12px 14px;
    background: #f8fafc;
}

.promotion-summary-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b7785;
    margin-bottom: 4px;
}

.promotion-summary-errors {
    margin: -10px 0 20px;
}

.promotion-summary-error {
    color: #b42318;
    font-size: 13px;
    margin-bottom: 4px;
}

.promotion-select-items-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.promotion-item-selector-shell {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 16px;
    background: #fff;
}

.promotion-item-selector-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.promotion-item-inline-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.promotion-item-drawer-copy {
    color: #6c757d;
    margin-bottom: 12px;
}

.promotion-inline-hint {
    font-size: 13px;
    margin-top: 8px;
}

.promotion-inline-error {
    color: #b42318;
}

.promotion-empty-state {
    border: 1px dashed #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    color: #64748b;
    padding: 12px 14px;
    margin-top: 12px;
}

.ant-steps-item-process .ant-steps-item-icon {
    background: #65CB8F;
    border: #65CB8F;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    white-space: nowrap;
    max-width: 100%;
}

.ant-steps-item-finish .ant-steps-item-icon {
    border-color: #AFB5BC;
    background-color: #fff;
}

.ant-steps-item-finish>.ant-steps-item-content>.ant-steps-item-title:after {
    background-color: #AFB5BC;
}

.numberCircle {
    display: inline-block;
    border-radius: 50%;
    border: 2px solid;
    font-size: 18px;
    background: #65CB8F;
    border: #65CB8F;
    color: #ffffff;
}

.numberCircle:before,
.numberCircle:after {
    content: '\200B';
    display: inline-block;
    line-height: 0px;
    padding-top: 50%;
    padding-bottom: 50%;
}

.numberCircle:before {
    padding-left: 8px;
}

.numberCircle:after {
    padding-right: 8px;
}

.filter-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
}

.ellisis-cont .dropdown-menu .dropdown-item {
    cursor: pointer;
}
</style>
